var map = {
	"./api/apiContstants": [
		68660,
		9
	],
	"./api/apiContstants.js": [
		68660,
		9
	],
	"./api/apiDataHelpers": [
		45689,
		9
	],
	"./api/apiDataHelpers.js": [
		45689,
		9
	],
	"./api/apiHelperFunctions": [
		53123,
		9,
		53123
	],
	"./api/apiHelperFunctions.js": [
		53123,
		9,
		53123
	],
	"./api/apiUtils": [
		14684,
		9
	],
	"./api/apiUtils.js": [
		14684,
		9
	],
	"./api/firebase": [
		35845,
		9,
		64972,
		39596
	],
	"./api/firebase.ts": [
		35845,
		9,
		64972,
		39596
	],
	"./application-insights/TelemetryProvider-component": [
		13250,
		9
	],
	"./application-insights/TelemetryProvider-component.jsx": [
		13250,
		9
	],
	"./application-insights/TelemetryService": [
		22581,
		9
	],
	"./application-insights/TelemetryService.js": [
		22581,
		9
	],
	"./components/common": [
		49736,
		9
	],
	"./components/common/": [
		49736,
		9
	],
	"./components/common/Animations": [
		94890,
		9
	],
	"./components/common/Animations/": [
		94890,
		9
	],
	"./components/common/Animations/index": [
		94890,
		9
	],
	"./components/common/Animations/index.tsx": [
		94890,
		9
	],
	"./components/common/CharacterCounter": [
		11808,
		9,
		11808
	],
	"./components/common/CharacterCounter/": [
		11808,
		9,
		11808
	],
	"./components/common/CharacterCounter/index": [
		11808,
		9,
		11808
	],
	"./components/common/CharacterCounter/index.tsx": [
		11808,
		9,
		11808
	],
	"./components/common/CharacterCounter/styles": [
		16566,
		9,
		16566
	],
	"./components/common/CharacterCounter/styles.ts": [
		16566,
		9,
		16566
	],
	"./components/common/CommonButton": [
		83575,
		9,
		83575
	],
	"./components/common/CommonButton/": [
		83575,
		9,
		83575
	],
	"./components/common/CommonButton/hocs": [
		75229,
		9,
		75229
	],
	"./components/common/CommonButton/hocs.tsx": [
		75229,
		9,
		75229
	],
	"./components/common/CommonButton/index": [
		83575,
		9,
		83575
	],
	"./components/common/CommonButton/index.tsx": [
		83575,
		9,
		83575
	],
	"./components/common/CommonButton/styles": [
		36130,
		9,
		36130
	],
	"./components/common/CommonButton/styles.ts": [
		36130,
		9,
		36130
	],
	"./components/common/CommonButton/types": [
		68826,
		9,
		68826
	],
	"./components/common/CommonButton/types.ts": [
		68826,
		9,
		68826
	],
	"./components/common/CommonButton/utils": [
		20124,
		9,
		20124
	],
	"./components/common/CommonButton/utils.tsx": [
		20124,
		9,
		20124
	],
	"./components/common/ConfirmEmail": [
		809,
		9
	],
	"./components/common/ConfirmEmail/": [
		809,
		9
	],
	"./components/common/ConfirmEmail/index": [
		809,
		9
	],
	"./components/common/ConfirmEmail/index.tsx": [
		809,
		9
	],
	"./components/common/CookieNotice": [
		78936,
		9,
		78936
	],
	"./components/common/CookieNotice/": [
		78936,
		9,
		78936
	],
	"./components/common/CookieNotice/index": [
		78936,
		9,
		78936
	],
	"./components/common/CookieNotice/index.tsx": [
		78936,
		9,
		78936
	],
	"./components/common/CookieNotice/styles": [
		38348,
		9,
		38348
	],
	"./components/common/CookieNotice/styles.ts": [
		38348,
		9,
		38348
	],
	"./components/common/CopyToClipboard": [
		710,
		9,
		710
	],
	"./components/common/CopyToClipboard/": [
		710,
		9,
		710
	],
	"./components/common/CopyToClipboard/index": [
		710,
		9,
		710
	],
	"./components/common/CopyToClipboard/index.tsx": [
		710,
		9,
		710
	],
	"./components/common/Disclaimer/Disclaimer-component": [
		26426,
		9,
		26426
	],
	"./components/common/Disclaimer/Disclaimer-component.tsx": [
		26426,
		9,
		26426
	],
	"./components/common/Disclaimer/styles": [
		31942,
		9,
		31942
	],
	"./components/common/Disclaimer/styles.ts": [
		31942,
		9,
		31942
	],
	"./components/common/DividerWithText": [
		76191,
		9,
		76191
	],
	"./components/common/DividerWithText/": [
		76191,
		9,
		76191
	],
	"./components/common/DividerWithText/index": [
		76191,
		9,
		76191
	],
	"./components/common/DividerWithText/index.tsx": [
		76191,
		9,
		76191
	],
	"./components/common/DividerWithText/styles": [
		50652,
		9,
		50652
	],
	"./components/common/DividerWithText/styles.ts": [
		50652,
		9,
		50652
	],
	"./components/common/GoogleAnalytics": [
		87083,
		9
	],
	"./components/common/GoogleAnalytics/": [
		87083,
		9
	],
	"./components/common/GoogleAnalytics/index": [
		87083,
		9
	],
	"./components/common/GoogleAnalytics/index.tsx": [
		87083,
		9
	],
	"./components/common/GoogleAnalytics/utils": [
		5600,
		9
	],
	"./components/common/GoogleAnalytics/utils.ts": [
		5600,
		9
	],
	"./components/common/InfoTooltip": [
		50811,
		9,
		50811
	],
	"./components/common/InfoTooltip/": [
		50811,
		9,
		50811
	],
	"./components/common/InfoTooltip/InfoTooltip.stories": [
		18652,
		9,
		18652
	],
	"./components/common/InfoTooltip/InfoTooltip.stories.tsx": [
		18652,
		9,
		18652
	],
	"./components/common/InfoTooltip/index": [
		50811,
		9,
		50811
	],
	"./components/common/InfoTooltip/index.tsx": [
		50811,
		9,
		50811
	],
	"./components/common/LabelChangeInput": [
		74453,
		9,
		74453
	],
	"./components/common/LabelChangeInput/": [
		74453,
		9,
		74453
	],
	"./components/common/LabelChangeInput/index": [
		74453,
		9,
		74453
	],
	"./components/common/LabelChangeInput/index.tsx": [
		74453,
		9,
		74453
	],
	"./components/common/LabelChangeInput/styles": [
		86829,
		9,
		86829
	],
	"./components/common/LabelChangeInput/styles.ts": [
		86829,
		9,
		86829
	],
	"./components/common/Link": [
		3383,
		9
	],
	"./components/common/Link/": [
		3383,
		9
	],
	"./components/common/Link/index": [
		3383,
		9
	],
	"./components/common/Link/index.tsx": [
		3383,
		9
	],
	"./components/common/Lists/AvailableAssestsList": [
		54362,
		9,
		54362
	],
	"./components/common/Lists/AvailableAssestsList.tsx": [
		54362,
		9,
		54362
	],
	"./components/common/Lists/PasswordHints": [
		42993,
		9,
		42993
	],
	"./components/common/Lists/PasswordHints.tsx": [
		42993,
		9,
		42993
	],
	"./components/common/Lists/styles": [
		77515,
		9,
		77515
	],
	"./components/common/Lists/styles.ts": [
		77515,
		9,
		77515
	],
	"./components/common/Modal/FixedHeader": [
		50707,
		9
	],
	"./components/common/Modal/FixedHeader/": [
		50707,
		9
	],
	"./components/common/Modal/FixedHeader/index": [
		50707,
		9
	],
	"./components/common/Modal/FixedHeader/index.tsx": [
		50707,
		9
	],
	"./components/common/NumberInput": [
		5500,
		9,
		5500
	],
	"./components/common/NumberInput/": [
		5500,
		9,
		5500
	],
	"./components/common/NumberInput/index": [
		5500,
		9,
		5500
	],
	"./components/common/NumberInput/index.tsx": [
		5500,
		9,
		5500
	],
	"./components/common/PathHandlerModal": [
		5099,
		9,
		5099
	],
	"./components/common/PathHandlerModal/": [
		5099,
		9,
		5099
	],
	"./components/common/PathHandlerModal/components/CompanyPaymentByCard": [
		50827,
		9,
		50827
	],
	"./components/common/PathHandlerModal/components/CompanyPaymentByCard.tsx": [
		50827,
		9,
		50827
	],
	"./components/common/PathHandlerModal/components/CompanyPaymentByOnlineBank": [
		17667,
		9,
		17667
	],
	"./components/common/PathHandlerModal/components/CompanyPaymentByOnlineBank.tsx": [
		17667,
		9,
		17667
	],
	"./components/common/PathHandlerModal/components/DepositByCard": [
		76925,
		9,
		76925
	],
	"./components/common/PathHandlerModal/components/DepositByCard.tsx": [
		76925,
		9,
		76925
	],
	"./components/common/PathHandlerModal/components/DepositByOnlineBank": [
		72227,
		9,
		72227
	],
	"./components/common/PathHandlerModal/components/DepositByOnlineBank.tsx": [
		72227,
		9,
		72227
	],
	"./components/common/PathHandlerModal/components/Failure": [
		64235,
		9,
		64235
	],
	"./components/common/PathHandlerModal/components/Failure.tsx": [
		64235,
		9,
		64235
	],
	"./components/common/PathHandlerModal/components/Success": [
		63677,
		9,
		63677
	],
	"./components/common/PathHandlerModal/components/Success.tsx": [
		63677,
		9,
		63677
	],
	"./components/common/PathHandlerModal/index": [
		5099,
		9,
		5099
	],
	"./components/common/PathHandlerModal/index.tsx": [
		5099,
		9,
		5099
	],
	"./components/common/PathHandlerModal/interface": [
		61224,
		9,
		61224
	],
	"./components/common/PathHandlerModal/interface.ts": [
		61224,
		9,
		61224
	],
	"./components/common/PlaygroundNotice": [
		43690,
		9,
		43690
	],
	"./components/common/PlaygroundNotice/": [
		43690,
		9,
		43690
	],
	"./components/common/PlaygroundNotice/index": [
		43690,
		9,
		43690
	],
	"./components/common/PlaygroundNotice/index.tsx": [
		43690,
		9,
		43690
	],
	"./components/common/PlaygroundNotice/styles": [
		72766,
		9,
		72766
	],
	"./components/common/PlaygroundNotice/styles.ts": [
		72766,
		9,
		72766
	],
	"./components/common/ScrollToTop": [
		52817,
		9
	],
	"./components/common/ScrollToTop/": [
		52817,
		9
	],
	"./components/common/ScrollToTop/index": [
		52817,
		9
	],
	"./components/common/ScrollToTop/index.tsx": [
		52817,
		9
	],
	"./components/common/Select": [
		52134,
		9,
		52134
	],
	"./components/common/Select/": [
		52134,
		9,
		52134
	],
	"./components/common/Select/Country": [
		47819,
		9,
		12136,
		95399,
		47819
	],
	"./components/common/Select/Country.jsx": [
		47819,
		9,
		12136,
		95399,
		47819
	],
	"./components/common/Select/Filter": [
		92068,
		9,
		12136,
		95399,
		92068
	],
	"./components/common/Select/Filter.jsx": [
		92068,
		9,
		12136,
		95399,
		92068
	],
	"./components/common/Select/index": [
		52134,
		9,
		52134
	],
	"./components/common/Select/index.tsx": [
		52134,
		9,
		52134
	],
	"./components/common/Select/utils": [
		18459,
		9,
		18459
	],
	"./components/common/Select/utils.ts": [
		18459,
		9,
		18459
	],
	"./components/common/SelectDropDown": [
		54761,
		9,
		54761
	],
	"./components/common/SelectDropDown/": [
		54761,
		9,
		54761
	],
	"./components/common/SelectDropDown/index": [
		54761,
		9,
		54761
	],
	"./components/common/SelectDropDown/index.tsx": [
		54761,
		9,
		54761
	],
	"./components/common/SelectWithCheckboxes/SelectWithCheckboxes": [
		17180,
		9,
		95399,
		17180
	],
	"./components/common/SelectWithCheckboxes/SelectWithCheckboxes.jsx": [
		17180,
		9,
		95399,
		17180
	],
	"./components/common/SocialAuthenticationButtons": [
		4268,
		9,
		64972,
		72952
	],
	"./components/common/SocialAuthenticationButtons/": [
		4268,
		9,
		64972,
		72952
	],
	"./components/common/SocialAuthenticationButtons/components/AppleAuthenticationButton": [
		16029,
		9,
		64972,
		20032
	],
	"./components/common/SocialAuthenticationButtons/components/AppleAuthenticationButton.tsx": [
		16029,
		9,
		64972,
		20032
	],
	"./components/common/SocialAuthenticationButtons/components/GoogleAuthenticationButton": [
		47027,
		9,
		64972,
		7170
	],
	"./components/common/SocialAuthenticationButtons/components/GoogleAuthenticationButton.tsx": [
		47027,
		9,
		64972,
		7170
	],
	"./components/common/SocialAuthenticationButtons/index": [
		4268,
		9,
		64972,
		72952
	],
	"./components/common/SocialAuthenticationButtons/index.ts": [
		4268,
		9,
		64972,
		72952
	],
	"./components/common/SocialAuthenticationButtons/socialAuthentication.interface": [
		62496,
		9,
		62496
	],
	"./components/common/SocialAuthenticationButtons/socialAuthentication.interface.ts": [
		62496,
		9,
		62496
	],
	"./components/common/SocialAuthenticationButtons/utils/AppleIcon": [
		58002,
		9,
		58002
	],
	"./components/common/SocialAuthenticationButtons/utils/AppleIcon.tsx": [
		58002,
		9,
		58002
	],
	"./components/common/SocialAuthenticationButtons/utils/GoogleIcon": [
		65264,
		9,
		65264
	],
	"./components/common/SocialAuthenticationButtons/utils/GoogleIcon.tsx": [
		65264,
		9,
		65264
	],
	"./components/common/SocialAuthenticationButtons/utils/authenticationHelpers": [
		19303,
		9,
		19303
	],
	"./components/common/SocialAuthenticationButtons/utils/authenticationHelpers.ts": [
		19303,
		9,
		19303
	],
	"./components/common/SocialAuthenticationButtons/utils/styles": [
		10715,
		9,
		10715
	],
	"./components/common/SocialAuthenticationButtons/utils/styles.ts": [
		10715,
		9,
		10715
	],
	"./components/common/Styles": [
		25928,
		9
	],
	"./components/common/Styles/": [
		25928,
		9
	],
	"./components/common/Styles/index": [
		25928,
		9
	],
	"./components/common/Styles/index.tsx": [
		25928,
		9
	],
	"./components/common/Switch": [
		40527,
		9,
		40527
	],
	"./components/common/Switch/": [
		40527,
		9,
		40527
	],
	"./components/common/Switch/index": [
		40527,
		9,
		40527
	],
	"./components/common/Switch/index.tsx": [
		40527,
		9,
		40527
	],
	"./components/common/Switch/styles": [
		5351,
		9,
		5351
	],
	"./components/common/Switch/styles.ts": [
		5351,
		9,
		5351
	],
	"./components/common/TabPanel": [
		67562,
		9,
		67562
	],
	"./components/common/TabPanel/": [
		67562,
		9,
		67562
	],
	"./components/common/TabPanel/index": [
		67562,
		9,
		67562
	],
	"./components/common/TabPanel/index.tsx": [
		67562,
		9,
		67562
	],
	"./components/common/WhitelabelThemeWrapper": [
		83658,
		9,
		83658
	],
	"./components/common/WhitelabelThemeWrapper/": [
		83658,
		9,
		83658
	],
	"./components/common/WhitelabelThemeWrapper/index": [
		83658,
		9,
		83658
	],
	"./components/common/WhitelabelThemeWrapper/index.tsx": [
		83658,
		9,
		83658
	],
	"./components/common/icons/TransactionStatusMark": [
		56014,
		9,
		56014
	],
	"./components/common/icons/TransactionStatusMark.tsx": [
		56014,
		9,
		56014
	],
	"./components/common/icons/TransactionTypeIcon": [
		84962,
		9,
		84962
	],
	"./components/common/icons/TransactionTypeIcon.jsx": [
		84962,
		9,
		84962
	],
	"./components/common/icons/styles": [
		52163,
		9,
		52163
	],
	"./components/common/icons/styles.ts": [
		52163,
		9,
		52163
	],
	"./components/common/index": [
		49736,
		9
	],
	"./components/common/index.tsx": [
		49736,
		9
	],
	"./components/common/links": [
		25964,
		9,
		25964
	],
	"./components/common/links/": [
		25964,
		9,
		25964
	],
	"./components/common/links/index": [
		25964,
		9,
		25964
	],
	"./components/common/links/index.tsx": [
		25964,
		9,
		25964
	],
	"./components/common/links/styles": [
		60065,
		9,
		60065
	],
	"./components/common/links/styles.ts": [
		60065,
		9,
		60065
	],
	"./components/common/tooltips": [
		74424,
		9
	],
	"./components/common/tooltips/": [
		74424,
		9
	],
	"./components/common/tooltips/index": [
		74424,
		9
	],
	"./components/common/tooltips/index.tsx": [
		74424,
		9
	],
	"./components/common/tooltips/styles": [
		61599,
		9
	],
	"./components/common/tooltips/styles.ts": [
		61599,
		9
	],
	"./components/core/2FA/2FA-component": [
		64753,
		9,
		48527,
		64753
	],
	"./components/core/2FA/2FA-component.tsx": [
		64753,
		9,
		48527,
		64753
	],
	"./components/core/2FA/components/ContactSupportAlert": [
		12073,
		9,
		12073
	],
	"./components/core/2FA/components/ContactSupportAlert.tsx": [
		12073,
		9,
		12073
	],
	"./components/core/AccountLinking/AccountLinking-component": [
		46698,
		9,
		46698
	],
	"./components/core/AccountLinking/AccountLinking-component.tsx": [
		46698,
		9,
		46698
	],
	"./components/core/AccountLinking/styles": [
		28831,
		9,
		28831
	],
	"./components/core/AccountLinking/styles.ts": [
		28831,
		9,
		28831
	],
	"./components/core/Acquiring/AcquiringAdditionalCards/AcquiringAdditionalCards": [
		8940,
		9
	],
	"./components/core/Acquiring/AcquiringAdditionalCards/AcquiringAdditionalCards.tsx": [
		8940,
		9
	],
	"./components/core/Acquiring/AcquiringApi": [
		53287,
		9
	],
	"./components/core/Acquiring/AcquiringApi/": [
		53287,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerate": [
		19137,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerate.tsx": [
		19137,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerateModal": [
		6665,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerateModal.tsx": [
		6665,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/styles": [
		22177,
		9
	],
	"./components/core/Acquiring/AcquiringApi/components/styles.ts": [
		22177,
		9
	],
	"./components/core/Acquiring/AcquiringApi/index": [
		53287,
		9
	],
	"./components/core/Acquiring/AcquiringApi/index.tsx": [
		53287,
		9
	],
	"./components/core/Acquiring/AcquiringCharges": [
		3061,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/": [
		3061,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringCharges-filter": [
		97021,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringCharges-filter.tsx": [
		97021,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesContext": [
		95057,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesContext.tsx": [
		95057,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesStepper": [
		14165,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesStepper.tsx": [
		14165,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTable": [
		64689,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTable.tsx": [
		64689,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTableRow": [
		21571,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTableRow.tsx": [
		21571,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModal": [
		86404,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModal.tsx": [
		86404,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModalTable": [
		52298,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModalTable.tsx": [
		52298,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/styles": [
		43868,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/styles.ts": [
		43868,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/styles": [
		69933,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/components/styles.ts": [
		69933,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/index": [
		3061,
		9
	],
	"./components/core/Acquiring/AcquiringCharges/index.tsx": [
		3061,
		9
	],
	"./components/core/Acquiring/AcquiringOverview": [
		3250,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/": [
		3250,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/AcquiringTransfersContext": [
		88300,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/AcquiringTransfersContext.tsx": [
		88300,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/AcquiringTransfersDownload": [
		88755,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/AcquiringTransfersDownload.tsx": [
		88755,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/styles": [
		81012,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/components/styles.ts": [
		81012,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/index": [
		3250,
		9
	],
	"./components/core/Acquiring/AcquiringOverview/index.tsx": [
		3250,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements": [
		65820,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/": [
		65820,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsContext": [
		84178,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsContext.tsx": [
		84178,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsFilter": [
		22748,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsFilter.tsx": [
		22748,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsStepper": [
		95077,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsStepper.tsx": [
		95077,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTable": [
		39737,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTable.tsx": [
		39737,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTableRow": [
		77518,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTableRow.tsx": [
		77518,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementModalTable": [
		66474,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementModalTable.tsx": [
		66474,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementsModal": [
		6284,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementsModal.tsx": [
		6284,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/styles": [
		86189,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/styles.ts": [
		86189,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/styles": [
		34183,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/components/styles.ts": [
		34183,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/index": [
		65820,
		9
	],
	"./components/core/Acquiring/AcquiringSettlements/index.tsx": [
		65820,
		9
	],
	"./components/core/Acquiring/AcquiringState": [
		14643,
		9
	],
	"./components/core/Acquiring/AcquiringState.ts": [
		14643,
		9
	],
	"./components/core/Acquiring/AcquiringTabs": [
		3040,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/": [
		3040,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/components/TabPanel": [
		70946,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/components/TabPanel.tsx": [
		70946,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/components/Tabs": [
		89423,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/components/Tabs.tsx": [
		89423,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/index": [
		3040,
		9
	],
	"./components/core/Acquiring/AcquiringTabs/index.tsx": [
		3040,
		9
	],
	"./components/core/Acquiring/styles": [
		82449,
		9
	],
	"./components/core/Acquiring/styles.tsx": [
		82449,
		9
	],
	"./components/core/Activate2FA": [
		24717,
		9,
		24717
	],
	"./components/core/Activate2FA/": [
		24717,
		9,
		24717
	],
	"./components/core/Activate2FA/components/Activate2FA-modal": [
		52445,
		9,
		52445
	],
	"./components/core/Activate2FA/components/Activate2FA-modal.tsx": [
		52445,
		9,
		52445
	],
	"./components/core/Activate2FA/components/ContentGoogle2FA": [
		53173,
		9,
		53173
	],
	"./components/core/Activate2FA/components/ContentGoogle2FA.tsx": [
		53173,
		9,
		53173
	],
	"./components/core/Activate2FA/components/Countdown": [
		21954,
		9,
		21954
	],
	"./components/core/Activate2FA/components/Countdown.tsx": [
		21954,
		9,
		21954
	],
	"./components/core/Activate2FA/index": [
		24717,
		9,
		24717
	],
	"./components/core/Activate2FA/index.tsx": [
		24717,
		9,
		24717
	],
	"./components/core/Activate2FA/styles": [
		80788,
		9,
		80788
	],
	"./components/core/Activate2FA/styles.ts": [
		80788,
		9,
		80788
	],
	"./components/core/Alert": [
		65778,
		9
	],
	"./components/core/Alert/": [
		65778,
		9
	],
	"./components/core/Alert/AlertVariants/Base": [
		81046,
		9
	],
	"./components/core/Alert/AlertVariants/Base.tsx": [
		81046,
		9
	],
	"./components/core/Alert/AlertVariants/BlueAlert": [
		12445,
		9
	],
	"./components/core/Alert/AlertVariants/BlueAlert.tsx": [
		12445,
		9
	],
	"./components/core/Alert/AlertVariants/DocumentRequests": [
		5271,
		9
	],
	"./components/core/Alert/AlertVariants/DocumentRequests.tsx": [
		5271,
		9
	],
	"./components/core/Alert/AlertVariants/Error": [
		3839,
		9
	],
	"./components/core/Alert/AlertVariants/Error/": [
		3839,
		9
	],
	"./components/core/Alert/AlertVariants/Error/ErrorCodes": [
		23602,
		9
	],
	"./components/core/Alert/AlertVariants/Error/ErrorCodes.tsx": [
		23602,
		9
	],
	"./components/core/Alert/AlertVariants/Error/index": [
		3839,
		9
	],
	"./components/core/Alert/AlertVariants/Error/index.tsx": [
		3839,
		9
	],
	"./components/core/Alert/AlertVariants/Info": [
		62307,
		9
	],
	"./components/core/Alert/AlertVariants/Info/": [
		62307,
		9
	],
	"./components/core/Alert/AlertVariants/Info/Text": [
		38782,
		9
	],
	"./components/core/Alert/AlertVariants/Info/Text.tsx": [
		38782,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton": [
		69023,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton/": [
		69023,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton/index": [
		69023,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton/index.tsx": [
		69023,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton/styles": [
		4856,
		9
	],
	"./components/core/Alert/AlertVariants/Info/TextWithButton/styles.tsx": [
		4856,
		9
	],
	"./components/core/Alert/AlertVariants/Info/index": [
		62307,
		9
	],
	"./components/core/Alert/AlertVariants/Info/index.tsx": [
		62307,
		9
	],
	"./components/core/Alert/AlertVariants/Success": [
		55546,
		9
	],
	"./components/core/Alert/AlertVariants/Success.tsx": [
		55546,
		9
	],
	"./components/core/Alert/AlertVariants/Warning": [
		12066,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/": [
		12066,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Authenticator": [
		85305,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Authenticator.tsx": [
		85305,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Playground": [
		2331,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Playground.tsx": [
		2331,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/SecurityBadge": [
		70341,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/SecurityBadge.tsx": [
		70341,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Status": [
		59348,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/Status.tsx": [
		59348,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/WithText": [
		98251,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/WithText.tsx": [
		98251,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/index": [
		12066,
		9
	],
	"./components/core/Alert/AlertVariants/Warning/index.tsx": [
		12066,
		9
	],
	"./components/core/Alert/Global/Alerts": [
		71864,
		9
	],
	"./components/core/Alert/Global/Alerts.tsx": [
		71864,
		9
	],
	"./components/core/Alert/Global/Notifications": [
		53291,
		9
	],
	"./components/core/Alert/Global/Notifications.tsx": [
		53291,
		9
	],
	"./components/core/Alert/Global/utils": [
		19870,
		9
	],
	"./components/core/Alert/Global/utils.tsx": [
		19870,
		9
	],
	"./components/core/Alert/index": [
		65778,
		9
	],
	"./components/core/Alert/index.tsx": [
		65778,
		9
	],
	"./components/core/Alert/styles": [
		64594,
		9
	],
	"./components/core/Alert/styles.ts": [
		64594,
		9
	],
	"./components/core/Alert/types": [
		53125,
		9,
		53125
	],
	"./components/core/Alert/types.ts": [
		53125,
		9,
		53125
	],
	"./components/core/Alert/utils": [
		83484,
		9
	],
	"./components/core/Alert/utils.tsx": [
		83484,
		9
	],
	"./components/core/ApplicationForms/ApplicationForms-overrides": [
		25053,
		9,
		25053
	],
	"./components/core/ApplicationForms/ApplicationForms-overrides.jsx": [
		25053,
		9,
		25053
	],
	"./components/core/ApplicationForms/ApplicationForms-styles": [
		87859,
		9,
		87859
	],
	"./components/core/ApplicationForms/ApplicationForms-styles.jsx": [
		87859,
		9,
		87859
	],
	"./components/core/ApplicationForms/CompanyApplicationForm/v1-CompanyApplicationForm-component": [
		62151,
		9,
		87705,
		69584,
		58141,
		99241,
		62151
	],
	"./components/core/ApplicationForms/CompanyApplicationForm/v1-CompanyApplicationForm-component.jsx": [
		62151,
		9,
		87705,
		69584,
		58141,
		99241,
		62151
	],
	"./components/core/ApplicationForms/CompanyApplicationForm/v2-CompanyApplicationForm-component": [
		64206,
		9,
		87705,
		69584,
		58141,
		99241,
		64206
	],
	"./components/core/ApplicationForms/CompanyApplicationForm/v2-CompanyApplicationForm-component.jsx": [
		64206,
		9,
		87705,
		69584,
		58141,
		99241,
		64206
	],
	"./components/core/ApplicationForms/DynamicForm/DynamicForm-component": [
		25853,
		9,
		93341,
		25853
	],
	"./components/core/ApplicationForms/DynamicForm/DynamicForm-component.jsx": [
		25853,
		9,
		93341,
		25853
	],
	"./components/core/ApplicationForms/IndividualApplicationForm/v1-IndividualApplicationForm-component": [
		77944,
		9,
		87705,
		69584,
		58141,
		77944
	],
	"./components/core/ApplicationForms/IndividualApplicationForm/v1-IndividualApplicationForm-component.jsx": [
		77944,
		9,
		87705,
		69584,
		58141,
		77944
	],
	"./components/core/ApplicationForms/IndividualApplicationForm/v2-IndividualApplicationForm-component": [
		98571,
		9,
		87705,
		69584,
		58141,
		98571
	],
	"./components/core/ApplicationForms/IndividualApplicationForm/v2-IndividualApplicationForm-component.jsx": [
		98571,
		9,
		87705,
		69584,
		58141,
		98571
	],
	"./components/core/Cards/DragableCard": [
		1900,
		9,
		1900
	],
	"./components/core/Cards/DragableCard/": [
		1900,
		9,
		1900
	],
	"./components/core/Cards/DragableCard/components/DetermineCard": [
		9839,
		9,
		9839
	],
	"./components/core/Cards/DragableCard/components/DetermineCard.tsx": [
		9839,
		9,
		9839
	],
	"./components/core/Cards/DragableCard/index": [
		1900,
		9,
		1900
	],
	"./components/core/Cards/DragableCard/index.tsx": [
		1900,
		9,
		1900
	],
	"./components/core/Cards/DragableCard/styles": [
		23718,
		9,
		23718
	],
	"./components/core/Cards/DragableCard/styles.tsx": [
		23718,
		9,
		23718
	],
	"./components/core/Cards/EmptySectionCard": [
		1641,
		9,
		1641
	],
	"./components/core/Cards/EmptySectionCard/": [
		1641,
		9,
		1641
	],
	"./components/core/Cards/EmptySectionCard/index": [
		1641,
		9,
		1641
	],
	"./components/core/Cards/EmptySectionCard/index.tsx": [
		1641,
		9,
		1641
	],
	"./components/core/Cards/EmptySectionCard/styles": [
		89577,
		9,
		89577
	],
	"./components/core/Cards/EmptySectionCard/styles.tsx": [
		89577,
		9,
		89577
	],
	"./components/core/Cards/FailureModalCard": [
		45374,
		9,
		45374
	],
	"./components/core/Cards/FailureModalCard/": [
		45374,
		9,
		45374
	],
	"./components/core/Cards/FailureModalCard/index": [
		45374,
		9,
		45374
	],
	"./components/core/Cards/FailureModalCard/index.tsx": [
		45374,
		9,
		45374
	],
	"./components/core/Cards/LinkingCards": [
		12329,
		9,
		80925,
		12329
	],
	"./components/core/Cards/LinkingCards/": [
		12329,
		9,
		80925,
		12329
	],
	"./components/core/Cards/LinkingCards/index": [
		12329,
		9,
		80925,
		12329
	],
	"./components/core/Cards/LinkingCards/index.tsx": [
		12329,
		9,
		80925,
		12329
	],
	"./components/core/Cards/LinkingCards/styles": [
		77612,
		9,
		77612
	],
	"./components/core/Cards/LinkingCards/styles.ts": [
		77612,
		9,
		77612
	],
	"./components/core/Cards/LinkingCards/utils": [
		6610,
		9,
		6610
	],
	"./components/core/Cards/LinkingCards/utils.ts": [
		6610,
		9,
		6610
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard": [
		76263,
		9,
		76263
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard/": [
		76263,
		9,
		76263
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard/index": [
		76263,
		9,
		76263
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard/index.tsx": [
		76263,
		9,
		76263
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard/styles": [
		22931,
		9,
		22931
	],
	"./components/core/Cards/NotVerifiedUserCards/NotVerifiedAccountLedgerCard/styles.ts": [
		22931,
		9,
		22931
	],
	"./components/core/Cards/NotVerifiedUserCards/VerifyYourProfileCard": [
		79011,
		9,
		79011
	],
	"./components/core/Cards/NotVerifiedUserCards/VerifyYourProfileCard/": [
		79011,
		9,
		79011
	],
	"./components/core/Cards/NotVerifiedUserCards/VerifyYourProfileCard/index": [
		79011,
		9,
		79011
	],
	"./components/core/Cards/NotVerifiedUserCards/VerifyYourProfileCard/index.tsx": [
		79011,
		9,
		79011
	],
	"./components/core/Cards/PromoCard": [
		14722,
		9,
		14722
	],
	"./components/core/Cards/PromoCard/": [
		14722,
		9,
		14722
	],
	"./components/core/Cards/PromoCard/components/PromoCardImageStyled": [
		40483,
		9,
		40483
	],
	"./components/core/Cards/PromoCard/components/PromoCardImageStyled.tsx": [
		40483,
		9,
		40483
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer": [
		60740,
		9,
		60740
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer/": [
		60740,
		9,
		60740
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer/index": [
		60740,
		9,
		60740
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer/index.tsx": [
		60740,
		9,
		60740
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer/styles": [
		28391,
		9,
		28391
	],
	"./components/core/Cards/PromoCard/components/SpecialOffer/styles.ts": [
		28391,
		9,
		28391
	],
	"./components/core/Cards/PromoCard/index": [
		14722,
		9,
		14722
	],
	"./components/core/Cards/PromoCard/index.tsx": [
		14722,
		9,
		14722
	],
	"./components/core/Cards/PromoCard/styles": [
		82596,
		9,
		82596
	],
	"./components/core/Cards/PromoCard/styles.ts": [
		82596,
		9,
		82596
	],
	"./components/core/Cards/QuickDepositCard": [
		51331,
		9,
		51331
	],
	"./components/core/Cards/QuickDepositCard/": [
		51331,
		9,
		51331
	],
	"./components/core/Cards/QuickDepositCard/index": [
		51331,
		9,
		51331
	],
	"./components/core/Cards/QuickDepositCard/index.tsx": [
		51331,
		9,
		51331
	],
	"./components/core/Cards/QuickDepositCard/styles": [
		7756,
		9,
		7756
	],
	"./components/core/Cards/QuickDepositCard/styles.ts": [
		7756,
		9,
		7756
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards": [
		64465,
		9,
		69584,
		64465
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/": [
		64465,
		9,
		69584,
		64465
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/BorderLinearProgressStyled": [
		60614,
		9,
		60614
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/BorderLinearProgressStyled.ts": [
		60614,
		9,
		60614
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/QontoConnectorStyled": [
		25539,
		9,
		25539
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/QontoConnectorStyled.ts": [
		25539,
		9,
		25539
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/index": [
		64465,
		9,
		69584,
		64465
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/index.tsx": [
		64465,
		9,
		69584,
		64465
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/styles": [
		61124,
		9,
		61124
	],
	"./components/core/Cards/ReferralsCard/ReferralEarnedRewards/styles.ts": [
		61124,
		9,
		61124
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram": [
		98966,
		9,
		69584,
		98966
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram/": [
		98966,
		9,
		69584,
		98966
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram/index": [
		98966,
		9,
		69584,
		98966
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram/index.tsx": [
		98966,
		9,
		69584,
		98966
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram/styles": [
		4148,
		9,
		4148
	],
	"./components/core/Cards/ReferralsCard/ReferralProgram/styles.ts": [
		4148,
		9,
		4148
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded": [
		51391,
		9,
		51391
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded/": [
		51391,
		9,
		51391
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded/index": [
		51391,
		9,
		51391
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded/index.tsx": [
		51391,
		9,
		51391
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded/styles": [
		67586,
		9,
		67586
	],
	"./components/core/Cards/ReferralsCard/ReferralProgramEnded/styles.ts": [
		67586,
		9,
		67586
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards": [
		6164,
		9,
		6164
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards/": [
		6164,
		9,
		6164
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards/index": [
		6164,
		9,
		6164
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards/index.tsx": [
		6164,
		9,
		6164
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards/styles": [
		2652,
		9,
		2652
	],
	"./components/core/Cards/ReferralsCard/ReferralRewards/styles.ts": [
		2652,
		9,
		2652
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer": [
		12618,
		9,
		53104
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer/": [
		12618,
		9,
		53104
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer/index": [
		12618,
		9,
		53104
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer/index.tsx": [
		12618,
		9,
		53104
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer/styles": [
		66078,
		9,
		66078
	],
	"./components/core/Cards/ReferralsCard/ReferralsTimer/styles.ts": [
		66078,
		9,
		66078
	],
	"./components/core/Cards/SpecialOffers": [
		76371,
		9,
		76371
	],
	"./components/core/Cards/SpecialOffers/": [
		76371,
		9,
		76371
	],
	"./components/core/Cards/SpecialOffers/components/OfferAsset": [
		27966,
		9,
		27966
	],
	"./components/core/Cards/SpecialOffers/components/OfferAsset.tsx": [
		27966,
		9,
		27966
	],
	"./components/core/Cards/SpecialOffers/index": [
		76371,
		9,
		76371
	],
	"./components/core/Cards/SpecialOffers/index.tsx": [
		76371,
		9,
		76371
	],
	"./components/core/Cards/SpecialOffers/styles": [
		2295,
		9,
		2295
	],
	"./components/core/Cards/SpecialOffers/styles.ts": [
		2295,
		9,
		2295
	],
	"./components/core/Cards/SuccessModalCard/QuickDepositCard/QuickDepositCard-component": [
		66765,
		9,
		66765
	],
	"./components/core/Cards/SuccessModalCard/QuickDepositCard/QuickDepositCard-component.tsx": [
		66765,
		9,
		66765
	],
	"./components/core/Cards/SuccessModalCard/SuccessModalCard-component": [
		19710,
		9,
		19710
	],
	"./components/core/Cards/SuccessModalCard/SuccessModalCard-component.jsx": [
		19710,
		9,
		19710
	],
	"./components/core/Cards/SuccessModalCard/SuccessModalCard-modal": [
		38178,
		9,
		38178
	],
	"./components/core/Cards/SuccessModalCard/SuccessModalCard-modal.tsx": [
		38178,
		9,
		38178
	],
	"./components/core/Cards/SuspendedModalCard": [
		93602,
		9,
		93602
	],
	"./components/core/Cards/SuspendedModalCard/": [
		93602,
		9,
		93602
	],
	"./components/core/Cards/SuspendedModalCard/index": [
		93602,
		9,
		93602
	],
	"./components/core/Cards/SuspendedModalCard/index.tsx": [
		93602,
		9,
		93602
	],
	"./components/core/CompanyPayments/BankDeposit/BankDepositPayment-component": [
		90255,
		9,
		90255
	],
	"./components/core/CompanyPayments/BankDeposit/BankDepositPayment-component.jsx": [
		90255,
		9,
		90255
	],
	"./components/core/CompanyPayments/BankDeposit/BankDepositPayment-modal": [
		21705,
		9,
		21705
	],
	"./components/core/CompanyPayments/BankDeposit/BankDepositPayment-modal.jsx": [
		21705,
		9,
		21705
	],
	"./components/core/CompanyPayments/BankDeposit/styles": [
		75372,
		9,
		75372
	],
	"./components/core/CompanyPayments/BankDeposit/styles.js": [
		75372,
		9,
		75372
	],
	"./components/core/CompanyPayments/Card/CardPayment-component": [
		78509,
		9,
		78509
	],
	"./components/core/CompanyPayments/Card/CardPayment-component.jsx": [
		78509,
		9,
		78509
	],
	"./components/core/CompanyPayments/Card/CardPayment-modal": [
		19049,
		9,
		19049
	],
	"./components/core/CompanyPayments/Card/CardPayment-modal.jsx": [
		19049,
		9,
		19049
	],
	"./components/core/CompanyPayments/CompanyPayments-component": [
		20956,
		9,
		20956
	],
	"./components/core/CompanyPayments/CompanyPayments-component.jsx": [
		20956,
		9,
		20956
	],
	"./components/core/CompanyPayments/OnlineBank/OnlineBankPayment-component": [
		79478,
		9,
		79478
	],
	"./components/core/CompanyPayments/OnlineBank/OnlineBankPayment-component.jsx": [
		79478,
		9,
		79478
	],
	"./components/core/CompanyPayments/OnlineBank/OnlineBankPayment-modal": [
		1886,
		9,
		1886
	],
	"./components/core/CompanyPayments/OnlineBank/OnlineBankPayment-modal.jsx": [
		1886,
		9,
		1886
	],
	"./components/core/CountdownTimer/CountdownCircleTimer-component": [
		60054,
		9,
		60054
	],
	"./components/core/CountdownTimer/CountdownCircleTimer-component.jsx": [
		60054,
		9,
		60054
	],
	"./components/core/DropDown/DropDown-component": [
		38872,
		9
	],
	"./components/core/DropDown/DropDown-component.tsx": [
		38872,
		9
	],
	"./components/core/DropDown/DropDown-styles": [
		8590,
		9
	],
	"./components/core/DropDown/DropDown-styles.ts": [
		8590,
		9
	],
	"./components/core/DropDown/DropDown.interfaces": [
		60804,
		9,
		60804
	],
	"./components/core/DropDown/DropDown.interfaces.ts": [
		60804,
		9,
		60804
	],
	"./components/core/ErrorBoundary": [
		77716,
		9,
		77716
	],
	"./components/core/ErrorBoundary/": [
		77716,
		9,
		77716
	],
	"./components/core/ErrorBoundary/Error404": [
		14581,
		9
	],
	"./components/core/ErrorBoundary/Error404.tsx": [
		14581,
		9
	],
	"./components/core/ErrorBoundary/ErrorNetwork408": [
		45917,
		9
	],
	"./components/core/ErrorBoundary/ErrorNetwork408.tsx": [
		45917,
		9
	],
	"./components/core/ErrorBoundary/ErrorPage": [
		92210,
		9,
		92210
	],
	"./components/core/ErrorBoundary/ErrorPage.tsx": [
		92210,
		9,
		92210
	],
	"./components/core/ErrorBoundary/ErrorPermission403": [
		45775,
		9,
		45775
	],
	"./components/core/ErrorBoundary/ErrorPermission403.tsx": [
		45775,
		9,
		45775
	],
	"./components/core/ErrorBoundary/ErrorServer500": [
		85121,
		9
	],
	"./components/core/ErrorBoundary/ErrorServer500.tsx": [
		85121,
		9
	],
	"./components/core/ErrorBoundary/ErrorServerToast/ErrorServerToast-component": [
		4649,
		9
	],
	"./components/core/ErrorBoundary/ErrorServerToast/ErrorServerToast-component.tsx": [
		4649,
		9
	],
	"./components/core/ErrorBoundary/ErrorSpitter": [
		83322,
		9
	],
	"./components/core/ErrorBoundary/ErrorSpitter.tsx": [
		83322,
		9
	],
	"./components/core/ErrorBoundary/index": [
		77716,
		9,
		77716
	],
	"./components/core/ErrorBoundary/index.tsx": [
		77716,
		9,
		77716
	],
	"./components/core/ErrorBoundary/styles": [
		99150,
		9
	],
	"./components/core/ErrorBoundary/styles.tsx": [
		99150,
		9
	],
	"./components/core/FakeDeposit/FakeDeposit-component": [
		29486,
		9,
		29486
	],
	"./components/core/FakeDeposit/FakeDeposit-component.jsx": [
		29486,
		9,
		29486
	],
	"./components/core/FakeDeposit/FakeDeposit-modal": [
		98620,
		9,
		98620
	],
	"./components/core/FakeDeposit/FakeDeposit-modal.jsx": [
		98620,
		9,
		98620
	],
	"./components/core/Footer/Footer-component": [
		5761,
		9,
		5761
	],
	"./components/core/Footer/Footer-component.jsx": [
		5761,
		9,
		5761
	],
	"./components/core/Forms/AccountStatusChangedForm/AccountStatusChangedForm-component": [
		87059,
		9
	],
	"./components/core/Forms/AccountStatusChangedForm/AccountStatusChangedForm-component.jsx": [
		87059,
		9
	],
	"./components/core/Forms/AccountStatusChangedForm/AccountStatusChangedForm-modal": [
		2588,
		9
	],
	"./components/core/Forms/AccountStatusChangedForm/AccountStatusChangedForm-modal.jsx": [
		2588,
		9
	],
	"./components/core/Forms/AssetsForm/AssetsForm-component": [
		38151,
		9,
		38151
	],
	"./components/core/Forms/AssetsForm/AssetsForm-component.jsx": [
		38151,
		9,
		38151
	],
	"./components/core/Forms/AssetsForm/AssetsForm-modal": [
		6143,
		9,
		6143
	],
	"./components/core/Forms/AssetsForm/AssetsForm-modal.jsx": [
		6143,
		9,
		6143
	],
	"./components/core/Forms/AssetsForm/DepositByBank": [
		95855,
		9,
		87705,
		74036,
		95855
	],
	"./components/core/Forms/AssetsForm/DepositByBank/": [
		95855,
		9,
		87705,
		74036,
		95855
	],
	"./components/core/Forms/AssetsForm/DepositByBank/index": [
		95855,
		9,
		87705,
		74036,
		95855
	],
	"./components/core/Forms/AssetsForm/DepositByBank/index.tsx": [
		95855,
		9,
		87705,
		74036,
		95855
	],
	"./components/core/Forms/AssetsForm/DepositByBank/styles": [
		36342,
		9,
		36342
	],
	"./components/core/Forms/AssetsForm/DepositByBank/styles.ts": [
		36342,
		9,
		36342
	],
	"./components/core/Forms/AssetsForm/Exchange/Exchange-component": [
		98174,
		9,
		87705,
		74036,
		98174
	],
	"./components/core/Forms/AssetsForm/Exchange/Exchange-component.jsx": [
		98174,
		9,
		87705,
		74036,
		98174
	],
	"./components/core/Forms/AssetsForm/Exchange/Exchange-state": [
		33469,
		9,
		33469
	],
	"./components/core/Forms/AssetsForm/Exchange/Exchange-state.tsx": [
		33469,
		9,
		33469
	],
	"./components/core/Forms/AssetsForm/Tabs/AddMoneyTab-component": [
		90661,
		9,
		37079
	],
	"./components/core/Forms/AssetsForm/Tabs/AddMoneyTab-component.jsx": [
		90661,
		9,
		37079
	],
	"./components/core/Forms/AssetsForm/Tabs/TransferTab-component": [
		55101,
		9,
		55101
	],
	"./components/core/Forms/AssetsForm/Tabs/TransferTab-component.jsx": [
		55101,
		9,
		55101
	],
	"./components/core/Forms/AssetsForm/Transfer/BankAccountTransfer-component": [
		753,
		9,
		87705,
		18267,
		12136,
		62924,
		74036,
		753
	],
	"./components/core/Forms/AssetsForm/Transfer/BankAccountTransfer-component.tsx": [
		753,
		9,
		87705,
		18267,
		12136,
		62924,
		74036,
		753
	],
	"./components/core/Forms/AssetsForm/Transfer/Transfer.interface": [
		37762,
		9,
		27979
	],
	"./components/core/Forms/AssetsForm/Transfer/Transfer.interface.ts": [
		37762,
		9,
		27979
	],
	"./components/core/Forms/AssetsForm/Transfer/UserTransfer-component": [
		95450,
		9,
		87705,
		18267,
		74036,
		95450
	],
	"./components/core/Forms/AssetsForm/Transfer/UserTransfer-component.jsx": [
		95450,
		9,
		87705,
		18267,
		74036,
		95450
	],
	"./components/core/Forms/BankAccountForm/BankAccountForm-component": [
		61491,
		9,
		61491
	],
	"./components/core/Forms/BankAccountForm/BankAccountForm-component.jsx": [
		61491,
		9,
		61491
	],
	"./components/core/Forms/BankAccountForm/BankAccountForm-modal": [
		26896,
		9,
		26896
	],
	"./components/core/Forms/BankAccountForm/BankAccountForm-modal.jsx": [
		26896,
		9,
		26896
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositBank-component": [
		61002,
		9,
		87705,
		74036,
		61002
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositBank-component.tsx": [
		61002,
		9,
		87705,
		74036,
		61002
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositInternal-component": [
		68782,
		9,
		87705,
		74036,
		68782
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositInternal-component.jsx": [
		68782,
		9,
		87705,
		74036,
		68782
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositUKLocal-component": [
		1471,
		9,
		1471
	],
	"./components/core/Forms/BankAccountForm/Deposit/DepositUKLocal-component.jsx": [
		1471,
		9,
		1471
	],
	"./components/core/Forms/BankAccountForm/Tabs/DepositTab-component": [
		60131,
		9,
		60131
	],
	"./components/core/Forms/BankAccountForm/Tabs/DepositTab-component.jsx": [
		60131,
		9,
		60131
	],
	"./components/core/Forms/BankAccountForm/Tabs/TransferTab-component": [
		5227,
		9,
		5227
	],
	"./components/core/Forms/BankAccountForm/Tabs/TransferTab-component.jsx": [
		5227,
		9,
		5227
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferBank-component": [
		88587,
		9,
		87705,
		18267,
		12136,
		55973,
		74036,
		88587
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferBank-component.jsx": [
		88587,
		9,
		87705,
		18267,
		12136,
		55973,
		74036,
		88587
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferInternal-component": [
		44224,
		9,
		87705,
		74036,
		44224
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferInternal-component.jsx": [
		44224,
		9,
		87705,
		74036,
		44224
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferUKLocalBank-component": [
		32597,
		9,
		87705,
		18267,
		12136,
		74036,
		32597
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferUKLocalBank-component.jsx": [
		32597,
		9,
		87705,
		18267,
		12136,
		74036,
		32597
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferWithdraw-component": [
		53997,
		9,
		87705,
		74036,
		53997
	],
	"./components/core/Forms/BankAccountForm/Transfer/TransferWithdraw-component.jsx": [
		53997,
		9,
		87705,
		74036,
		53997
	],
	"./components/core/Forms/BusinessApplyForm": [
		46693,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		46693
	],
	"./components/core/Forms/BusinessApplyForm/": [
		46693,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		46693
	],
	"./components/core/Forms/BusinessApplyForm/components/Splitter": [
		2350,
		9,
		2350
	],
	"./components/core/Forms/BusinessApplyForm/components/Splitter.tsx": [
		2350,
		9,
		2350
	],
	"./components/core/Forms/BusinessApplyForm/components/Success": [
		93873,
		9,
		93873
	],
	"./components/core/Forms/BusinessApplyForm/components/Success.tsx": [
		93873,
		9,
		93873
	],
	"./components/core/Forms/BusinessApplyForm/formHelpers": [
		33338,
		9,
		8007,
		33338
	],
	"./components/core/Forms/BusinessApplyForm/formHelpers.ts": [
		33338,
		9,
		8007,
		33338
	],
	"./components/core/Forms/BusinessApplyForm/index": [
		46693,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		46693
	],
	"./components/core/Forms/BusinessApplyForm/index.tsx": [
		46693,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		46693
	],
	"./components/core/Forms/BusinessApplyForm/styles": [
		5173,
		9,
		5173
	],
	"./components/core/Forms/BusinessApplyForm/styles.ts": [
		5173,
		9,
		5173
	],
	"./components/core/Forms/ChangePasswordForm/ChangePasswordForm-component": [
		48826,
		9,
		87705,
		48826
	],
	"./components/core/Forms/ChangePasswordForm/ChangePasswordForm-component.jsx": [
		48826,
		9,
		87705,
		48826
	],
	"./components/core/Forms/ChangePasswordForm/ChangePasswordForm-modal": [
		34461,
		9,
		34461
	],
	"./components/core/Forms/ChangePasswordForm/ChangePasswordForm-modal.jsx": [
		34461,
		9,
		34461
	],
	"./components/core/Forms/ChangePhoneForm/ChangePhoneForm-component": [
		7632,
		9,
		7632
	],
	"./components/core/Forms/ChangePhoneForm/ChangePhoneForm-component.jsx": [
		7632,
		9,
		7632
	],
	"./components/core/Forms/ChangePhoneForm/ChangePhoneForm-modal": [
		24798,
		9,
		24798
	],
	"./components/core/Forms/ChangePhoneForm/ChangePhoneForm-modal.jsx": [
		24798,
		9,
		24798
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardActivate-component": [
		63408,
		9,
		87705,
		63408
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardActivate-component.tsx": [
		63408,
		9,
		87705,
		63408
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardDeactivate-component": [
		77177,
		9,
		77177
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardDeactivate-component.tsx": [
		77177,
		9,
		77177
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardInfo": [
		20864,
		9,
		20864
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/CreditCardInfo.tsx": [
		20864,
		9,
		20864
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/styles": [
		51914,
		9,
		51914
	],
	"./components/core/Forms/CreditCardViewForm/CardInfo/styles.ts": [
		51914,
		9,
		51914
	],
	"./components/core/Forms/CreditCardViewForm/CardTopUp/CreditCardTopUp-component": [
		41429,
		9,
		87705,
		74036,
		41429
	],
	"./components/core/Forms/CreditCardViewForm/CardTopUp/CreditCardTopUp-component.tsx": [
		41429,
		9,
		87705,
		74036,
		41429
	],
	"./components/core/Forms/CreditCardViewForm/CardWithdraw/CreditCardWithdraw-component": [
		79405,
		9,
		87705,
		74036,
		79405
	],
	"./components/core/Forms/CreditCardViewForm/CardWithdraw/CreditCardWithdraw-component.tsx": [
		79405,
		9,
		87705,
		74036,
		79405
	],
	"./components/core/Forms/CreditCardViewForm/CreditCardViewForm-component": [
		18944,
		9,
		87705,
		74036,
		20864,
		18944
	],
	"./components/core/Forms/CreditCardViewForm/CreditCardViewForm-component.tsx": [
		18944,
		9,
		87705,
		74036,
		20864,
		18944
	],
	"./components/core/Forms/CreditCardViewForm/CreditCardViewForm-modal": [
		6558,
		9,
		6558
	],
	"./components/core/Forms/CreditCardViewForm/CreditCardViewForm-modal.jsx": [
		6558,
		9,
		6558
	],
	"./components/core/Forms/DeactivateAccountForm/DeactivateAccountForm-component": [
		70736,
		9,
		70736
	],
	"./components/core/Forms/DeactivateAccountForm/DeactivateAccountForm-component.jsx": [
		70736,
		9,
		70736
	],
	"./components/core/Forms/DeactivateAccountForm/DeactivateAccountForm-modal": [
		27659,
		9,
		27659
	],
	"./components/core/Forms/DeactivateAccountForm/DeactivateAccountForm-modal.jsx": [
		27659,
		9,
		27659
	],
	"./components/core/Forms/DepositByCard/DepositByCard-component": [
		83680,
		9,
		87705,
		50545,
		74036,
		83680
	],
	"./components/core/Forms/DepositByCard/DepositByCard-component.jsx": [
		83680,
		9,
		87705,
		50545,
		74036,
		83680
	],
	"./components/core/Forms/DepositByOnlineBank/DepositByOnlineBank-component": [
		24995,
		9,
		87705,
		25772,
		74036,
		24995
	],
	"./components/core/Forms/DepositByOnlineBank/DepositByOnlineBank-component.jsx": [
		24995,
		9,
		87705,
		25772,
		74036,
		24995
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetWalletInfo": [
		83810,
		9,
		83810
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetWalletInfo.tsx": [
		83810,
		9,
		83810
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-modal": [
		604,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		80925,
		74036,
		94659,
		66599,
		15422,
		90554,
		99472,
		16489,
		9644,
		604
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-modal.tsx": [
		604,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		80925,
		74036,
		94659,
		66599,
		15422,
		90554,
		99472,
		16489,
		9644,
		604
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-state": [
		59371,
		9,
		59371
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-state.ts": [
		59371,
		9,
		59371
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-styles": [
		54793,
		9,
		54793
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssets-styles.tsx": [
		54793,
		9,
		54793
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsReceiveCryptoForm-component": [
		91714,
		9,
		80925,
		65237
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsReceiveCryptoForm-component.tsx": [
		91714,
		9,
		80925,
		65237
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsSendCryptoForm-component": [
		16489,
		9,
		87705,
		74036,
		16489,
		57199
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsSendCryptoForm-component.tsx": [
		16489,
		9,
		87705,
		74036,
		16489,
		57199
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsTabs-component": [
		9644,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		80925,
		74036,
		94659,
		66599,
		15422,
		90554,
		99472,
		16489,
		9644
	],
	"./components/core/Forms/DigitalAssetsFrom/DigitalAssets/DigitalAssetsTabs-component.tsx": [
		9644,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		80925,
		74036,
		94659,
		66599,
		15422,
		90554,
		99472,
		16489,
		9644
	],
	"./components/core/Forms/EmailConfirmationForm/EmailConfirmationForm-component": [
		64974,
		9,
		64974
	],
	"./components/core/Forms/EmailConfirmationForm/EmailConfirmationForm-component.jsx": [
		64974,
		9,
		64974
	],
	"./components/core/Forms/EmailConfirmationForm/EmailConfirmationForm-modal": [
		10724,
		9,
		10724
	],
	"./components/core/Forms/EmailConfirmationForm/EmailConfirmationForm-modal.jsx": [
		10724,
		9,
		10724
	],
	"./components/core/Forms/FileUploadForm/FileUploadForm-component": [
		64579,
		9,
		18267,
		64579
	],
	"./components/core/Forms/FileUploadForm/FileUploadForm-component.jsx": [
		64579,
		9,
		18267,
		64579
	],
	"./components/core/Forms/FileUploadForm/FileUploadForm-modal": [
		64075,
		9,
		64075
	],
	"./components/core/Forms/FileUploadForm/FileUploadForm-modal.jsx": [
		64075,
		9,
		64075
	],
	"./components/core/Forms/FileUploadForm/styles": [
		91021,
		9,
		91021
	],
	"./components/core/Forms/FileUploadForm/styles.ts": [
		91021,
		9,
		91021
	],
	"./components/core/Forms/ForgotPasswordForm": [
		1669,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		1669
	],
	"./components/core/Forms/ForgotPasswordForm/": [
		1669,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		1669
	],
	"./components/core/Forms/ForgotPasswordForm/components/SuccessCard": [
		90382,
		9,
		90382
	],
	"./components/core/Forms/ForgotPasswordForm/components/SuccessCard.tsx": [
		90382,
		9,
		90382
	],
	"./components/core/Forms/ForgotPasswordForm/formHelpers": [
		23190,
		9,
		8007,
		23190
	],
	"./components/core/Forms/ForgotPasswordForm/formHelpers.ts": [
		23190,
		9,
		8007,
		23190
	],
	"./components/core/Forms/ForgotPasswordForm/index": [
		1669,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		1669
	],
	"./components/core/Forms/ForgotPasswordForm/index.tsx": [
		1669,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		1669
	],
	"./components/core/Forms/ForgotPasswordForm/styles": [
		23046,
		9,
		23046
	],
	"./components/core/Forms/ForgotPasswordForm/styles.ts": [
		23046,
		9,
		23046
	],
	"./components/core/Forms/LimitedTokensForm/Buy": [
		88760,
		9,
		87705,
		88760
	],
	"./components/core/Forms/LimitedTokensForm/Buy/": [
		88760,
		9,
		87705,
		88760
	],
	"./components/core/Forms/LimitedTokensForm/Buy/index": [
		88760,
		9,
		87705,
		88760
	],
	"./components/core/Forms/LimitedTokensForm/Buy/index.tsx": [
		88760,
		9,
		87705,
		88760
	],
	"./components/core/Forms/LimitedTokensForm/FeeCalculation": [
		69280,
		9,
		69280
	],
	"./components/core/Forms/LimitedTokensForm/FeeCalculation.tsx": [
		69280,
		9,
		69280
	],
	"./components/core/Forms/LimitedTokensForm/Receive": [
		77924,
		9,
		80925,
		77924
	],
	"./components/core/Forms/LimitedTokensForm/Receive/": [
		77924,
		9,
		80925,
		77924
	],
	"./components/core/Forms/LimitedTokensForm/Receive/index": [
		77924,
		9,
		80925,
		77924
	],
	"./components/core/Forms/LimitedTokensForm/Receive/index.tsx": [
		77924,
		9,
		80925,
		77924
	],
	"./components/core/Forms/LimitedTokensForm/Receive/styles": [
		21818,
		9,
		21818
	],
	"./components/core/Forms/LimitedTokensForm/Receive/styles.tsx": [
		21818,
		9,
		21818
	],
	"./components/core/Forms/LimitedTokensForm/Redeem": [
		16699,
		9,
		87705,
		45329,
		16699
	],
	"./components/core/Forms/LimitedTokensForm/Redeem/": [
		16699,
		9,
		87705,
		45329,
		16699
	],
	"./components/core/Forms/LimitedTokensForm/Redeem/index": [
		16699,
		9,
		87705,
		45329,
		16699
	],
	"./components/core/Forms/LimitedTokensForm/Redeem/index.tsx": [
		16699,
		9,
		87705,
		45329,
		16699
	],
	"./components/core/Forms/LimitedTokensForm/Sell": [
		89649,
		9,
		87705,
		89649,
		98525
	],
	"./components/core/Forms/LimitedTokensForm/Sell/": [
		89649,
		9,
		87705,
		89649,
		98525
	],
	"./components/core/Forms/LimitedTokensForm/Sell/index": [
		89649,
		9,
		87705,
		89649,
		98525
	],
	"./components/core/Forms/LimitedTokensForm/Sell/index.tsx": [
		89649,
		9,
		87705,
		89649,
		98525
	],
	"./components/core/Forms/LimitedTokensForm/Tabs": [
		14536,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		14536
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/": [
		14536,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		14536
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/Modal": [
		44299,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		44299
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/Modal.tsx": [
		44299,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		44299
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/Panels": [
		81395,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/Panels.tsx": [
		81395,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/index": [
		14536,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		14536
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/index.tsx": [
		14536,
		9,
		87705,
		45329,
		80925,
		74036,
		89649,
		81395,
		14536
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/styles": [
		29726,
		9,
		22162
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/styles.tsx": [
		29726,
		9,
		22162
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/types": [
		2334,
		9,
		2334
	],
	"./components/core/Forms/LimitedTokensForm/Tabs/types.ts": [
		2334,
		9,
		2334
	],
	"./components/core/Forms/LimitedTokensForm/Transfer": [
		54722,
		9,
		87705,
		54722
	],
	"./components/core/Forms/LimitedTokensForm/Transfer/": [
		54722,
		9,
		87705,
		54722
	],
	"./components/core/Forms/LimitedTokensForm/Transfer/index": [
		54722,
		9,
		87705,
		54722
	],
	"./components/core/Forms/LimitedTokensForm/Transfer/index.tsx": [
		54722,
		9,
		87705,
		54722
	],
	"./components/core/Forms/LimitedTokensForm/Withdraw": [
		94105,
		9,
		87705,
		74036,
		94105
	],
	"./components/core/Forms/LimitedTokensForm/Withdraw/": [
		94105,
		9,
		87705,
		74036,
		94105
	],
	"./components/core/Forms/LimitedTokensForm/Withdraw/index": [
		94105,
		9,
		87705,
		74036,
		94105
	],
	"./components/core/Forms/LimitedTokensForm/Withdraw/index.tsx": [
		94105,
		9,
		87705,
		74036,
		94105
	],
	"./components/core/Forms/LimitedTokensForm/state": [
		55463,
		9,
		55463
	],
	"./components/core/Forms/LimitedTokensForm/state.tsx": [
		55463,
		9,
		55463
	],
	"./components/core/Forms/OrderBankAccountForm/AdditionalQuestionnaireForm-component": [
		24858,
		9,
		87705,
		24858
	],
	"./components/core/Forms/OrderBankAccountForm/AdditionalQuestionnaireForm-component.jsx": [
		24858,
		9,
		87705,
		24858
	],
	"./components/core/Forms/OrderBankAccountForm/OrderBankAccountForm-component": [
		61639,
		9,
		87705,
		20918,
		61639
	],
	"./components/core/Forms/OrderBankAccountForm/OrderBankAccountForm-component.jsx": [
		61639,
		9,
		87705,
		20918,
		61639
	],
	"./components/core/Forms/OrderBankAccountForm/OrderBankAccountForm-modal": [
		48960,
		9,
		87705,
		20918,
		48960
	],
	"./components/core/Forms/OrderBankAccountForm/OrderBankAccountForm-modal.jsx": [
		48960,
		9,
		87705,
		20918,
		48960
	],
	"./components/core/Forms/OrderCardForm": [
		55855,
		9,
		55855
	],
	"./components/core/Forms/OrderCardForm/": [
		55855,
		9,
		55855
	],
	"./components/core/Forms/OrderCardForm/CardDetails": [
		48433,
		9,
		87705,
		8007,
		45329,
		48433
	],
	"./components/core/Forms/OrderCardForm/CardDetails/": [
		48433,
		9,
		87705,
		8007,
		45329,
		48433
	],
	"./components/core/Forms/OrderCardForm/CardDetails/AddNewAsset": [
		84265,
		9,
		84265
	],
	"./components/core/Forms/OrderCardForm/CardDetails/AddNewAsset.tsx": [
		84265,
		9,
		84265
	],
	"./components/core/Forms/OrderCardForm/CardDetails/CompanyMemberSelect": [
		81602,
		9,
		81602
	],
	"./components/core/Forms/OrderCardForm/CardDetails/CompanyMemberSelect.tsx": [
		81602,
		9,
		81602
	],
	"./components/core/Forms/OrderCardForm/CardDetails/DebitAccountBox": [
		9971,
		9,
		9971
	],
	"./components/core/Forms/OrderCardForm/CardDetails/DebitAccountBox.tsx": [
		9971,
		9,
		9971
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoCorrectDocumentMessage": [
		60654,
		9,
		60654
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoCorrectDocumentMessage.tsx": [
		60654,
		9,
		60654
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoCorrectIBANMessage": [
		46165,
		9,
		46165
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoCorrectIBANMessage.tsx": [
		46165,
		9,
		46165
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoDebitAccountsMessage": [
		39438,
		9,
		39438
	],
	"./components/core/Forms/OrderCardForm/CardDetails/NoDebitAccountsMessage.tsx": [
		39438,
		9,
		39438
	],
	"./components/core/Forms/OrderCardForm/CardDetails/ShippingBox": [
		63210,
		9,
		87705,
		8007,
		45329,
		63210
	],
	"./components/core/Forms/OrderCardForm/CardDetails/ShippingBox.tsx": [
		63210,
		9,
		87705,
		8007,
		45329,
		63210
	],
	"./components/core/Forms/OrderCardForm/CardDetails/index": [
		48433,
		9,
		87705,
		8007,
		45329,
		48433
	],
	"./components/core/Forms/OrderCardForm/CardDetails/index.tsx": [
		48433,
		9,
		87705,
		8007,
		45329,
		48433
	],
	"./components/core/Forms/OrderCardForm/CardDetails/styles": [
		67071,
		9,
		67071
	],
	"./components/core/Forms/OrderCardForm/CardDetails/styles.ts": [
		67071,
		9,
		67071
	],
	"./components/core/Forms/OrderCardForm/OrderCardForm": [
		59361,
		9,
		87705,
		8007,
		45329,
		48433,
		59361
	],
	"./components/core/Forms/OrderCardForm/OrderCardForm.tsx": [
		59361,
		9,
		87705,
		8007,
		45329,
		48433,
		59361
	],
	"./components/core/Forms/OrderCardForm/PhysicalCardForm": [
		43169,
		9,
		87705,
		8007,
		45329,
		48433,
		43169
	],
	"./components/core/Forms/OrderCardForm/PhysicalCardForm/": [
		43169,
		9,
		87705,
		8007,
		45329,
		48433,
		43169
	],
	"./components/core/Forms/OrderCardForm/PhysicalCardForm/index": [
		43169,
		9,
		87705,
		8007,
		45329,
		48433,
		43169
	],
	"./components/core/Forms/OrderCardForm/PhysicalCardForm/index.tsx": [
		43169,
		9,
		87705,
		8007,
		45329,
		48433,
		43169
	],
	"./components/core/Forms/OrderCardForm/VirtualCardForm": [
		91660,
		9,
		87705,
		8007,
		45329,
		48433,
		91660
	],
	"./components/core/Forms/OrderCardForm/VirtualCardForm/": [
		91660,
		9,
		87705,
		8007,
		45329,
		48433,
		91660
	],
	"./components/core/Forms/OrderCardForm/VirtualCardForm/index": [
		91660,
		9,
		87705,
		8007,
		45329,
		48433,
		91660
	],
	"./components/core/Forms/OrderCardForm/VirtualCardForm/index.tsx": [
		91660,
		9,
		87705,
		8007,
		45329,
		48433,
		91660
	],
	"./components/core/Forms/OrderCardForm/index": [
		55855,
		9,
		55855
	],
	"./components/core/Forms/OrderCardForm/index.tsx": [
		55855,
		9,
		55855
	],
	"./components/core/Forms/OrderCurrencyAccountForm/OrderCurrencyAccountForm-component": [
		28255,
		9,
		28255
	],
	"./components/core/Forms/OrderCurrencyAccountForm/OrderCurrencyAccountForm-component.jsx": [
		28255,
		9,
		28255
	],
	"./components/core/Forms/OrderCurrencyAccountForm/OrderCurrencyAccountForm-modal": [
		86439,
		9,
		86439
	],
	"./components/core/Forms/OrderCurrencyAccountForm/OrderCurrencyAccountForm-modal.jsx": [
		86439,
		9,
		86439
	],
	"./components/core/Forms/OrderCurrencyAccountForm/SuccessCurrencyAccountOrder": [
		9645,
		9,
		9645
	],
	"./components/core/Forms/OrderCurrencyAccountForm/SuccessCurrencyAccountOrder.tsx": [
		9645,
		9,
		9645
	],
	"./components/core/Forms/PayForm/PayForm-component": [
		8393,
		9,
		46431,
		8393
	],
	"./components/core/Forms/PayForm/PayForm-component.jsx": [
		8393,
		9,
		46431,
		8393
	],
	"./components/core/Forms/PayForm/PayForm-modal": [
		3490,
		9,
		46431,
		3490
	],
	"./components/core/Forms/PayForm/PayForm-modal.jsx": [
		3490,
		9,
		46431,
		3490
	],
	"./components/core/Forms/PayForm/TransactionsViewModal-styles": [
		44306,
		9,
		44306
	],
	"./components/core/Forms/PayForm/TransactionsViewModal-styles.jsx": [
		44306,
		9,
		44306
	],
	"./components/core/Forms/PreviewFile/PreviewFile-component": [
		6269,
		9,
		5111,
		88897
	],
	"./components/core/Forms/PreviewFile/PreviewFile-component.jsx": [
		6269,
		9,
		5111,
		88897
	],
	"./components/core/Forms/PreviewFile/PreviewFile-modal": [
		74733,
		9,
		5111,
		23150
	],
	"./components/core/Forms/PreviewFile/PreviewFile-modal.jsx": [
		74733,
		9,
		5111,
		23150
	],
	"./components/core/Forms/QuickDeposit/CryptoAssetsSelection-component": [
		32310,
		9,
		32310
	],
	"./components/core/Forms/QuickDeposit/CryptoAssetsSelection-component.tsx": [
		32310,
		9,
		32310
	],
	"./components/core/Forms/QuickDeposit/QuickDeposit-component": [
		42634,
		9,
		42634
	],
	"./components/core/Forms/QuickDeposit/QuickDeposit-component.tsx": [
		42634,
		9,
		42634
	],
	"./components/core/Forms/QuickDeposit/QuickDeposit-modal": [
		70506,
		9,
		70506
	],
	"./components/core/Forms/QuickDeposit/QuickDeposit-modal.tsx": [
		70506,
		9,
		70506
	],
	"./components/core/Forms/ResetPasswordForm/ResetPasswordForm-center-card-styles": [
		21630,
		9,
		21630
	],
	"./components/core/Forms/ResetPasswordForm/ResetPasswordForm-center-card-styles.jsx": [
		21630,
		9,
		21630
	],
	"./components/core/Forms/ResetPasswordForm/ResetPasswordForm-component": [
		71128,
		9,
		71128
	],
	"./components/core/Forms/ResetPasswordForm/ResetPasswordForm-component.jsx": [
		71128,
		9,
		71128
	],
	"./components/core/Forms/ShippingAddressForm": [
		75355,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		75355
	],
	"./components/core/Forms/ShippingAddressForm/": [
		75355,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		75355
	],
	"./components/core/Forms/ShippingAddressForm/components/Confirm": [
		5503,
		9,
		5503
	],
	"./components/core/Forms/ShippingAddressForm/components/Confirm.tsx": [
		5503,
		9,
		5503
	],
	"./components/core/Forms/ShippingAddressForm/components/Success": [
		24919,
		9,
		24919
	],
	"./components/core/Forms/ShippingAddressForm/components/Success.tsx": [
		24919,
		9,
		24919
	],
	"./components/core/Forms/ShippingAddressForm/formHelpers": [
		1695,
		9,
		8007,
		1695
	],
	"./components/core/Forms/ShippingAddressForm/formHelpers.ts": [
		1695,
		9,
		8007,
		1695
	],
	"./components/core/Forms/ShippingAddressForm/index": [
		75355,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		75355
	],
	"./components/core/Forms/ShippingAddressForm/index.tsx": [
		75355,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		75355
	],
	"./components/core/Forms/SignInForm": [
		94536,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		64972,
		94659,
		94536
	],
	"./components/core/Forms/SignInForm/": [
		94536,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		64972,
		94659,
		94536
	],
	"./components/core/Forms/SignInForm/formHelpers": [
		36521,
		9,
		8007,
		36521
	],
	"./components/core/Forms/SignInForm/formHelpers.ts": [
		36521,
		9,
		8007,
		36521
	],
	"./components/core/Forms/SignInForm/index": [
		94536,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		64972,
		94659,
		94536
	],
	"./components/core/Forms/SignInForm/index.tsx": [
		94536,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		64972,
		94659,
		94536
	],
	"./components/core/Forms/SignInForm/styles": [
		2443,
		9,
		2443
	],
	"./components/core/Forms/SignInForm/styles.ts": [
		2443,
		9,
		2443
	],
	"./components/core/Forms/SignUpForm": [
		82594,
		9,
		82594
	],
	"./components/core/Forms/SignUpForm/": [
		82594,
		9,
		82594
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm": [
		74197,
		9,
		87705,
		12136,
		95399,
		87936,
		32328,
		74197
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/": [
		74197,
		9,
		87705,
		12136,
		95399,
		87936,
		32328,
		74197
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/index": [
		74197,
		9,
		87705,
		12136,
		95399,
		87936,
		32328,
		74197
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/index.tsx": [
		74197,
		9,
		87705,
		12136,
		95399,
		87936,
		32328,
		74197
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/styles": [
		74489,
		9,
		74489
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/styles.ts": [
		74489,
		9,
		74489
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/types": [
		81800,
		9,
		81800
	],
	"./components/core/Forms/SignUpForm/SignUpCompanyForm/types.ts": [
		81800,
		9,
		81800
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm": [
		42258,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		48140,
		42258
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/": [
		42258,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		48140,
		42258
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components": [
		84712,
		9,
		48140,
		51913
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/": [
		84712,
		9,
		48140,
		51913
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/RadioBoxAccount": [
		48140,
		9,
		48140,
		95731
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/RadioBoxAccount.tsx": [
		48140,
		9,
		48140,
		95731
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/ReferralRequirement": [
		35491,
		9,
		45346
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/ReferralRequirement.tsx": [
		35491,
		9,
		45346
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/index": [
		84712,
		9,
		48140,
		51913
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/components/index.tsx": [
		84712,
		9,
		48140,
		51913
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/formHelpers": [
		75830,
		9,
		8007,
		75830
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/formHelpers.ts": [
		75830,
		9,
		8007,
		75830
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/index": [
		42258,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		48140,
		42258
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/index.tsx": [
		42258,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		48140,
		42258
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/styles": [
		6967,
		9,
		6967
	],
	"./components/core/Forms/SignUpForm/SignUpPersonalForm/styles.jsx": [
		6967,
		9,
		6967
	],
	"./components/core/Forms/SignUpForm/index": [
		82594,
		9,
		82594
	],
	"./components/core/Forms/SignUpForm/index.tsx": [
		82594,
		9,
		82594
	],
	"./components/core/Forms/SignUpForm/styles": [
		75946,
		9,
		75946
	],
	"./components/core/Forms/SignUpForm/styles.ts": [
		75946,
		9,
		75946
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitForm/TradingDeskFormsV2ExchangeLimitForm": [
		15422,
		9,
		87705,
		15422,
		70651
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitForm/TradingDeskFormsV2ExchangeLimitForm-styles": [
		50001,
		9,
		50001
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitForm/TradingDeskFormsV2ExchangeLimitForm-styles.tsx": [
		50001,
		9,
		50001
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitForm/TradingDeskFormsV2ExchangeLimitForm.tsx": [
		15422,
		9,
		87705,
		15422,
		70651
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitMarket/TradingDeskFormsV2ExchangeLimitMarket": [
		92353,
		9,
		87705,
		74036,
		15422,
		90554,
		84747
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeLimitMarket/TradingDeskFormsV2ExchangeLimitMarket.tsx": [
		92353,
		9,
		87705,
		74036,
		15422,
		90554,
		84747
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeMarketForm/TradingDeskFormsV2ExchangeMarketForm": [
		90554,
		9,
		87705,
		74036,
		90554,
		60498
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeMarketForm/TradingDeskFormsV2ExchangeMarketForm-styles": [
		82914,
		9,
		82914
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeMarketForm/TradingDeskFormsV2ExchangeMarketForm-styles.tsx": [
		82914,
		9,
		82914
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Exchange/TradingDeskFormsV2ExchangeMarketForm/TradingDeskFormsV2ExchangeMarketForm.tsx": [
		90554,
		9,
		87705,
		74036,
		90554,
		60498
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm": [
		31500,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		52080
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/": [
		31500,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		52080
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit": [
		66599,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		84694
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit/": [
		66599,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		84694
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit/formHelpers": [
		21836,
		9,
		8007,
		21836
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit/formHelpers.ts": [
		21836,
		9,
		8007,
		21836
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit/index": [
		66599,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		84694
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2Limit/index.tsx": [
		66599,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		84694
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2LimitFeeAmount": [
		21561,
		9,
		21561
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2LimitFeeAmount.tsx": [
		21561,
		9,
		21561
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2LimitSummary": [
		45698,
		9,
		45698
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2LimitSummary.tsx": [
		45698,
		9,
		45698
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer": [
		18759,
		9,
		18759
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer/": [
		18759,
		9,
		18759
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer/index": [
		18759,
		9,
		18759
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer/index.tsx": [
		18759,
		9,
		18759
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer/styles": [
		43401,
		9,
		43401
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/components/TradingDeskFormV2PriceDisclaimer/styles.ts": [
		43401,
		9,
		43401
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/index": [
		31500,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		52080
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/index.tsx": [
		31500,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		52080
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/styles": [
		95984,
		9,
		95984
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitForm/styles.tsx": [
		95984,
		9,
		95984
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitMarket/TradingDeskFormsV2LimitMarket": [
		36214,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		99472,
		7942
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2LimitMarket/TradingDeskFormsV2LimitMarket.tsx": [
		36214,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		66599,
		99472,
		7942
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2MarketForm/TradingDeskFormsV2MarketForm": [
		99472,
		9,
		87705,
		99472,
		81632
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2MarketForm/TradingDeskFormsV2MarketForm-styles": [
		96866,
		9,
		96866
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2MarketForm/TradingDeskFormsV2MarketForm-styles.tsx": [
		96866,
		9,
		96866
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskFormsV2Seperate/TradingDeskFormsV2MarketForm/TradingDeskFormsV2MarketForm.tsx": [
		99472,
		9,
		87705,
		99472,
		81632
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskTopUpFormV2/TradingDeskTopUpV2-component": [
		45154,
		9,
		45154
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskTopUpFormV2/TradingDeskTopUpV2-component.jsx": [
		45154,
		9,
		45154
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskTopUpFormV2/TradingDeskTopUpV2-modal": [
		9467,
		9,
		9467
	],
	"./components/core/Forms/TradingDeskFormsV2/TradingDeskTopUpFormV2/TradingDeskTopUpV2-modal.jsx": [
		9467,
		9,
		9467
	],
	"./components/core/Forms/VerifyPrimaryAddressForm": [
		35087,
		9,
		35087
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/": [
		35087,
		9,
		35087
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/components/VerifyPrimaryAddressForm": [
		33445,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		33445
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/components/VerifyPrimaryAddressForm.tsx": [
		33445,
		9,
		87705,
		18267,
		12136,
		8007,
		14251,
		90606,
		84377,
		94659,
		33445
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/components/VerifyPrimaryAddressSuccessWindow": [
		42410,
		9,
		42410
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/components/VerifyPrimaryAddressSuccessWindow.tsx": [
		42410,
		9,
		42410
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/formHelpers": [
		46940,
		9,
		8007,
		46940
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/formHelpers.ts": [
		46940,
		9,
		8007,
		46940
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/index": [
		35087,
		9,
		35087
	],
	"./components/core/Forms/VerifyPrimaryAddressForm/index.tsx": [
		35087,
		9,
		35087
	],
	"./components/core/Forms/VirtualAddressForm/VirtualAddressForm-component": [
		35660,
		9,
		35660
	],
	"./components/core/Forms/VirtualAddressForm/VirtualAddressForm-component.jsx": [
		35660,
		9,
		35660
	],
	"./components/core/Forms/VirtualAddressForm/VirtualAddressForm-modal": [
		67885,
		9,
		67885
	],
	"./components/core/Forms/VirtualAddressForm/VirtualAddressForm-modal.jsx": [
		67885,
		9,
		67885
	],
	"./components/core/Header": [
		74857,
		9,
		64975,
		74857
	],
	"./components/core/Header/": [
		74857,
		9,
		64975,
		74857
	],
	"./components/core/Header/OnboardingIntentSwitch": [
		94062,
		9,
		94062
	],
	"./components/core/Header/OnboardingIntentSwitch/": [
		94062,
		9,
		94062
	],
	"./components/core/Header/OnboardingIntentSwitch/OnboardingIntentSwitch": [
		46006,
		9,
		46006
	],
	"./components/core/Header/OnboardingIntentSwitch/OnboardingIntentSwitch.tsx": [
		46006,
		9,
		46006
	],
	"./components/core/Header/OnboardingIntentSwitch/index": [
		94062,
		9,
		94062
	],
	"./components/core/Header/OnboardingIntentSwitch/index.tsx": [
		94062,
		9,
		94062
	],
	"./components/core/Header/UserDropdown": [
		15740,
		9,
		15740
	],
	"./components/core/Header/UserDropdown/": [
		15740,
		9,
		15740
	],
	"./components/core/Header/UserDropdown/AccountMenuItems": [
		15440,
		9,
		15440
	],
	"./components/core/Header/UserDropdown/AccountMenuItems/": [
		15440,
		9,
		15440
	],
	"./components/core/Header/UserDropdown/AccountMenuItems/index": [
		15440,
		9,
		15440
	],
	"./components/core/Header/UserDropdown/AccountMenuItems/index.jsx": [
		15440,
		9,
		15440
	],
	"./components/core/Header/UserDropdown/AccountMenuItems/styles": [
		25835,
		9,
		25835
	],
	"./components/core/Header/UserDropdown/AccountMenuItems/styles.js": [
		25835,
		9,
		25835
	],
	"./components/core/Header/UserDropdown/Content": [
		62430,
		9,
		62430
	],
	"./components/core/Header/UserDropdown/Content/": [
		62430,
		9,
		62430
	],
	"./components/core/Header/UserDropdown/Content/index": [
		62430,
		9,
		62430
	],
	"./components/core/Header/UserDropdown/Content/index.jsx": [
		62430,
		9,
		62430
	],
	"./components/core/Header/UserDropdown/Content/styles": [
		12775,
		9,
		12775
	],
	"./components/core/Header/UserDropdown/Content/styles.js": [
		12775,
		9,
		12775
	],
	"./components/core/Header/UserDropdown/UserBox": [
		22912,
		9,
		22912
	],
	"./components/core/Header/UserDropdown/UserBox/": [
		22912,
		9,
		22912
	],
	"./components/core/Header/UserDropdown/UserBox/index": [
		22912,
		9,
		22912
	],
	"./components/core/Header/UserDropdown/UserBox/index.jsx": [
		22912,
		9,
		22912
	],
	"./components/core/Header/UserDropdown/UserBox/styles": [
		83561,
		9,
		83561
	],
	"./components/core/Header/UserDropdown/UserBox/styles.js": [
		83561,
		9,
		83561
	],
	"./components/core/Header/UserDropdown/index": [
		15740,
		9,
		15740
	],
	"./components/core/Header/UserDropdown/index.jsx": [
		15740,
		9,
		15740
	],
	"./components/core/Header/UserDropdown/styles": [
		50705,
		9,
		50705
	],
	"./components/core/Header/UserDropdown/styles.js": [
		50705,
		9,
		50705
	],
	"./components/core/Header/index": [
		74857,
		9,
		64975,
		74857
	],
	"./components/core/Header/index.jsx": [
		74857,
		9,
		64975,
		74857
	],
	"./components/core/Header/styles": [
		68878,
		9,
		68878
	],
	"./components/core/Header/styles.js": [
		68878,
		9,
		68878
	],
	"./components/core/Inputs/SelectWithIcon-component": [
		5216,
		9,
		5216
	],
	"./components/core/Inputs/SelectWithIcon-component.jsx": [
		5216,
		9,
		5216
	],
	"./components/core/Language/Landing/LandingLanguage-component": [
		68028,
		9,
		68028
	],
	"./components/core/Language/Landing/LandingLanguage-component.jsx": [
		68028,
		9,
		68028
	],
	"./components/core/Language/Render/LanguageRender-component": [
		94359,
		9
	],
	"./components/core/Language/Render/LanguageRender-component.jsx": [
		94359,
		9
	],
	"./components/core/LegalPages/LegalPages-component": [
		79517,
		9,
		79517
	],
	"./components/core/LegalPages/LegalPages-component.jsx": [
		79517,
		9,
		79517
	],
	"./components/core/LegalPages/Nav/DesktopNavbar-component": [
		72804,
		9,
		72804
	],
	"./components/core/LegalPages/Nav/DesktopNavbar-component.jsx": [
		72804,
		9,
		72804
	],
	"./components/core/LegalPages/Nav/MobileNavbar-component": [
		88513,
		9,
		88513
	],
	"./components/core/LegalPages/Nav/MobileNavbar-component.jsx": [
		88513,
		9,
		88513
	],
	"./components/core/LegalPages/Nav/Navigation-component": [
		8797,
		9,
		8797
	],
	"./components/core/LegalPages/Nav/Navigation-component.jsx": [
		8797,
		9,
		8797
	],
	"./components/core/LegalPages/Pages/AMLCTFPolicy-component": [
		70253,
		9,
		70253
	],
	"./components/core/LegalPages/Pages/AMLCTFPolicy-component.jsx": [
		70253,
		9,
		70253
	],
	"./components/core/LegalPages/Pages/AboutUs-component": [
		27744,
		9,
		27744
	],
	"./components/core/LegalPages/Pages/AboutUs-component.jsx": [
		27744,
		9,
		27744
	],
	"./components/core/LegalPages/Pages/ComprehensivePrivacyPolicy-component": [
		5834,
		9,
		5834
	],
	"./components/core/LegalPages/Pages/ComprehensivePrivacyPolicy-component.jsx": [
		5834,
		9,
		5834
	],
	"./components/core/LegalPages/Pages/ContactUs-component": [
		49684,
		9,
		49684
	],
	"./components/core/LegalPages/Pages/ContactUs-component.jsx": [
		49684,
		9,
		49684
	],
	"./components/core/LegalPages/Pages/CookieStatement-component": [
		35681,
		9,
		35681
	],
	"./components/core/LegalPages/Pages/CookieStatement-component.jsx": [
		35681,
		9,
		35681
	],
	"./components/core/LegalPages/Pages/Impressum-component": [
		13402,
		9,
		13402
	],
	"./components/core/LegalPages/Pages/Impressum-component.jsx": [
		13402,
		9,
		13402
	],
	"./components/core/LegalPages/Pages/PrivacyPolicy-component": [
		21902,
		9,
		21902
	],
	"./components/core/LegalPages/Pages/PrivacyPolicy-component.jsx": [
		21902,
		9,
		21902
	],
	"./components/core/LegalPages/Pages/RegulatorySupervision-component": [
		6329,
		9,
		6329
	],
	"./components/core/LegalPages/Pages/RegulatorySupervision-component.jsx": [
		6329,
		9,
		6329
	],
	"./components/core/LegalPages/Pages/RiskWarning-component": [
		99915,
		9,
		99915
	],
	"./components/core/LegalPages/Pages/RiskWarning-component.jsx": [
		99915,
		9,
		99915
	],
	"./components/core/LegalPages/Pages/TermOfUse-component": [
		37659,
		9,
		37659
	],
	"./components/core/LegalPages/Pages/TermOfUse-component.jsx": [
		37659,
		9,
		37659
	],
	"./components/core/LegalPages/Pages/Trademarks-component": [
		69546,
		9,
		69546
	],
	"./components/core/LegalPages/Pages/Trademarks-component.jsx": [
		69546,
		9,
		69546
	],
	"./components/core/Links/CardTermsOfUseLink-component": [
		49316,
		9,
		49316
	],
	"./components/core/Links/CardTermsOfUseLink-component.jsx": [
		49316,
		9,
		49316
	],
	"./components/core/Links/ContactLink-component": [
		75413,
		9,
		75413
	],
	"./components/core/Links/ContactLink-component.jsx": [
		75413,
		9,
		75413
	],
	"./components/core/Links/CookieStatementLink-component": [
		79104,
		9,
		79104
	],
	"./components/core/Links/CookieStatementLink-component.jsx": [
		79104,
		9,
		79104
	],
	"./components/core/Links/PrivacyPolicyLink-component": [
		10568,
		9,
		10568
	],
	"./components/core/Links/PrivacyPolicyLink-component.jsx": [
		10568,
		9,
		10568
	],
	"./components/core/Links/TermsOfUseLink-component": [
		84022,
		9,
		84022
	],
	"./components/core/Links/TermsOfUseLink-component.jsx": [
		84022,
		9,
		84022
	],
	"./components/core/Links/TermsOfUseLinkPurchaseCoins-component": [
		61299,
		9,
		61299
	],
	"./components/core/Links/TermsOfUseLinkPurchaseCoins-component.jsx": [
		61299,
		9,
		61299
	],
	"./components/core/Links/UserAgreementLink-component": [
		98790,
		9,
		98790
	],
	"./components/core/Links/UserAgreementLink-component.jsx": [
		98790,
		9,
		98790
	],
	"./components/core/MaxButton/MaxButton-component": [
		35941,
		9,
		35941
	],
	"./components/core/MaxButton/MaxButton-component.tsx": [
		35941,
		9,
		35941
	],
	"./components/core/PhoneVerification/PhoneAuthCode-component": [
		34583,
		9,
		48527,
		34583
	],
	"./components/core/PhoneVerification/PhoneAuthCode-component.tsx": [
		34583,
		9,
		48527,
		34583
	],
	"./components/core/PhoneVerification/PhoneVerificationForm-component": [
		53005,
		9,
		48527,
		87936,
		53005
	],
	"./components/core/PhoneVerification/PhoneVerificationForm-component.jsx": [
		53005,
		9,
		48527,
		87936,
		53005
	],
	"./components/core/Progress/Progress-component": [
		98657,
		9
	],
	"./components/core/Progress/Progress-component.jsx": [
		98657,
		9
	],
	"./components/core/Referrals/Referrals-component": [
		89567,
		9,
		89567
	],
	"./components/core/Referrals/Referrals-component.tsx": [
		89567,
		9,
		89567
	],
	"./components/core/Sections/Section/Section-component": [
		53635,
		9,
		80925,
		89812,
		53635
	],
	"./components/core/Sections/Section/Section-component.tsx": [
		53635,
		9,
		80925,
		89812,
		53635
	],
	"./components/core/Sections/Section/Section-styles": [
		10623,
		9,
		10623
	],
	"./components/core/Sections/Section/Section-styles.tsx": [
		10623,
		9,
		10623
	],
	"./components/core/Sections/Section/SectionHeader": [
		11082,
		9,
		11082
	],
	"./components/core/Sections/Section/SectionHeader/": [
		11082,
		9,
		11082
	],
	"./components/core/Sections/Section/SectionHeader/index": [
		11082,
		9,
		11082
	],
	"./components/core/Sections/Section/SectionHeader/index.tsx": [
		11082,
		9,
		11082
	],
	"./components/core/Sections/Section/SectionHeader/styles": [
		83094,
		9,
		83094
	],
	"./components/core/Sections/Section/SectionHeader/styles.ts": [
		83094,
		9,
		83094
	],
	"./components/core/Sections/Section/SectionNameChange/SectionNameChange-component": [
		97842,
		9,
		97842
	],
	"./components/core/Sections/Section/SectionNameChange/SectionNameChange-component.tsx": [
		97842,
		9,
		97842
	],
	"./components/core/Sections/Section/Sections-state": [
		73574,
		9,
		73574
	],
	"./components/core/Sections/Section/Sections-state.ts": [
		73574,
		9,
		73574
	],
	"./components/core/Sections/Sections-component": [
		67460,
		9,
		67460
	],
	"./components/core/Sections/Sections-component.tsx": [
		67460,
		9,
		67460
	],
	"./components/core/SessionTimeout/SessionTimeout": [
		63700,
		9
	],
	"./components/core/SessionTimeout/SessionTimeout.tsx": [
		63700,
		9
	],
	"./components/core/Settings/Affiliate/Affiliate-component": [
		84153,
		9,
		84153
	],
	"./components/core/Settings/Affiliate/Affiliate-component.jsx": [
		84153,
		9,
		84153
	],
	"./components/core/Settings/Documents/Documents-component": [
		95252,
		9,
		95252
	],
	"./components/core/Settings/Documents/Documents-component.jsx": [
		95252,
		9,
		95252
	],
	"./components/core/Settings/Documents/NoDocuments-component": [
		31163,
		9,
		31163
	],
	"./components/core/Settings/Documents/NoDocuments-component.jsx": [
		31163,
		9,
		31163
	],
	"./components/core/Settings/Documents/RequestedDocuments": [
		71621,
		9,
		71621
	],
	"./components/core/Settings/Documents/RequestedDocuments/": [
		71621,
		9,
		71621
	],
	"./components/core/Settings/Documents/RequestedDocuments/index": [
		71621,
		9,
		71621
	],
	"./components/core/Settings/Documents/RequestedDocuments/index.tsx": [
		71621,
		9,
		71621
	],
	"./components/core/Settings/Documents/RequestedDocuments/styles": [
		75035,
		9,
		75035
	],
	"./components/core/Settings/Documents/RequestedDocuments/styles.tsx": [
		75035,
		9,
		75035
	],
	"./components/core/Settings/Documents/RequestedHistory/RequestedHistory-component": [
		27760,
		9,
		27161,
		27760
	],
	"./components/core/Settings/Documents/RequestedHistory/RequestedHistory-component.jsx": [
		27760,
		9,
		27161,
		27760
	],
	"./components/core/Settings/Notifications": [
		18442,
		9,
		18442
	],
	"./components/core/Settings/Notifications/": [
		18442,
		9,
		18442
	],
	"./components/core/Settings/Notifications/index": [
		18442,
		9,
		18442
	],
	"./components/core/Settings/Notifications/index.jsx": [
		18442,
		9,
		18442
	],
	"./components/core/Settings/Notifications/styles": [
		6856,
		9,
		6856
	],
	"./components/core/Settings/Notifications/styles.ts": [
		6856,
		9,
		6856
	],
	"./components/core/Settings/PersonalProfile/OpenBusinessAccount-component": [
		44071,
		9,
		44071
	],
	"./components/core/Settings/PersonalProfile/OpenBusinessAccount-component.jsx": [
		44071,
		9,
		44071
	],
	"./components/core/Settings/PersonalProfile/PersonalProfile-component": [
		42636,
		9,
		5580
	],
	"./components/core/Settings/PersonalProfile/PersonalProfile-component.tsx": [
		42636,
		9,
		5580
	],
	"./components/core/Settings/PersonalProfile/ProfileInfoCard-component": [
		28394,
		9,
		28394
	],
	"./components/core/Settings/PersonalProfile/ProfileInfoCard-component.tsx": [
		28394,
		9,
		28394
	],
	"./components/core/Settings/Security": [
		892,
		9,
		892
	],
	"./components/core/Settings/Security/": [
		892,
		9,
		892
	],
	"./components/core/Settings/Security/DeactivateAccount": [
		13453,
		9,
		13453
	],
	"./components/core/Settings/Security/DeactivateAccount.jsx": [
		13453,
		9,
		13453
	],
	"./components/core/Settings/Security/Devices": [
		92432,
		9,
		92432
	],
	"./components/core/Settings/Security/Devices.tsx": [
		92432,
		9,
		92432
	],
	"./components/core/Settings/Security/LastSessions": [
		29696,
		9,
		29696
	],
	"./components/core/Settings/Security/LastSessions.jsx": [
		29696,
		9,
		29696
	],
	"./components/core/Settings/Security/TwoFaMethod": [
		78500,
		9,
		78500
	],
	"./components/core/Settings/Security/TwoFaMethod.jsx": [
		78500,
		9,
		78500
	],
	"./components/core/Settings/Security/UserProfileSettings": [
		32119,
		9,
		32119
	],
	"./components/core/Settings/Security/UserProfileSettings.jsx": [
		32119,
		9,
		32119
	],
	"./components/core/Settings/Security/index": [
		892,
		9,
		892
	],
	"./components/core/Settings/Security/index.jsx": [
		892,
		9,
		892
	],
	"./components/core/Settings/Security/styles": [
		30590,
		9,
		30590
	],
	"./components/core/Settings/Security/styles.js": [
		30590,
		9,
		30590
	],
	"./components/core/Settings/ServicePlans/FinancialServicesFees-component": [
		67886,
		9,
		67886
	],
	"./components/core/Settings/ServicePlans/FinancialServicesFees-component.jsx": [
		67886,
		9,
		67886
	],
	"./components/core/Settings/ServicePlans/ServicePlans-component": [
		67160,
		9,
		58141,
		94394,
		67160
	],
	"./components/core/Settings/ServicePlans/ServicePlans-component.jsx": [
		67160,
		9,
		58141,
		94394,
		67160
	],
	"./components/core/Settings/Services/Services-component": [
		48758,
		9,
		48758
	],
	"./components/core/Settings/Services/Services-component.jsx": [
		48758,
		9,
		48758
	],
	"./components/core/Settings/Services/ServicesFees-component": [
		78638,
		9,
		84639
	],
	"./components/core/Settings/Services/ServicesFees-component.jsx": [
		78638,
		9,
		84639
	],
	"./components/core/Settings/SettingsTabs/SettingsTabs-component": [
		18619,
		9,
		55907
	],
	"./components/core/Settings/SettingsTabs/SettingsTabs-component.jsx": [
		18619,
		9,
		55907
	],
	"./components/core/Settings/SettingsTabs/TabPanel-component": [
		32757,
		9,
		32757
	],
	"./components/core/Settings/SettingsTabs/TabPanel-component.jsx": [
		32757,
		9,
		32757
	],
	"./components/core/Settings/SettingsTabs/Tabs-component": [
		57979,
		9,
		57979
	],
	"./components/core/Settings/SettingsTabs/Tabs-component.jsx": [
		57979,
		9,
		57979
	],
	"./components/core/Settings/Support/ActiveConversations/ActiveConversations-component": [
		8775,
		9,
		27161,
		8775
	],
	"./components/core/Settings/Support/ActiveConversations/ActiveConversations-component.jsx": [
		8775,
		9,
		27161,
		8775
	],
	"./components/core/Settings/Support/ArchiveConversations/ArchiveConversations-component": [
		29611,
		9,
		27161,
		29611
	],
	"./components/core/Settings/Support/ArchiveConversations/ArchiveConversations-component.jsx": [
		29611,
		9,
		27161,
		29611
	],
	"./components/core/Settings/Support/Conversation/Conversation-component": [
		13684,
		9,
		18267,
		13684
	],
	"./components/core/Settings/Support/Conversation/Conversation-component.jsx": [
		13684,
		9,
		18267,
		13684
	],
	"./components/core/Settings/Support/CreateNewMessage/CreateNewMessage-component": [
		6244,
		9,
		18267,
		6244
	],
	"./components/core/Settings/Support/CreateNewMessage/CreateNewMessage-component.jsx": [
		6244,
		9,
		18267,
		6244
	],
	"./components/core/Settings/Support/CreateNewMessage/CreateNewMessage-modal": [
		63173,
		9,
		18267,
		63173
	],
	"./components/core/Settings/Support/CreateNewMessage/CreateNewMessage-modal.jsx": [
		63173,
		9,
		18267,
		63173
	],
	"./components/core/Settings/Support/NoConversations/NoConversations-component": [
		37091,
		9,
		37091
	],
	"./components/core/Settings/Support/NoConversations/NoConversations-component.jsx": [
		37091,
		9,
		37091
	],
	"./components/core/Settings/Support/Support-component": [
		95363,
		9,
		95363
	],
	"./components/core/Settings/Support/Support-component.jsx": [
		95363,
		9,
		95363
	],
	"./components/core/Settings/UserAddresses": [
		10804,
		9,
		34730,
		10804
	],
	"./components/core/Settings/UserAddresses/": [
		10804,
		9,
		34730,
		10804
	],
	"./components/core/Settings/UserAddresses/AddressCard": [
		60965,
		9,
		60965
	],
	"./components/core/Settings/UserAddresses/AddressCard/": [
		60965,
		9,
		60965
	],
	"./components/core/Settings/UserAddresses/AddressCard/index": [
		60965,
		9,
		60965
	],
	"./components/core/Settings/UserAddresses/AddressCard/index.tsx": [
		60965,
		9,
		60965
	],
	"./components/core/Settings/UserAddresses/VirtualAddressCard": [
		11663,
		9,
		11663
	],
	"./components/core/Settings/UserAddresses/VirtualAddressCard/": [
		11663,
		9,
		11663
	],
	"./components/core/Settings/UserAddresses/VirtualAddressCard/index": [
		11663,
		9,
		11663
	],
	"./components/core/Settings/UserAddresses/VirtualAddressCard/index.tsx": [
		11663,
		9,
		11663
	],
	"./components/core/Settings/UserAddresses/index": [
		10804,
		9,
		34730,
		10804
	],
	"./components/core/Settings/UserAddresses/index.tsx": [
		10804,
		9,
		34730,
		10804
	],
	"./components/core/Settings/UserAddresses/styles": [
		81337,
		9,
		81337
	],
	"./components/core/Settings/UserAddresses/styles.tsx": [
		81337,
		9,
		81337
	],
	"./components/core/Settings/Users/Users-component": [
		84101,
		9,
		55792,
		84101
	],
	"./components/core/Settings/Users/Users-component.jsx": [
		84101,
		9,
		55792,
		84101
	],
	"./components/core/Settings/Users/Users-modal": [
		68715,
		9,
		55792,
		68715
	],
	"./components/core/Settings/Users/Users-modal.jsx": [
		68715,
		9,
		55792,
		68715
	],
	"./components/core/Settings/Users/UsersTab-component": [
		37656,
		9,
		55792,
		37656
	],
	"./components/core/Settings/Users/UsersTab-component.jsx": [
		37656,
		9,
		55792,
		37656
	],
	"./components/core/SideBarNavigation": [
		95286,
		9,
		2964,
		95286
	],
	"./components/core/SideBarNavigation/": [
		95286,
		9,
		2964,
		95286
	],
	"./components/core/SideBarNavigation/index": [
		95286,
		9,
		2964,
		95286
	],
	"./components/core/SideBarNavigation/index.jsx": [
		95286,
		9,
		2964,
		95286
	],
	"./components/core/SideBarNavigation/styles": [
		98446,
		9,
		98446
	],
	"./components/core/SideBarNavigation/styles.ts": [
		98446,
		9,
		98446
	],
	"./components/core/Skeleton/SkeletonAccounts/SkeletonAccounts-component": [
		28814,
		9,
		38374,
		28814
	],
	"./components/core/Skeleton/SkeletonAccounts/SkeletonAccounts-component.jsx": [
		28814,
		9,
		38374,
		28814
	],
	"./components/core/Skeleton/SkeletonBox/SkeletonBox-Component": [
		25674,
		9,
		25674
	],
	"./components/core/Skeleton/SkeletonBox/SkeletonBox-Component.jsx": [
		25674,
		9,
		25674
	],
	"./components/core/Skeleton/SkeletonChangeAuthenticator/SkeletonChangeAuthenticator-Component": [
		20325,
		9,
		20325
	],
	"./components/core/Skeleton/SkeletonChangeAuthenticator/SkeletonChangeAuthenticator-Component.tsx": [
		20325,
		9,
		20325
	],
	"./components/core/Skeleton/SkeletonChangeProductPlan/SkeletonChangeProductPlan-Component": [
		39365,
		9,
		39365
	],
	"./components/core/Skeleton/SkeletonChangeProductPlan/SkeletonChangeProductPlan-Component.jsx": [
		39365,
		9,
		39365
	],
	"./components/core/Skeleton/SkeletonClosableModal/SkeletonClosableModal-component": [
		49666,
		9,
		49666
	],
	"./components/core/Skeleton/SkeletonClosableModal/SkeletonClosableModal-component.tsx": [
		49666,
		9,
		49666
	],
	"./components/core/Skeleton/SkeletonDashboardSection/SkeletonDashboardSection-component": [
		34341,
		9,
		34341
	],
	"./components/core/Skeleton/SkeletonDashboardSection/SkeletonDashboardSection-component.jsx": [
		34341,
		9,
		34341
	],
	"./components/core/Skeleton/SkeletonError/SkeletonError-component": [
		23971,
		9,
		23971
	],
	"./components/core/Skeleton/SkeletonError/SkeletonError-component.jsx": [
		23971,
		9,
		23971
	],
	"./components/core/Skeleton/SkeletonForm/SkeletonForm-Component": [
		38374,
		9,
		95532
	],
	"./components/core/Skeleton/SkeletonForm/SkeletonForm-Component.jsx": [
		38374,
		9,
		95532
	],
	"./components/core/Skeleton/SkeletonKycWidget/SkeletonKycWidget-component": [
		8956,
		9,
		8956
	],
	"./components/core/Skeleton/SkeletonKycWidget/SkeletonKycWidget-component.jsx": [
		8956,
		9,
		8956
	],
	"./components/core/Skeleton/SkeletonLastSessions/SkeletonLastSessions-Component": [
		90609,
		9,
		90609
	],
	"./components/core/Skeleton/SkeletonLastSessions/SkeletonLastSessions-Component.jsx": [
		90609,
		9,
		90609
	],
	"./components/core/Skeleton/SkeletonMainCurrencyCard/SkeletonMainCurrencyCard-Component": [
		46224,
		9,
		46224
	],
	"./components/core/Skeleton/SkeletonMainCurrencyCard/SkeletonMainCurrencyCard-Component.jsx": [
		46224,
		9,
		46224
	],
	"./components/core/Skeleton/SkeletonModal/SkeletonModal-Component": [
		19175,
		9,
		19175
	],
	"./components/core/Skeleton/SkeletonModal/SkeletonModal-Component.tsx": [
		19175,
		9,
		19175
	],
	"./components/core/Skeleton/SkeletonNotifications/SkeletonNotifications-Component": [
		28582,
		9,
		72900
	],
	"./components/core/Skeleton/SkeletonNotifications/SkeletonNotifications-Component.jsx": [
		28582,
		9,
		72900
	],
	"./components/core/Skeleton/SkeletonOnboardingWizard/SkeletonOnboardingWizard-component": [
		86040,
		9,
		86040
	],
	"./components/core/Skeleton/SkeletonOnboardingWizard/SkeletonOnboardingWizard-component.jsx": [
		86040,
		9,
		86040
	],
	"./components/core/Skeleton/SkeletonOpenBussinesAcocunt/SkeletonOpenBussinesAcocunt-Component": [
		56764,
		9,
		56764
	],
	"./components/core/Skeleton/SkeletonOpenBussinesAcocunt/SkeletonOpenBussinesAcocunt-Component.tsx": [
		56764,
		9,
		56764
	],
	"./components/core/Skeleton/SkeletonProductsFees/SkeletonProductsFees-Component": [
		77817,
		9,
		77817
	],
	"./components/core/Skeleton/SkeletonProductsFees/SkeletonProductsFees-Component.jsx": [
		77817,
		9,
		77817
	],
	"./components/core/Skeleton/SkeletonQrCode/SkeletonQrCode-component": [
		49396,
		9,
		49396
	],
	"./components/core/Skeleton/SkeletonQrCode/SkeletonQrCode-component.jsx": [
		49396,
		9,
		49396
	],
	"./components/core/Skeleton/SkeletonRecentTransactions/SkeletonRecentTransactions-component": [
		2938,
		9,
		2938
	],
	"./components/core/Skeleton/SkeletonRecentTransactions/SkeletonRecentTransactions-component.jsx": [
		2938,
		9,
		2938
	],
	"./components/core/Skeleton/SkeletonRequestedDocuments/SkeletonRequestedDocuments-Component": [
		6670,
		9,
		8238
	],
	"./components/core/Skeleton/SkeletonRequestedDocuments/SkeletonRequestedDocuments-Component.jsx": [
		6670,
		9,
		8238
	],
	"./components/core/Skeleton/SkeletonRequestsHistory/SkeletonRequestsHistory-Component": [
		55281,
		9,
		55281
	],
	"./components/core/Skeleton/SkeletonRequestsHistory/SkeletonRequestsHistory-Component.jsx": [
		55281,
		9,
		55281
	],
	"./components/core/Skeleton/SkeletonSection/SkeletonSection-component": [
		55249,
		9,
		55249
	],
	"./components/core/Skeleton/SkeletonSection/SkeletonSection-component.jsx": [
		55249,
		9,
		55249
	],
	"./components/core/Skeleton/SkeletonSectionCard/SkeletonSectionCard-component": [
		33646,
		9,
		33646
	],
	"./components/core/Skeleton/SkeletonSectionCard/SkeletonSectionCard-component.jsx": [
		33646,
		9,
		33646
	],
	"./components/core/Skeleton/SkeletonSelectedBatchPayment/SkeletonSelectedBatchPayment-component": [
		74383,
		9,
		74383
	],
	"./components/core/Skeleton/SkeletonSelectedBatchPayment/SkeletonSelectedBatchPayment-component.tsx": [
		74383,
		9,
		74383
	],
	"./components/core/Skeleton/SkeletonServicePlans/SkeletonServicePlans-Component": [
		92213,
		9,
		92213
	],
	"./components/core/Skeleton/SkeletonServicePlans/SkeletonServicePlans-Component.jsx": [
		92213,
		9,
		92213
	],
	"./components/core/Skeleton/SkeletonSideBarSelectCurrency/SkeletonSideBarSelectCurrency-Component": [
		62235,
		9,
		62235
	],
	"./components/core/Skeleton/SkeletonSideBarSelectCurrency/SkeletonSideBarSelectCurrency-Component.jsx": [
		62235,
		9,
		62235
	],
	"./components/core/Skeleton/SkeletonSignUp/SkeletonSignUp-component": [
		35390,
		9,
		35390
	],
	"./components/core/Skeleton/SkeletonSignUp/SkeletonSignUp-component.jsx": [
		35390,
		9,
		35390
	],
	"./components/core/Skeleton/SkeletonSupport/SkeletonSupport-Component": [
		57680,
		9,
		57680
	],
	"./components/core/Skeleton/SkeletonSupport/SkeletonSupport-Component.jsx": [
		57680,
		9,
		57680
	],
	"./components/core/Skeleton/SkeletonTransferModal/SkeletonTransferModal-Component": [
		87984,
		9,
		87984
	],
	"./components/core/Skeleton/SkeletonTransferModal/SkeletonTransferModal-Component.jsx": [
		87984,
		9,
		87984
	],
	"./components/core/Success/SuccessLikeModal/SuccessLikeModal-component": [
		98755,
		9,
		98755
	],
	"./components/core/Success/SuccessLikeModal/SuccessLikeModal-component.jsx": [
		98755,
		9,
		98755
	],
	"./components/core/SwapCurrency/SwapCurrency-component": [
		70060,
		9,
		70060
	],
	"./components/core/SwapCurrency/SwapCurrency-component.tsx": [
		70060,
		9,
		70060
	],
	"./components/core/Tables": [
		4187,
		9
	],
	"./components/core/Tables/": [
		4187,
		9
	],
	"./components/core/Tables/Table/PayslipTableSplitView-component": [
		14221,
		9
	],
	"./components/core/Tables/Table/PayslipTableSplitView-component.tsx": [
		14221,
		9
	],
	"./components/core/Tables/Table/PayslipsTableFrame-component": [
		80952,
		9
	],
	"./components/core/Tables/Table/PayslipsTableFrame-component.tsx": [
		80952,
		9
	],
	"./components/core/Tables/Table/PayslipsTableHeader-component": [
		5643,
		9
	],
	"./components/core/Tables/Table/PayslipsTableHeader-component.tsx": [
		5643,
		9
	],
	"./components/core/Tables/Table/TableFrame-component": [
		54672,
		9
	],
	"./components/core/Tables/Table/TableFrame-component.tsx": [
		54672,
		9
	],
	"./components/core/Tables/Table/TableHeader-component": [
		84425,
		9
	],
	"./components/core/Tables/Table/TableHeader-component.tsx": [
		84425,
		9
	],
	"./components/core/Tables/Table/TableHorizontalRows-componet": [
		88104,
		9
	],
	"./components/core/Tables/Table/TableHorizontalRows-componet.tsx": [
		88104,
		9
	],
	"./components/core/Tables/Table/TableSplitView-component": [
		93039,
		9
	],
	"./components/core/Tables/Table/TableSplitView-component.tsx": [
		93039,
		9
	],
	"./components/core/Tables/ThreeColumnTable/ThreeColumnTable": [
		41805,
		9
	],
	"./components/core/Tables/ThreeColumnTable/ThreeColumnTable-styles": [
		15053,
		9
	],
	"./components/core/Tables/ThreeColumnTable/ThreeColumnTable-styles.tsx": [
		15053,
		9
	],
	"./components/core/Tables/ThreeColumnTable/ThreeColumnTable.tsx": [
		41805,
		9
	],
	"./components/core/Tables/index": [
		4187,
		9
	],
	"./components/core/Tables/index.tsx": [
		4187,
		9
	],
	"./components/core/Toast/Toast-component": [
		65609,
		9,
		65609
	],
	"./components/core/Toast/Toast-component.jsx": [
		65609,
		9,
		65609
	],
	"./components/core/Transactions/Payslips": [
		42990,
		9,
		42990
	],
	"./components/core/Transactions/Payslips/": [
		42990,
		9,
		42990
	],
	"./components/core/Transactions/Payslips/index": [
		42990,
		9,
		42990
	],
	"./components/core/Transactions/Payslips/index.tsx": [
		42990,
		9,
		42990
	],
	"./components/core/Transactions/RecentTransactions": [
		30225,
		9,
		30225
	],
	"./components/core/Transactions/RecentTransactions/": [
		30225,
		9,
		30225
	],
	"./components/core/Transactions/RecentTransactions/components/TransactionRow": [
		41885,
		9,
		41885
	],
	"./components/core/Transactions/RecentTransactions/components/TransactionRow.jsx": [
		41885,
		9,
		41885
	],
	"./components/core/Transactions/RecentTransactions/components/TransactionsOverview": [
		83549,
		9,
		83549
	],
	"./components/core/Transactions/RecentTransactions/components/TransactionsOverview.jsx": [
		83549,
		9,
		83549
	],
	"./components/core/Transactions/RecentTransactions/components/styles": [
		99890,
		9,
		99890
	],
	"./components/core/Transactions/RecentTransactions/components/styles.ts": [
		99890,
		9,
		99890
	],
	"./components/core/Transactions/RecentTransactions/index": [
		30225,
		9,
		30225
	],
	"./components/core/Transactions/RecentTransactions/index.jsx": [
		30225,
		9,
		30225
	],
	"./components/core/Transactions/RecentTransactions/styles": [
		87576,
		9,
		87576
	],
	"./components/core/Transactions/RecentTransactions/styles.ts": [
		87576,
		9,
		87576
	],
	"./components/core/Transactions/TransactionsAccountStatement": [
		2525,
		9,
		2525
	],
	"./components/core/Transactions/TransactionsAccountStatement/": [
		2525,
		9,
		2525
	],
	"./components/core/Transactions/TransactionsAccountStatement/index": [
		2525,
		9,
		2525
	],
	"./components/core/Transactions/TransactionsAccountStatement/index.jsx": [
		2525,
		9,
		2525
	],
	"./components/core/Transactions/TransactionsBatchPayment": [
		70079,
		9,
		27161,
		39727,
		20570
	],
	"./components/core/Transactions/TransactionsBatchPayment/": [
		70079,
		9,
		27161,
		39727,
		20570
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities": [
		39727,
		9,
		39727,
		83750
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/": [
		39727,
		9,
		39727,
		83750
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ConfirmPaymentBox": [
		46590,
		9,
		46590
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ConfirmPaymentBox.tsx": [
		46590,
		9,
		46590
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ImportBatchPaymentFile": [
		80864,
		9,
		80864
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ImportBatchPaymentFile.tsx": [
		80864,
		9,
		80864
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ImportedPaymentRow": [
		62733,
		9,
		62733
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/ImportedPaymentRow.tsx": [
		62733,
		9,
		62733
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/NoBatchPaymentData": [
		18788,
		9,
		48385
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/NoBatchPaymentData.tsx": [
		18788,
		9,
		48385
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectPaymentRow": [
		90904,
		9,
		90904
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectPaymentRow.tsx": [
		90904,
		9,
		90904
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentError": [
		77106,
		9,
		77106
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentError.tsx": [
		77106,
		9,
		77106
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentHeader": [
		59531,
		9,
		59531
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentHeader.tsx": [
		59531,
		9,
		59531
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentTableToolbar": [
		36129,
		9,
		36129
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SelectedPaymentTableToolbar.tsx": [
		36129,
		9,
		36129
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SuccessModalText": [
		31072,
		9,
		31072
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/SuccessModalText.tsx": [
		31072,
		9,
		31072
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/VirtualTableRow": [
		55509,
		9,
		55509
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/VirtualTableRow.tsx": [
		55509,
		9,
		55509
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/index": [
		39727,
		9,
		39727,
		83750
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/index.tsx": [
		39727,
		9,
		39727,
		83750
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/styles": [
		34144,
		9,
		34144
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/BatchPaymentUtilities/styles.ts": [
		34144,
		9,
		34144
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/ImportedPaymentsTable": [
		35407,
		9,
		27161,
		39727,
		55385
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/ImportedPaymentsTable.tsx": [
		35407,
		9,
		27161,
		39727,
		55385
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment": [
		44164,
		9,
		6591,
		30663,
		39727,
		44164
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/": [
		44164,
		9,
		6591,
		30663,
		39727,
		44164
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/components/SelectedPaymentTable": [
		53285,
		9,
		6591,
		30663,
		39727,
		53285
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/components/SelectedPaymentTable.tsx": [
		53285,
		9,
		6591,
		30663,
		39727,
		53285
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/components/VirtuosoTableComponents": [
		71057,
		9,
		6591,
		39727,
		71057
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/components/VirtuosoTableComponents.tsx": [
		71057,
		9,
		6591,
		39727,
		71057
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/helpers": [
		88672,
		9,
		88672
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/helpers.ts": [
		88672,
		9,
		88672
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/index": [
		44164,
		9,
		6591,
		30663,
		39727,
		44164
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/index.tsx": [
		44164,
		9,
		6591,
		30663,
		39727,
		44164
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/styles": [
		30285,
		9,
		30285
	],
	"./components/core/Transactions/TransactionsBatchPayment/components/SelectedPayment/styles.ts": [
		30285,
		9,
		30285
	],
	"./components/core/Transactions/TransactionsBatchPayment/index": [
		70079,
		9,
		27161,
		39727,
		20570
	],
	"./components/core/Transactions/TransactionsBatchPayment/index.tsx": [
		70079,
		9,
		27161,
		39727,
		20570
	],
	"./components/core/Transactions/TransactionsBatchPayment/styles": [
		84555,
		9,
		84555
	],
	"./components/core/Transactions/TransactionsBatchPayment/styles.ts": [
		84555,
		9,
		84555
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge": [
		87347,
		9,
		87347
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge/": [
		87347,
		9,
		87347
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge/index": [
		87347,
		9,
		87347
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge/index.tsx": [
		87347,
		9,
		87347
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge/styles": [
		65702,
		9,
		65702
	],
	"./components/core/Transactions/TransactionsDocumentRequestBadge/styles.ts": [
		65702,
		9,
		65702
	],
	"./components/core/Transactions/TransactionsHistory": [
		63804,
		9,
		27161,
		95399,
		42636
	],
	"./components/core/Transactions/TransactionsHistory/": [
		63804,
		9,
		27161,
		95399,
		42636
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionRow": [
		66682,
		9,
		66682
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionRow.jsx": [
		66682,
		9,
		66682
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsDateHeading": [
		46297,
		9,
		46297
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsDateHeading.tsx": [
		46297,
		9,
		46297
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsFilter": [
		73713,
		9,
		95399,
		73713
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsFilter.jsx": [
		73713,
		9,
		95399,
		73713
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsTable": [
		90138,
		9,
		27161,
		90138
	],
	"./components/core/Transactions/TransactionsHistory/components/TransactionsTable.jsx": [
		90138,
		9,
		27161,
		90138
	],
	"./components/core/Transactions/TransactionsHistory/index": [
		63804,
		9,
		27161,
		95399,
		42636
	],
	"./components/core/Transactions/TransactionsHistory/index.tsx": [
		63804,
		9,
		27161,
		95399,
		42636
	],
	"./components/core/Transactions/TransactionsHistory/styles": [
		88158,
		9,
		88158
	],
	"./components/core/Transactions/TransactionsHistory/styles.ts": [
		88158,
		9,
		88158
	],
	"./components/core/Transactions/TransactionsTabs": [
		678,
		9,
		678
	],
	"./components/core/Transactions/TransactionsTabs/": [
		678,
		9,
		678
	],
	"./components/core/Transactions/TransactionsTabs/components/TabPanel": [
		90094,
		9,
		90094
	],
	"./components/core/Transactions/TransactionsTabs/components/TabPanel.tsx": [
		90094,
		9,
		90094
	],
	"./components/core/Transactions/TransactionsTabs/components/Tabs": [
		84719,
		9,
		84719
	],
	"./components/core/Transactions/TransactionsTabs/components/Tabs.tsx": [
		84719,
		9,
		84719
	],
	"./components/core/Transactions/TransactionsTabs/index": [
		678,
		9,
		678
	],
	"./components/core/Transactions/TransactionsTabs/index.tsx": [
		678,
		9,
		678
	],
	"./components/core/Transactions/TransactionsTabs/styles": [
		62294,
		9,
		62294
	],
	"./components/core/Transactions/TransactionsTabs/styles.ts": [
		62294,
		9,
		62294
	],
	"./components/core/Transactions/TransactionsTabs/tabs": [
		11950,
		9,
		11950
	],
	"./components/core/Transactions/TransactionsTabs/tabs.tsx": [
		11950,
		9,
		11950
	],
	"./components/core/Transactions/TransactionsViewModal": [
		8013,
		9,
		48914,
		8013
	],
	"./components/core/Transactions/TransactionsViewModal/": [
		8013,
		9,
		48914,
		8013
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent": [
		48914,
		9,
		48914
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/": [
		48914,
		9,
		48914
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/BalanceAdjustment": [
		79815,
		9,
		79815
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/BalanceAdjustment.tsx": [
		79815,
		9,
		79815
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo": [
		51112,
		9,
		51112
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo/": [
		51112,
		9,
		51112
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo/index": [
		51112,
		9,
		51112
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo/index.tsx": [
		51112,
		9,
		51112
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo/styles": [
		28748,
		9,
		28748
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/AdditionalInfo/styles.ts": [
		28748,
		9,
		28748
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/ApproveTransactionButton": [
		47213,
		9,
		47213
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/ApproveTransactionButton.tsx": [
		47213,
		9,
		47213
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox": [
		8916,
		9,
		8916
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox/": [
		8916,
		9,
		8916
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox/index": [
		8916,
		9,
		8916
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox/index.tsx": [
		8916,
		9,
		8916
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox/styles": [
		53231,
		9,
		53231
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/BottomPaymentBox/styles.ts": [
		53231,
		9,
		53231
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/ButtonsAssembly": [
		20212,
		9,
		20212
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/ButtonsAssembly.tsx": [
		20212,
		9,
		20212
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/CancelTransactionButton": [
		34729,
		9,
		34729
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/CancelTransactionButton.jsx": [
		34729,
		9,
		34729
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/CompleteTransactionButton": [
		78098,
		9,
		78098
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/CompleteTransactionButton.jsx": [
		78098,
		9,
		78098
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/DropDownComp": [
		70881,
		9,
		70881
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/DropDownComp.jsx": [
		70881,
		9,
		70881
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput": [
		86520,
		9,
		87705,
		86520
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput/": [
		86520,
		9,
		87705,
		86520
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput/index": [
		86520,
		9,
		87705,
		86520
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput/index.tsx": [
		86520,
		9,
		87705,
		86520
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput/styles": [
		67347,
		9,
		67347
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/NoteInput/styles.tsx": [
		67347,
		9,
		67347
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/PayTransactionButton": [
		57629,
		9,
		57629
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/PayTransactionButton.jsx": [
		57629,
		9,
		57629
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList": [
		56773,
		9,
		56773
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList/": [
		56773,
		9,
		56773
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList/index": [
		56773,
		9,
		56773
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList/index.tsx": [
		56773,
		9,
		56773
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList/styles": [
		44011,
		9,
		44011
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/RequiredDocumentsList/styles.ts": [
		44011,
		9,
		44011
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox": [
		21069,
		9,
		21069
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox/": [
		21069,
		9,
		21069
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox/index": [
		21069,
		9,
		21069
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox/index.tsx": [
		21069,
		9,
		21069
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox/styles": [
		79928,
		9,
		79928
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TopPaymentBox/styles.tsx": [
		79928,
		9,
		79928
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TransactionDownloadables": [
		19483,
		9,
		19483
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/TransactionDownloadables.jsx": [
		19483,
		9,
		19483
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/payslipRenderProps": [
		67517,
		9,
		31184
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/components/payslipRenderProps.jsx": [
		67517,
		9,
		31184
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/index": [
		48914,
		9,
		48914
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/index.jsx": [
		48914,
		9,
		48914
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/styles": [
		1103,
		9,
		1103
	],
	"./components/core/Transactions/TransactionsViewModal/TransactionsViewModalContent/styles.tsx": [
		1103,
		9,
		1103
	],
	"./components/core/Transactions/TransactionsViewModal/index": [
		8013,
		9,
		48914,
		8013
	],
	"./components/core/Transactions/TransactionsViewModal/index.tsx": [
		8013,
		9,
		48914,
		8013
	],
	"./components/core/UserHandler": [
		81360,
		9
	],
	"./components/core/UserHandler/": [
		81360,
		9
	],
	"./components/core/UserHandler/index": [
		81360,
		9
	],
	"./components/core/UserHandler/index.tsx": [
		81360,
		9
	],
	"./components/core/Verifications/GPVerificationForm-component": [
		40371,
		9,
		40371
	],
	"./components/core/Verifications/GPVerificationForm-component.jsx": [
		40371,
		9,
		40371
	],
	"./components/core/Verifications/SSVerificationForm-component": [
		23406,
		9,
		23406
	],
	"./components/core/Verifications/SSVerificationForm-component.jsx": [
		23406,
		9,
		23406
	],
	"./components/core/Wizard/Connector": [
		13924,
		9,
		13924
	],
	"./components/core/Wizard/Connector/": [
		13924,
		9,
		13924
	],
	"./components/core/Wizard/Connector/index": [
		13924,
		9,
		13924
	],
	"./components/core/Wizard/Connector/index.tsx": [
		13924,
		9,
		13924
	],
	"./components/core/Wizard/OnboardingWizard": [
		32762,
		9,
		32762
	],
	"./components/core/Wizard/OnboardingWizard/": [
		32762,
		9,
		32762
	],
	"./components/core/Wizard/OnboardingWizard/components/CurrentComponent": [
		90230,
		9,
		90230
	],
	"./components/core/Wizard/OnboardingWizard/components/CurrentComponent.tsx": [
		90230,
		9,
		90230
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard": [
		57296,
		9,
		57296
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard/": [
		57296,
		9,
		57296
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard/index": [
		57296,
		9,
		57296
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard/index.tsx": [
		57296,
		9,
		57296
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard/styles": [
		85236,
		9,
		85236
	],
	"./components/core/Wizard/OnboardingWizard/components/DocumentsCard/styles.ts": [
		85236,
		9,
		85236
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard": [
		65808,
		9,
		65808
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard/": [
		65808,
		9,
		65808
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard/index": [
		65808,
		9,
		65808
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard/index.tsx": [
		65808,
		9,
		65808
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard/styles": [
		51456,
		9,
		51456
	],
	"./components/core/Wizard/OnboardingWizard/components/KycSectionCard/styles.ts": [
		51456,
		9,
		51456
	],
	"./components/core/Wizard/OnboardingWizard/components/OnboardingStepper": [
		28383,
		9,
		69584,
		28383
	],
	"./components/core/Wizard/OnboardingWizard/components/OnboardingStepper.tsx": [
		28383,
		9,
		69584,
		28383
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard": [
		47983,
		9,
		87705,
		57502,
		47983
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard/": [
		47983,
		9,
		87705,
		57502,
		47983
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard/index": [
		47983,
		9,
		87705,
		57502,
		47983
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard/index.tsx": [
		47983,
		9,
		87705,
		57502,
		47983
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard/styles": [
		58922,
		9,
		58922
	],
	"./components/core/Wizard/OnboardingWizard/components/QuestionnaireCard/styles.ts": [
		58922,
		9,
		58922
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard": [
		88979,
		9,
		88979
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard/": [
		88979,
		9,
		88979
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard/index": [
		88979,
		9,
		88979
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard/index.tsx": [
		88979,
		9,
		88979
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard/styles": [
		80506,
		9,
		80506
	],
	"./components/core/Wizard/OnboardingWizard/components/SuccessCard/styles.ts": [
		80506,
		9,
		80506
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard": [
		30834,
		9,
		30834
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard/": [
		30834,
		9,
		30834
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard/index": [
		30834,
		9,
		30834
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard/index.tsx": [
		30834,
		9,
		30834
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard/styles": [
		81409,
		9,
		81409
	],
	"./components/core/Wizard/OnboardingWizard/components/WelcomeCard/styles.ts": [
		81409,
		9,
		81409
	],
	"./components/core/Wizard/OnboardingWizard/index": [
		32762,
		9,
		32762
	],
	"./components/core/Wizard/OnboardingWizard/index.tsx": [
		32762,
		9,
		32762
	],
	"./components/core/Wizard/PaymentGatewayWizard": [
		21944,
		9,
		21944
	],
	"./components/core/Wizard/PaymentGatewayWizard/": [
		21944,
		9,
		21944
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/CurrentComponent": [
		65289,
		9,
		65289
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/CurrentComponent.tsx": [
		65289,
		9,
		65289
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/OnboardingStepper": [
		67749,
		9,
		69584,
		18619
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/OnboardingStepper.tsx": [
		67749,
		9,
		69584,
		18619
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard": [
		71694,
		9,
		71694
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard/": [
		71694,
		9,
		71694
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard/index": [
		71694,
		9,
		71694
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard/index.tsx": [
		71694,
		9,
		71694
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard/styles": [
		11429,
		9,
		11429
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/PaymentCard/styles.ts": [
		11429,
		9,
		11429
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard": [
		23470,
		9,
		23470
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard/": [
		23470,
		9,
		23470
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard/index": [
		23470,
		9,
		23470
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard/index.tsx": [
		23470,
		9,
		23470
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard/styles": [
		36536,
		9,
		36536
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/QuestionnaireCard/styles.ts": [
		36536,
		9,
		36536
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard": [
		9366,
		9,
		9366
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard/": [
		9366,
		9,
		9366
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard/index": [
		9366,
		9,
		9366
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard/index.tsx": [
		9366,
		9,
		9366
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard/styles": [
		42154,
		9,
		42154
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/SuccessCard/styles.ts": [
		42154,
		9,
		42154
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard": [
		79057,
		9,
		79057
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard/": [
		79057,
		9,
		79057
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard/index": [
		79057,
		9,
		79057
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard/index.tsx": [
		79057,
		9,
		79057
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard/styles": [
		77343,
		9,
		77343
	],
	"./components/core/Wizard/PaymentGatewayWizard/components/WelcomeCard/styles.ts": [
		77343,
		9,
		77343
	],
	"./components/core/Wizard/PaymentGatewayWizard/index": [
		21944,
		9,
		21944
	],
	"./components/core/Wizard/PaymentGatewayWizard/index.tsx": [
		21944,
		9,
		21944
	],
	"./components/formDisplays": [
		42428,
		9,
		42428
	],
	"./components/formDisplays/": [
		42428,
		9,
		42428
	],
	"./components/formDisplays/IFormAssetDisplay": [
		14914,
		9,
		14914
	],
	"./components/formDisplays/IFormAssetDisplay/": [
		14914,
		9,
		14914
	],
	"./components/formDisplays/IFormAssetDisplay/index": [
		14914,
		9,
		14914
	],
	"./components/formDisplays/IFormAssetDisplay/index.tsx": [
		14914,
		9,
		14914
	],
	"./components/formDisplays/IFormAssetDisplay/styles": [
		83771,
		9,
		83771
	],
	"./components/formDisplays/IFormAssetDisplay/styles.ts": [
		83771,
		9,
		83771
	],
	"./components/formDisplays/index": [
		42428,
		9,
		42428
	],
	"./components/formDisplays/index.ts": [
		42428,
		9,
		42428
	],
	"./components/formElements": [
		94659,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659
	],
	"./components/formElements/": [
		94659,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659
	],
	"./components/formElements/IForm": [
		39314,
		9,
		87705,
		39314
	],
	"./components/formElements/IForm/": [
		39314,
		9,
		87705,
		39314
	],
	"./components/formElements/IForm/index": [
		39314,
		9,
		87705,
		39314
	],
	"./components/formElements/IForm/index.tsx": [
		39314,
		9,
		87705,
		39314
	],
	"./components/formElements/IForm/styles": [
		48631,
		9,
		48631
	],
	"./components/formElements/IForm/styles.ts": [
		48631,
		9,
		48631
	],
	"./components/formElements/IFormAmountInput": [
		95078,
		9,
		87705,
		95078
	],
	"./components/formElements/IFormAmountInput/": [
		95078,
		9,
		87705,
		95078
	],
	"./components/formElements/IFormAmountInput/components/MaxButton": [
		12354,
		9,
		12354
	],
	"./components/formElements/IFormAmountInput/components/MaxButton/": [
		12354,
		9,
		12354
	],
	"./components/formElements/IFormAmountInput/components/MaxButton/index": [
		12354,
		9,
		12354
	],
	"./components/formElements/IFormAmountInput/components/MaxButton/index.tsx": [
		12354,
		9,
		12354
	],
	"./components/formElements/IFormAmountInput/components/MaxButton/styles": [
		23921,
		9,
		23921
	],
	"./components/formElements/IFormAmountInput/components/MaxButton/styles.ts": [
		23921,
		9,
		23921
	],
	"./components/formElements/IFormAmountInput/index": [
		95078,
		9,
		87705,
		95078
	],
	"./components/formElements/IFormAmountInput/index.tsx": [
		95078,
		9,
		87705,
		95078
	],
	"./components/formElements/IFormAmountInput/styles": [
		13375,
		9,
		13375
	],
	"./components/formElements/IFormAmountInput/styles.ts": [
		13375,
		9,
		13375
	],
	"./components/formElements/IFormAmountInput/utils": [
		91451,
		9,
		91451
	],
	"./components/formElements/IFormAmountInput/utils.ts": [
		91451,
		9,
		91451
	],
	"./components/formElements/IFormAssetSelection": [
		43083,
		9,
		87705,
		43083
	],
	"./components/formElements/IFormAssetSelection/": [
		43083,
		9,
		87705,
		43083
	],
	"./components/formElements/IFormAssetSelection/index": [
		43083,
		9,
		87705,
		43083
	],
	"./components/formElements/IFormAssetSelection/index.tsx": [
		43083,
		9,
		87705,
		43083
	],
	"./components/formElements/IFormAssetSelection/styles": [
		7851,
		9,
		7851
	],
	"./components/formElements/IFormAssetSelection/styles.ts": [
		7851,
		9,
		7851
	],
	"./components/formElements/IFormCheckbox": [
		44841,
		9,
		87705,
		44841
	],
	"./components/formElements/IFormCheckbox/": [
		44841,
		9,
		87705,
		44841
	],
	"./components/formElements/IFormCheckbox/IFormCheckbox.stories": [
		87301,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		87301
	],
	"./components/formElements/IFormCheckbox/IFormCheckbox.stories.tsx": [
		87301,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		87301
	],
	"./components/formElements/IFormCheckbox/index": [
		44841,
		9,
		87705,
		44841
	],
	"./components/formElements/IFormCheckbox/index.tsx": [
		44841,
		9,
		87705,
		44841
	],
	"./components/formElements/IFormCountrySelect": [
		65499,
		9,
		87705,
		12136,
		65499
	],
	"./components/formElements/IFormCountrySelect/": [
		65499,
		9,
		87705,
		12136,
		65499
	],
	"./components/formElements/IFormCountrySelect/index": [
		65499,
		9,
		87705,
		12136,
		65499
	],
	"./components/formElements/IFormCountrySelect/index.tsx": [
		65499,
		9,
		87705,
		12136,
		65499
	],
	"./components/formElements/IFormDateTimePicker": [
		30471,
		9,
		87705,
		14251,
		30471
	],
	"./components/formElements/IFormDateTimePicker/": [
		30471,
		9,
		87705,
		14251,
		30471
	],
	"./components/formElements/IFormDateTimePicker/IFormDateTimePicker.stories": [
		22041,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		22041
	],
	"./components/formElements/IFormDateTimePicker/IFormDateTimePicker.stories.tsx": [
		22041,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		22041
	],
	"./components/formElements/IFormDateTimePicker/index": [
		30471,
		9,
		87705,
		14251,
		30471
	],
	"./components/formElements/IFormDateTimePicker/index.tsx": [
		30471,
		9,
		87705,
		14251,
		30471
	],
	"./components/formElements/IFormFileUpload": [
		32228,
		9,
		87705,
		18267,
		32228
	],
	"./components/formElements/IFormFileUpload/": [
		32228,
		9,
		87705,
		18267,
		32228
	],
	"./components/formElements/IFormFileUpload/index": [
		32228,
		9,
		87705,
		18267,
		32228
	],
	"./components/formElements/IFormFileUpload/index.tsx": [
		32228,
		9,
		87705,
		18267,
		32228
	],
	"./components/formElements/IFormFileUpload/styles": [
		24709,
		9,
		24709
	],
	"./components/formElements/IFormFileUpload/styles.ts": [
		24709,
		9,
		24709
	],
	"./components/formElements/IFormInput": [
		18377,
		9,
		87705,
		16409
	],
	"./components/formElements/IFormInput/": [
		18377,
		9,
		87705,
		16409
	],
	"./components/formElements/IFormInput/IFormInput.stories": [
		63510,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		63510
	],
	"./components/formElements/IFormInput/IFormInput.stories.tsx": [
		63510,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		63510
	],
	"./components/formElements/IFormInput/index": [
		18377,
		9,
		87705,
		16409
	],
	"./components/formElements/IFormInput/index.tsx": [
		18377,
		9,
		87705,
		16409
	],
	"./components/formElements/IFormPostCodeInput": [
		11109,
		9,
		87705,
		11109
	],
	"./components/formElements/IFormPostCodeInput/": [
		11109,
		9,
		87705,
		11109
	],
	"./components/formElements/IFormPostCodeInput/customValidator": [
		92448,
		9,
		92448
	],
	"./components/formElements/IFormPostCodeInput/customValidator.ts": [
		92448,
		9,
		92448
	],
	"./components/formElements/IFormPostCodeInput/index": [
		11109,
		9,
		87705,
		11109
	],
	"./components/formElements/IFormPostCodeInput/index.tsx": [
		11109,
		9,
		87705,
		11109
	],
	"./components/formElements/IFormSelect": [
		63133,
		9,
		87705,
		63133
	],
	"./components/formElements/IFormSelect/": [
		63133,
		9,
		87705,
		63133
	],
	"./components/formElements/IFormSelect/IFormSelect.stories": [
		63181,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		63181
	],
	"./components/formElements/IFormSelect/IFormSelect.stories.tsx": [
		63181,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		63181
	],
	"./components/formElements/IFormSelect/index": [
		63133,
		9,
		87705,
		63133
	],
	"./components/formElements/IFormSelect/index.tsx": [
		63133,
		9,
		87705,
		63133
	],
	"./components/formElements/IFormSelection": [
		26965,
		9,
		87705,
		26965
	],
	"./components/formElements/IFormSelection/": [
		26965,
		9,
		87705,
		26965
	],
	"./components/formElements/IFormSelection/IFormSelection.interface": [
		95364,
		9,
		95364
	],
	"./components/formElements/IFormSelection/IFormSelection.interface.ts": [
		95364,
		9,
		95364
	],
	"./components/formElements/IFormSelection/IFormSelection.stories": [
		88315,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		88315
	],
	"./components/formElements/IFormSelection/IFormSelection.stories.tsx": [
		88315,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		88315
	],
	"./components/formElements/IFormSelection/index": [
		26965,
		9,
		87705,
		26965
	],
	"./components/formElements/IFormSelection/index.tsx": [
		26965,
		9,
		87705,
		26965
	],
	"./components/formElements/IFormSelection/styles": [
		10902,
		9,
		10902
	],
	"./components/formElements/IFormSelection/styles.ts": [
		10902,
		9,
		10902
	],
	"./components/formElements/IFormStoryWrapper": [
		56519,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		56519
	],
	"./components/formElements/IFormStoryWrapper/": [
		56519,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		56519
	],
	"./components/formElements/IFormStoryWrapper/index": [
		56519,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		56519
	],
	"./components/formElements/IFormStoryWrapper/index.tsx": [
		56519,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		56519
	],
	"./components/formElements/IFormSubmit": [
		72516,
		9,
		72516
	],
	"./components/formElements/IFormSubmit/": [
		72516,
		9,
		72516
	],
	"./components/formElements/IFormSubmit/index": [
		72516,
		9,
		72516
	],
	"./components/formElements/IFormSubmit/index.tsx": [
		72516,
		9,
		72516
	],
	"./components/formElements/IFormSwitch": [
		11847,
		9,
		87705,
		90606,
		11847
	],
	"./components/formElements/IFormSwitch/": [
		11847,
		9,
		87705,
		90606,
		11847
	],
	"./components/formElements/IFormSwitch/IFormSwitch.stories": [
		86838,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		86838
	],
	"./components/formElements/IFormSwitch/IFormSwitch.stories.tsx": [
		86838,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659,
		86838
	],
	"./components/formElements/IFormSwitch/index": [
		11847,
		9,
		87705,
		90606,
		11847
	],
	"./components/formElements/IFormSwitch/index.tsx": [
		11847,
		9,
		87705,
		90606,
		11847
	],
	"./components/formElements/formHelpers": [
		88689,
		9,
		88689
	],
	"./components/formElements/formHelpers.ts": [
		88689,
		9,
		88689
	],
	"./components/formElements/index": [
		94659,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659
	],
	"./components/formElements/index.ts": [
		94659,
		9,
		87705,
		18267,
		12136,
		14251,
		90606,
		84377,
		94659
	],
	"./components/layouts/HomePageLayout": [
		4826,
		9,
		4826
	],
	"./components/layouts/HomePageLayout/": [
		4826,
		9,
		4826
	],
	"./components/layouts/HomePageLayout/index": [
		4826,
		9,
		4826
	],
	"./components/layouts/HomePageLayout/index.tsx": [
		4826,
		9,
		4826
	],
	"./components/layouts/HomePageLayout/styles": [
		83505,
		9,
		83505
	],
	"./components/layouts/HomePageLayout/styles.ts": [
		83505,
		9,
		83505
	],
	"./components/layouts/LegalPagesLayout": [
		14719,
		9,
		14719
	],
	"./components/layouts/LegalPagesLayout/": [
		14719,
		9,
		14719
	],
	"./components/layouts/LegalPagesLayout/components/GradientFooter": [
		96699,
		9,
		96699
	],
	"./components/layouts/LegalPagesLayout/components/GradientFooter.tsx": [
		96699,
		9,
		96699
	],
	"./components/layouts/LegalPagesLayout/components/GradientHeader": [
		84324,
		9,
		84324
	],
	"./components/layouts/LegalPagesLayout/components/GradientHeader.tsx": [
		84324,
		9,
		84324
	],
	"./components/layouts/LegalPagesLayout/components/LegalPagesLayoutFooter": [
		19346,
		9,
		19346
	],
	"./components/layouts/LegalPagesLayout/components/LegalPagesLayoutFooter.tsx": [
		19346,
		9,
		19346
	],
	"./components/layouts/LegalPagesLayout/components/LegalPagesLayoutHeader": [
		35965,
		9,
		35965
	],
	"./components/layouts/LegalPagesLayout/components/LegalPagesLayoutHeader.tsx": [
		35965,
		9,
		35965
	],
	"./components/layouts/LegalPagesLayout/index": [
		14719,
		9,
		14719
	],
	"./components/layouts/LegalPagesLayout/index.tsx": [
		14719,
		9,
		14719
	],
	"./components/layouts/LegalPagesLayout/styles": [
		30964,
		9,
		30964
	],
	"./components/layouts/LegalPagesLayout/styles.ts": [
		30964,
		9,
		30964
	],
	"./components/layouts/NavBannerLayout": [
		65373,
		9,
		38374,
		65373
	],
	"./components/layouts/NavBannerLayout/": [
		65373,
		9,
		38374,
		65373
	],
	"./components/layouts/NavBannerLayout/index": [
		65373,
		9,
		38374,
		65373
	],
	"./components/layouts/NavBannerLayout/index.tsx": [
		65373,
		9,
		38374,
		65373
	],
	"./components/layouts/NavBannerLayout/styles": [
		98785,
		9,
		98785
	],
	"./components/layouts/NavBannerLayout/styles.ts": [
		98785,
		9,
		98785
	],
	"./components/layouts/SingleContainerLayout": [
		51299,
		9,
		51299
	],
	"./components/layouts/SingleContainerLayout/": [
		51299,
		9,
		51299
	],
	"./components/layouts/SingleContainerLayout/components/SingleContainerLayoutHeader": [
		71452,
		9,
		71452
	],
	"./components/layouts/SingleContainerLayout/components/SingleContainerLayoutHeader.tsx": [
		71452,
		9,
		71452
	],
	"./components/layouts/SingleContainerLayout/index": [
		51299,
		9,
		51299
	],
	"./components/layouts/SingleContainerLayout/index.tsx": [
		51299,
		9,
		51299
	],
	"./components/layouts/SingleContainerLayout/styles": [
		31419,
		9,
		31419
	],
	"./components/layouts/SingleContainerLayout/styles.ts": [
		31419,
		9,
		31419
	],
	"./components/modals": [
		42054,
		9
	],
	"./components/modals/": [
		42054,
		9
	],
	"./components/modals/BusinessApply": [
		59696,
		9,
		59696
	],
	"./components/modals/BusinessApply/": [
		59696,
		9,
		59696
	],
	"./components/modals/BusinessApply/index": [
		59696,
		9,
		59696
	],
	"./components/modals/BusinessApply/index.tsx": [
		59696,
		9,
		59696
	],
	"./components/modals/ConfirmationModal": [
		45991,
		9,
		45991
	],
	"./components/modals/ConfirmationModal/": [
		45991,
		9,
		45991
	],
	"./components/modals/ConfirmationModal/confirmationModal.interface": [
		27953,
		9,
		27953
	],
	"./components/modals/ConfirmationModal/confirmationModal.interface.ts": [
		27953,
		9,
		27953
	],
	"./components/modals/ConfirmationModal/index": [
		45991,
		9,
		45991
	],
	"./components/modals/ConfirmationModal/index.tsx": [
		45991,
		9,
		45991
	],
	"./components/modals/ConfirmationModal/useConfirmationModal": [
		40562,
		9,
		40562
	],
	"./components/modals/ConfirmationModal/useConfirmationModal.ts": [
		40562,
		9,
		40562
	],
	"./components/modals/EmailResetModal": [
		35212,
		9,
		35212
	],
	"./components/modals/EmailResetModal/": [
		35212,
		9,
		35212
	],
	"./components/modals/EmailResetModal/index": [
		35212,
		9,
		35212
	],
	"./components/modals/EmailResetModal/index.tsx": [
		35212,
		9,
		35212
	],
	"./components/modals/ShippingAddressFormModal": [
		66355,
		9,
		66355
	],
	"./components/modals/ShippingAddressFormModal/": [
		66355,
		9,
		66355
	],
	"./components/modals/ShippingAddressFormModal/index": [
		66355,
		9,
		66355
	],
	"./components/modals/ShippingAddressFormModal/index.tsx": [
		66355,
		9,
		66355
	],
	"./components/modals/index": [
		42054,
		9
	],
	"./components/modals/index.tsx": [
		42054,
		9
	],
	"./components/modals/modals.interface": [
		9416,
		9,
		9416
	],
	"./components/modals/modals.interface.ts": [
		9416,
		9,
		9416
	],
	"./hooks/": [
		55405,
		9,
		55405
	],
	"./hooks/handler3DSecure": [
		30363,
		9
	],
	"./hooks/handler3DSecure.jsx": [
		30363,
		9
	],
	"./hooks/hooks": [
		98525,
		9,
		71171
	],
	"./hooks/hooks.tsx": [
		98525,
		9,
		71171
	],
	"./hooks/index": [
		55405,
		9,
		55405
	],
	"./hooks/index.ts": [
		55405,
		9,
		55405
	],
	"./hooks/scrollTo": [
		94416,
		9
	],
	"./hooks/scrollTo.jsx": [
		94416,
		9
	],
	"./hooks/sectionOptions": [
		98411,
		9,
		98411
	],
	"./hooks/sectionOptions.jsx": [
		98411,
		9,
		98411
	],
	"./hooks/use2FA": [
		66212,
		9,
		66212
	],
	"./hooks/use2FA.jsx": [
		66212,
		9,
		66212
	],
	"./hooks/useCheckIban": [
		7450,
		9,
		87705,
		7450
	],
	"./hooks/useCheckIban.jsx": [
		7450,
		9,
		87705,
		7450
	],
	"./hooks/useCookie": [
		20420,
		9,
		20420
	],
	"./hooks/useCookie.jsx": [
		20420,
		9,
		20420
	],
	"./hooks/useCountries": [
		59268,
		9,
		59268
	],
	"./hooks/useCountries.tsx": [
		59268,
		9,
		59268
	],
	"./hooks/useDateRangePicker": [
		32778,
		9
	],
	"./hooks/useDateRangePicker.ts": [
		32778,
		9
	],
	"./hooks/useFeeCalculation": [
		74036,
		9,
		74036
	],
	"./hooks/useFeeCalculation/": [
		74036,
		9,
		74036
	],
	"./hooks/useFeeCalculation/DefaultSummary": [
		48042,
		9,
		48042
	],
	"./hooks/useFeeCalculation/DefaultSummary.tsx": [
		48042,
		9,
		48042
	],
	"./hooks/useFeeCalculation/ExtendedSummaryWithRate": [
		32352,
		9,
		32352
	],
	"./hooks/useFeeCalculation/ExtendedSummaryWithRate.tsx": [
		32352,
		9,
		32352
	],
	"./hooks/useFeeCalculation/ExtendedSummaryWithTotalToSpendText": [
		25386,
		9,
		25386
	],
	"./hooks/useFeeCalculation/ExtendedSummaryWithTotalToSpendText.tsx": [
		25386,
		9,
		25386
	],
	"./hooks/useFeeCalculation/index": [
		74036,
		9,
		74036
	],
	"./hooks/useFeeCalculation/index.tsx": [
		74036,
		9,
		74036
	],
	"./hooks/useFeeCalculation/useFeeCalculation-state": [
		18902,
		9,
		18902
	],
	"./hooks/useFeeCalculation/useFeeCalculation-state.ts": [
		18902,
		9,
		18902
	],
	"./hooks/useFileUpload": [
		71464,
		9,
		18267,
		71464
	],
	"./hooks/useFileUpload.jsx": [
		71464,
		9,
		18267,
		71464
	],
	"./hooks/useFullwidthModalDetect": [
		59261,
		9
	],
	"./hooks/useFullwidthModalDetect.ts": [
		59261,
		9
	],
	"./hooks/useHover": [
		45346,
		9
	],
	"./hooks/useHover.tsx": [
		45346,
		9
	],
	"./hooks/usePasswordHints": [
		10194,
		9,
		10194
	],
	"./hooks/usePasswordHints.js": [
		10194,
		9,
		10194
	],
	"./hooks/usePermissions": [
		31467,
		9
	],
	"./hooks/usePermissions.jsx": [
		31467,
		9
	],
	"./hooks/usePhoneVerification": [
		41061,
		9,
		41061
	],
	"./hooks/usePhoneVerification.jsx": [
		41061,
		9,
		41061
	],
	"./hooks/useQueryParams": [
		4766,
		9
	],
	"./hooks/useQueryParams.ts": [
		4766,
		9
	],
	"./hooks/useReCaptcha": [
		37005,
		9,
		37005
	],
	"./hooks/useReCaptcha.tsx": [
		37005,
		9,
		37005
	],
	"./hooks/useScript": [
		22520,
		9,
		22520
	],
	"./hooks/useScript.jsx": [
		22520,
		9,
		22520
	],
	"./hooks/useSocialAuthentication": [
		37057,
		9,
		64972,
		16385
	],
	"./hooks/useSocialAuthentication.ts": [
		37057,
		9,
		64972,
		16385
	],
	"./hooks/useSumsubListener": [
		37522,
		9,
		37522
	],
	"./hooks/useSumsubListener.jsx": [
		37522,
		9,
		37522
	],
	"./hooks/useWhitelabelThemeWrapper": [
		31684,
		9,
		31684
	],
	"./hooks/useWhitelabelThemeWrapper.ts": [
		31684,
		9,
		31684
	],
	"./hooks/useWindowDimensions": [
		57154,
		9
	],
	"./hooks/useWindowDimensions.jsx": [
		57154,
		9
	],
	"./pages/AccountLinking": [
		69999,
		9
	],
	"./pages/AccountLinking/": [
		69999,
		9
	],
	"./pages/AccountLinking/index": [
		69999,
		9
	],
	"./pages/AccountLinking/index.tsx": [
		69999,
		9
	],
	"./pages/AccountPage": [
		67859,
		9
	],
	"./pages/AccountPage/": [
		67859,
		9
	],
	"./pages/AccountPage/index": [
		67859,
		9
	],
	"./pages/AccountPage/index.tsx": [
		67859,
		9
	],
	"./pages/AccountPage/styles": [
		99375,
		9
	],
	"./pages/AccountPage/styles.ts": [
		99375,
		9
	],
	"./pages/Acquiring": [
		53680,
		9
	],
	"./pages/Acquiring/": [
		53680,
		9
	],
	"./pages/Acquiring/index": [
		53680,
		9
	],
	"./pages/Acquiring/index.tsx": [
		53680,
		9
	],
	"./pages/BatchPayment": [
		63832,
		9
	],
	"./pages/BatchPayment/": [
		63832,
		9
	],
	"./pages/BatchPayment/index": [
		63832,
		9
	],
	"./pages/BatchPayment/index.tsx": [
		63832,
		9
	],
	"./pages/CompanyApplication": [
		95765,
		9
	],
	"./pages/CompanyApplication/": [
		95765,
		9
	],
	"./pages/CompanyApplication/index": [
		95765,
		9
	],
	"./pages/CompanyApplication/index.tsx": [
		95765,
		9
	],
	"./pages/DynamicForm": [
		31002,
		9
	],
	"./pages/DynamicForm/": [
		31002,
		9
	],
	"./pages/DynamicForm/index": [
		31002,
		9
	],
	"./pages/DynamicForm/index.tsx": [
		31002,
		9
	],
	"./pages/ForgotPassword": [
		78264,
		9
	],
	"./pages/ForgotPassword/": [
		78264,
		9
	],
	"./pages/ForgotPassword/index": [
		78264,
		9
	],
	"./pages/ForgotPassword/index.tsx": [
		78264,
		9
	],
	"./pages/IndividualApplication": [
		51344,
		9
	],
	"./pages/IndividualApplication/": [
		51344,
		9
	],
	"./pages/IndividualApplication/index": [
		51344,
		9
	],
	"./pages/IndividualApplication/index.tsx": [
		51344,
		9
	],
	"./pages/Legal": [
		3406,
		9,
		3406
	],
	"./pages/Legal/": [
		3406,
		9,
		3406
	],
	"./pages/Legal/index": [
		3406,
		9,
		3406
	],
	"./pages/Legal/index.tsx": [
		3406,
		9,
		3406
	],
	"./pages/MockAccount": [
		98284,
		9
	],
	"./pages/MockAccount/": [
		98284,
		9
	],
	"./pages/MockAccount/index": [
		98284,
		9
	],
	"./pages/MockAccount/index.tsx": [
		98284,
		9
	],
	"./pages/MockAccount/styles": [
		67377,
		9
	],
	"./pages/MockAccount/styles.ts": [
		67377,
		9
	],
	"./pages/Referrals": [
		22821,
		9,
		22821
	],
	"./pages/Referrals/": [
		22821,
		9,
		22821
	],
	"./pages/Referrals/index": [
		22821,
		9,
		22821
	],
	"./pages/Referrals/index.tsx": [
		22821,
		9,
		22821
	],
	"./pages/ResetPassword": [
		4341,
		9
	],
	"./pages/ResetPassword/": [
		4341,
		9
	],
	"./pages/ResetPassword/index": [
		4341,
		9
	],
	"./pages/ResetPassword/index.tsx": [
		4341,
		9
	],
	"./pages/Secure3D": [
		53397,
		9
	],
	"./pages/Secure3D/": [
		53397,
		9
	],
	"./pages/Secure3D/index": [
		53397,
		9
	],
	"./pages/Secure3D/index.tsx": [
		53397,
		9
	],
	"./pages/ServicePlans": [
		37654,
		9
	],
	"./pages/ServicePlans/": [
		37654,
		9
	],
	"./pages/ServicePlans/index": [
		37654,
		9
	],
	"./pages/ServicePlans/index.tsx": [
		37654,
		9
	],
	"./pages/Settings": [
		43560,
		9
	],
	"./pages/Settings/": [
		43560,
		9
	],
	"./pages/Settings/index": [
		43560,
		9
	],
	"./pages/Settings/index.tsx": [
		43560,
		9
	],
	"./pages/SignIn": [
		46697,
		9
	],
	"./pages/SignIn/": [
		46697,
		9
	],
	"./pages/SignIn/index": [
		46697,
		9
	],
	"./pages/SignIn/index.tsx": [
		46697,
		9
	],
	"./pages/SignUp/SignUp": [
		60177,
		9,
		60177
	],
	"./pages/SignUp/SignUp.tsx": [
		60177,
		9,
		60177
	],
	"./pages/Success": [
		92205,
		9
	],
	"./pages/Success/": [
		92205,
		9
	],
	"./pages/Success/index": [
		92205,
		9
	],
	"./pages/Success/index.tsx": [
		92205,
		9
	],
	"./pages/Success/styles": [
		78229,
		9
	],
	"./pages/Success/styles.ts": [
		78229,
		9
	],
	"./pages/Transactions": [
		75501,
		9
	],
	"./pages/Transactions/": [
		75501,
		9
	],
	"./pages/Transactions/index": [
		75501,
		9
	],
	"./pages/Transactions/index.tsx": [
		75501,
		9
	],
	"./pages/Verification": [
		78429,
		9,
		78429
	],
	"./pages/Verification/": [
		78429,
		9,
		78429
	],
	"./pages/Verification/index": [
		78429,
		9,
		78429
	],
	"./pages/Verification/index.tsx": [
		78429,
		9,
		78429
	],
	"./redux/2FA/2FA-actions": [
		72327,
		9
	],
	"./redux/2FA/2FA-actions.js": [
		72327,
		9
	],
	"./redux/2FA/2FA-reducer": [
		90975,
		9
	],
	"./redux/2FA/2FA-reducer.js": [
		90975,
		9
	],
	"./redux/2FA/2FA-sagas": [
		56916,
		9
	],
	"./redux/2FA/2FA-sagas.js": [
		56916,
		9
	],
	"./redux/2FA/2FA-select": [
		10217,
		9
	],
	"./redux/2FA/2FA-select.js": [
		10217,
		9
	],
	"./redux/2FA/2FA-types": [
		65986,
		9
	],
	"./redux/2FA/2FA-types.js": [
		65986,
		9
	],
	"./redux/acquiring/acquiring-actions": [
		32814,
		9
	],
	"./redux/acquiring/acquiring-actions.js": [
		32814,
		9
	],
	"./redux/acquiring/acquiring-reducer": [
		2102,
		9
	],
	"./redux/acquiring/acquiring-reducer.js": [
		2102,
		9
	],
	"./redux/acquiring/acquiring-sagas": [
		95790,
		9
	],
	"./redux/acquiring/acquiring-sagas.js": [
		95790,
		9
	],
	"./redux/acquiring/acquiring-select": [
		41770,
		9
	],
	"./redux/acquiring/acquiring-select.js": [
		41770,
		9
	],
	"./redux/acquiring/acquiring-types": [
		15232,
		9
	],
	"./redux/acquiring/acquiring-types.js": [
		15232,
		9
	],
	"./redux/addresses/addresses-actions": [
		96166,
		9
	],
	"./redux/addresses/addresses-actions.js": [
		96166,
		9
	],
	"./redux/addresses/addresses-reducer": [
		98024,
		9
	],
	"./redux/addresses/addresses-reducer.js": [
		98024,
		9
	],
	"./redux/addresses/addresses-sagas": [
		65258,
		9
	],
	"./redux/addresses/addresses-sagas.js": [
		65258,
		9
	],
	"./redux/addresses/addresses-select": [
		89101,
		9,
		89101
	],
	"./redux/addresses/addresses-select.js": [
		89101,
		9,
		89101
	],
	"./redux/addresses/addresses-types": [
		15321,
		9
	],
	"./redux/addresses/addresses-types.js": [
		15321,
		9
	],
	"./redux/alert/alert-actions": [
		12878,
		9
	],
	"./redux/alert/alert-actions.js": [
		12878,
		9
	],
	"./redux/alert/alert-reducer": [
		51501,
		9
	],
	"./redux/alert/alert-reducer.js": [
		51501,
		9
	],
	"./redux/alert/alert-sagas": [
		983,
		9
	],
	"./redux/alert/alert-sagas.js": [
		983,
		9
	],
	"./redux/alert/alert-select": [
		79264,
		9,
		79264
	],
	"./redux/alert/alert-select.js": [
		79264,
		9,
		79264
	],
	"./redux/alert/alert-types": [
		12288,
		9
	],
	"./redux/alert/alert-types.js": [
		12288,
		9
	],
	"./redux/allAssets/allAssets-actions": [
		90656,
		9
	],
	"./redux/allAssets/allAssets-actions.js": [
		90656,
		9
	],
	"./redux/allAssets/allAssets-reducer": [
		14093,
		9
	],
	"./redux/allAssets/allAssets-reducer.js": [
		14093,
		9
	],
	"./redux/allAssets/allAssets-sagas": [
		26399,
		9
	],
	"./redux/allAssets/allAssets-sagas.js": [
		26399,
		9
	],
	"./redux/allAssets/allAssets-select": [
		60485,
		9,
		60485
	],
	"./redux/allAssets/allAssets-select.js": [
		60485,
		9,
		60485
	],
	"./redux/allAssets/allAssets-types": [
		8617,
		9
	],
	"./redux/allAssets/allAssets-types.js": [
		8617,
		9
	],
	"./redux/api": [
		65859,
		9
	],
	"./redux/api.ts": [
		65859,
		9
	],
	"./redux/batchPayments/batchPayments-actions": [
		84749,
		9
	],
	"./redux/batchPayments/batchPayments-actions.js": [
		84749,
		9
	],
	"./redux/batchPayments/batchPayments-reducer": [
		22010,
		9
	],
	"./redux/batchPayments/batchPayments-reducer.js": [
		22010,
		9
	],
	"./redux/batchPayments/batchPayments-sagas": [
		23327,
		9
	],
	"./redux/batchPayments/batchPayments-sagas.js": [
		23327,
		9
	],
	"./redux/batchPayments/batchPayments-select": [
		46721,
		9,
		46721
	],
	"./redux/batchPayments/batchPayments-select.js": [
		46721,
		9,
		46721
	],
	"./redux/batchPayments/batchPayments-types": [
		82719,
		9
	],
	"./redux/batchPayments/batchPayments-types.js": [
		82719,
		9
	],
	"./redux/cards/api": [
		59316,
		9,
		59316
	],
	"./redux/cards/api.ts": [
		59316,
		9,
		59316
	],
	"./redux/cards/cards-actions": [
		34923,
		9
	],
	"./redux/cards/cards-actions.js": [
		34923,
		9
	],
	"./redux/cards/cards-reducer": [
		28149,
		9
	],
	"./redux/cards/cards-reducer.js": [
		28149,
		9
	],
	"./redux/cards/cards-sagas": [
		71144,
		9
	],
	"./redux/cards/cards-sagas.js": [
		71144,
		9
	],
	"./redux/cards/cards-select": [
		64577,
		9,
		64577
	],
	"./redux/cards/cards-select.js": [
		64577,
		9,
		64577
	],
	"./redux/cards/cards-types": [
		70889,
		9
	],
	"./redux/cards/cards-types.js": [
		70889,
		9
	],
	"./redux/common/common-actions": [
		25094,
		9
	],
	"./redux/common/common-actions.js": [
		25094,
		9
	],
	"./redux/common/common-reducer": [
		72835,
		9
	],
	"./redux/common/common-reducer.js": [
		72835,
		9
	],
	"./redux/common/common-sagas": [
		29963,
		9
	],
	"./redux/common/common-sagas.js": [
		29963,
		9
	],
	"./redux/common/common-select": [
		45012,
		9,
		45012
	],
	"./redux/common/common-select.js": [
		45012,
		9,
		45012
	],
	"./redux/common/common-types": [
		88723,
		9
	],
	"./redux/common/common-types.js": [
		88723,
		9
	],
	"./redux/currencies/currencies-actions": [
		81856,
		9
	],
	"./redux/currencies/currencies-actions.js": [
		81856,
		9
	],
	"./redux/currencies/currencies-reducer": [
		72754,
		9
	],
	"./redux/currencies/currencies-reducer.js": [
		72754,
		9
	],
	"./redux/currencies/currencies-sagas": [
		87013,
		9
	],
	"./redux/currencies/currencies-sagas.js": [
		87013,
		9
	],
	"./redux/currencies/currencies-select": [
		75842,
		9,
		75842
	],
	"./redux/currencies/currencies-select.js": [
		75842,
		9,
		75842
	],
	"./redux/currencies/currencies-state": [
		28806,
		9
	],
	"./redux/currencies/currencies-state.ts": [
		28806,
		9
	],
	"./redux/currencies/currencies-types": [
		34232,
		9
	],
	"./redux/currencies/currencies-types.js": [
		34232,
		9
	],
	"./redux/dashboard/dashboard-actions": [
		69002,
		9
	],
	"./redux/dashboard/dashboard-actions.js": [
		69002,
		9
	],
	"./redux/dashboard/dashboard-reducer": [
		86868,
		9
	],
	"./redux/dashboard/dashboard-reducer.js": [
		86868,
		9
	],
	"./redux/dashboard/dashboard-sagas": [
		79280,
		9
	],
	"./redux/dashboard/dashboard-sagas.js": [
		79280,
		9
	],
	"./redux/dashboard/dashboard-select": [
		78701,
		9,
		78701
	],
	"./redux/dashboard/dashboard-select.js": [
		78701,
		9,
		78701
	],
	"./redux/dashboard/dashboard-types": [
		9481,
		9
	],
	"./redux/dashboard/dashboard-types.js": [
		9481,
		9
	],
	"./redux/digitalAssets/digitalAssets-actions": [
		53014,
		9
	],
	"./redux/digitalAssets/digitalAssets-actions.js": [
		53014,
		9
	],
	"./redux/digitalAssets/digitalAssets-reducer": [
		62172,
		9
	],
	"./redux/digitalAssets/digitalAssets-reducer.js": [
		62172,
		9
	],
	"./redux/digitalAssets/digitalAssets-sagas": [
		37079,
		9
	],
	"./redux/digitalAssets/digitalAssets-sagas.js": [
		37079,
		9
	],
	"./redux/digitalAssets/digitalAssets-select": [
		27373,
		9,
		27373
	],
	"./redux/digitalAssets/digitalAssets-select.js": [
		27373,
		9,
		27373
	],
	"./redux/digitalAssets/digitalAssets-types": [
		44738,
		9
	],
	"./redux/digitalAssets/digitalAssets-types.js": [
		44738,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-actions": [
		35344,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-actions.js": [
		35344,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-reducer": [
		75659,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-reducer.js": [
		75659,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-sagas": [
		32215,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-sagas.js": [
		32215,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-select": [
		69777,
		9,
		69777
	],
	"./redux/favouritesDashboard/favouritesDashboard-select.js": [
		69777,
		9,
		69777
	],
	"./redux/favouritesDashboard/favouritesDashboard-types": [
		31359,
		9
	],
	"./redux/favouritesDashboard/favouritesDashboard-types.js": [
		31359,
		9
	],
	"./redux/googleAnalytics/googleAnalytics.interface": [
		82553,
		9,
		82553
	],
	"./redux/googleAnalytics/googleAnalytics.interface.ts": [
		82553,
		9,
		82553
	],
	"./redux/googleAnalytics/slice": [
		70124,
		9
	],
	"./redux/googleAnalytics/slice.ts": [
		70124,
		9
	],
	"./redux/hooks": [
		63153,
		9
	],
	"./redux/hooks.ts": [
		63153,
		9
	],
	"./redux/ledger/ledger-actions": [
		65615,
		9
	],
	"./redux/ledger/ledger-actions.js": [
		65615,
		9
	],
	"./redux/ledger/ledger-reducer": [
		30431,
		9
	],
	"./redux/ledger/ledger-reducer.ts": [
		30431,
		9
	],
	"./redux/ledger/ledger-sagas": [
		18193,
		9
	],
	"./redux/ledger/ledger-sagas.js": [
		18193,
		9
	],
	"./redux/ledger/ledger-select": [
		81610,
		9
	],
	"./redux/ledger/ledger-select.js": [
		81610,
		9
	],
	"./redux/ledger/ledger-types": [
		82971,
		9
	],
	"./redux/ledger/ledger-types.js": [
		82971,
		9
	],
	"./redux/limitedTokens/limitedTokens-actions": [
		17730,
		9
	],
	"./redux/limitedTokens/limitedTokens-actions.js": [
		17730,
		9
	],
	"./redux/limitedTokens/limitedTokens-reducer": [
		64051,
		9
	],
	"./redux/limitedTokens/limitedTokens-reducer.js": [
		64051,
		9
	],
	"./redux/limitedTokens/limitedTokens-sagas": [
		47115,
		9
	],
	"./redux/limitedTokens/limitedTokens-sagas.js": [
		47115,
		9
	],
	"./redux/limitedTokens/limitedTokens-select": [
		16857,
		9,
		16857
	],
	"./redux/limitedTokens/limitedTokens-select.js": [
		16857,
		9,
		16857
	],
	"./redux/limitedTokens/limitedTokens-types": [
		51113,
		9
	],
	"./redux/limitedTokens/limitedTokens-types.js": [
		51113,
		9
	],
	"./redux/referrals/referrals-actions": [
		73980,
		9
	],
	"./redux/referrals/referrals-actions.js": [
		73980,
		9
	],
	"./redux/referrals/referrals-reducer": [
		72505,
		9
	],
	"./redux/referrals/referrals-reducer.js": [
		72505,
		9
	],
	"./redux/referrals/referrals-sagas": [
		379,
		9
	],
	"./redux/referrals/referrals-sagas.js": [
		379,
		9
	],
	"./redux/referrals/referrals-select": [
		39686,
		9,
		39686
	],
	"./redux/referrals/referrals-select.js": [
		39686,
		9,
		39686
	],
	"./redux/referrals/referrals-types": [
		91385,
		9
	],
	"./redux/referrals/referrals-types.js": [
		91385,
		9
	],
	"./redux/rootReducer": [
		46283,
		9
	],
	"./redux/rootReducer.ts": [
		46283,
		9
	],
	"./redux/rootSaga": [
		79996,
		9
	],
	"./redux/rootSaga.ts": [
		79996,
		9
	],
	"./redux/settings/settings-actions": [
		46499,
		9
	],
	"./redux/settings/settings-actions.js": [
		46499,
		9
	],
	"./redux/settings/settings-reducer": [
		33667,
		9
	],
	"./redux/settings/settings-reducer.ts": [
		33667,
		9
	],
	"./redux/settings/settings-sagas": [
		93807,
		9
	],
	"./redux/settings/settings-sagas.js": [
		93807,
		9
	],
	"./redux/settings/settings-select": [
		72151,
		9
	],
	"./redux/settings/settings-select.js": [
		72151,
		9
	],
	"./redux/settings/settings-types": [
		60064,
		9
	],
	"./redux/settings/settings-types.js": [
		60064,
		9
	],
	"./redux/settings/types": [
		10595,
		9,
		10595
	],
	"./redux/settings/types.ts": [
		10595,
		9,
		10595
	],
	"./redux/signalR/signalR-actions": [
		88622,
		9
	],
	"./redux/signalR/signalR-actions.js": [
		88622,
		9
	],
	"./redux/signalR/signalR-connection": [
		14702,
		9
	],
	"./redux/signalR/signalR-connection.js": [
		14702,
		9
	],
	"./redux/signalR/signalR-reducer": [
		46102,
		9,
		46102
	],
	"./redux/signalR/signalR-reducer.js": [
		46102,
		9,
		46102
	],
	"./redux/signalR/signalR-sagas": [
		20463,
		9
	],
	"./redux/signalR/signalR-sagas.js": [
		20463,
		9
	],
	"./redux/signalR/signalR-select": [
		48155,
		9,
		48155
	],
	"./redux/signalR/signalR-select.js": [
		48155,
		9,
		48155
	],
	"./redux/signalR/signalR-types": [
		52861,
		9
	],
	"./redux/signalR/signalR-types.js": [
		52861,
		9
	],
	"./redux/store": [
		95027,
		9
	],
	"./redux/store.ts": [
		95027,
		9
	],
	"./redux/toast/toast-actions": [
		53295,
		9
	],
	"./redux/toast/toast-actions.js": [
		53295,
		9
	],
	"./redux/toast/toast-reducer": [
		49522,
		9
	],
	"./redux/toast/toast-reducer.js": [
		49522,
		9
	],
	"./redux/toast/toast-sagas": [
		93588,
		9
	],
	"./redux/toast/toast-sagas.js": [
		93588,
		9
	],
	"./redux/toast/toast-select": [
		54848,
		9,
		54848
	],
	"./redux/toast/toast-select.js": [
		54848,
		9,
		54848
	],
	"./redux/toast/toast-types": [
		19451,
		9
	],
	"./redux/toast/toast-types.js": [
		19451,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-actions": [
		81823,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-actions.js": [
		81823,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-reducer": [
		68730,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-reducer.js": [
		68730,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-sagas": [
		80174,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-sagas.js": [
		80174,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-select": [
		11029,
		9,
		11029
	],
	"./redux/tradingDeskV2/tradingDeskV2-select.js": [
		11029,
		9,
		11029
	],
	"./redux/tradingDeskV2/tradingDeskV2-types": [
		58075,
		9
	],
	"./redux/tradingDeskV2/tradingDeskV2-types.js": [
		58075,
		9
	],
	"./redux/transactions/transactions-actions": [
		59183,
		9
	],
	"./redux/transactions/transactions-actions.js": [
		59183,
		9
	],
	"./redux/transactions/transactions-reducer": [
		49506,
		9
	],
	"./redux/transactions/transactions-reducer.js": [
		49506,
		9
	],
	"./redux/transactions/transactions-sagas": [
		1935,
		9
	],
	"./redux/transactions/transactions-sagas.js": [
		1935,
		9
	],
	"./redux/transactions/transactions-select": [
		66109,
		9
	],
	"./redux/transactions/transactions-select.js": [
		66109,
		9
	],
	"./redux/transactions/transactions-types": [
		86445,
		9
	],
	"./redux/transactions/transactions-types.js": [
		86445,
		9
	],
	"./redux/user/api": [
		28988,
		9,
		28988
	],
	"./redux/user/api.ts": [
		28988,
		9,
		28988
	],
	"./redux/user/types": [
		65091,
		9,
		65091
	],
	"./redux/user/types.ts": [
		65091,
		9,
		65091
	],
	"./redux/user/user-actions": [
		28369,
		9
	],
	"./redux/user/user-actions.js": [
		28369,
		9
	],
	"./redux/user/user-reducer": [
		32060,
		9
	],
	"./redux/user/user-reducer.ts": [
		32060,
		9
	],
	"./redux/user/user-sagas": [
		94505,
		9
	],
	"./redux/user/user-sagas.js": [
		94505,
		9
	],
	"./redux/user/user-select": [
		45616,
		9
	],
	"./redux/user/user-select.js": [
		45616,
		9
	],
	"./redux/user/user-types": [
		37041,
		9
	],
	"./redux/user/user-types.js": [
		37041,
		9
	],
	"./redux/user/user.interface": [
		39706,
		9,
		39706
	],
	"./redux/user/user.interface.ts": [
		39706,
		9,
		39706
	],
	"./themes/": [
		96862,
		9
	],
	"./themes/Provider": [
		44289,
		9
	],
	"./themes/Provider.tsx": [
		44289,
		9
	],
	"./themes/base/App.css": [
		10865,
		9
	],
	"./themes/base/assets/images-offers/acquiring.png": [
		36014,
		1
	],
	"./themes/base/assets/images-offers/exception.png": [
		5746,
		1
	],
	"./themes/base/assets/images-offers/image1.png": [
		86411,
		1
	],
	"./themes/base/assets/images-offers/image2.png": [
		18885,
		1
	],
	"./themes/base/assets/images-offers/image3.png": [
		29094,
		1
	],
	"./themes/base/assets/images-offers/image4.png": [
		36282,
		1
	],
	"./themes/base/assets/images-offers/image6.png": [
		70823,
		1
	],
	"./themes/base/assets/images-offers/image7.png": [
		66686,
		1
	],
	"./themes/base/assets/images-offers/kyc.svg": [
		45686,
		1
	],
	"./themes/base/assets/images-offers/quickDeposit.png": [
		77833,
		1
	],
	"./themes/base/assets/images-offers/quickDepositMobile.png": [
		76242,
		1
	],
	"./themes/base/assets/images-offers/referralProgram.png": [
		69741,
		1
	],
	"./themes/base/assets/images-offers/services.png": [
		1758,
		1
	],
	"./themes/base/assets/images-offers/support.png": [
		62514,
		1
	],
	"./themes/base/assets/images-offers/welcome.png": [
		13815,
		1
	],
	"./themes/base/assets/images/2FAOval.svg": [
		22709,
		1
	],
	"./themes/base/assets/images/2faImg.svg": [
		90691,
		1
	],
	"./themes/base/assets/images/Cancelled.svg": [
		36074,
		1
	],
	"./themes/base/assets/images/CardActiveOvalWhite.svg": [
		17067,
		1
	],
	"./themes/base/assets/images/CardFrozenOvalWhite.svg": [
		17537,
		1
	],
	"./themes/base/assets/images/CardOvalGray.svg": [
		8520,
		1
	],
	"./themes/base/assets/images/CreditCards.svg": [
		91911,
		1
	],
	"./themes/base/assets/images/Failed.svg": [
		35699,
		1
	],
	"./themes/base/assets/images/Finnished.svg": [
		73615,
		1
	],
	"./themes/base/assets/images/PDF-preview.svg": [
		82328,
		1
	],
	"./themes/base/assets/images/Pending.svg": [
		24945,
		1
	],
	"./themes/base/assets/images/Processing.svg": [
		66768,
		1
	],
	"./themes/base/assets/images/Reverted.svg": [
		82167,
		1
	],
	"./themes/base/assets/images/TradingDesk.svg": [
		58679,
		1
	],
	"./themes/base/assets/images/aboutImgOne.png": [
		58631,
		1
	],
	"./themes/base/assets/images/aboutImgTwo.png": [
		23812,
		1
	],
	"./themes/base/assets/images/accountProfileMenu.svg": [
		22171,
		1
	],
	"./themes/base/assets/images/active-programme.svg": [
		68395,
		1
	],
	"./themes/base/assets/images/add-account.svg": [
		71888,
		1
	],
	"./themes/base/assets/images/addMoneyOval.svg": [
		8964,
		1
	],
	"./themes/base/assets/images/addPerson.svg": [
		28919,
		1
	],
	"./themes/base/assets/images/addedPerson.svg": [
		49362,
		1
	],
	"./themes/base/assets/images/address.svg": [
		41302,
		1
	],
	"./themes/base/assets/images/alert-error.svg": [
		37515,
		1
	],
	"./themes/base/assets/images/alert-info.svg": [
		76706,
		1
	],
	"./themes/base/assets/images/alert-warning-yellow.svg": [
		57989,
		1
	],
	"./themes/base/assets/images/alert-warning.svg": [
		69978,
		1
	],
	"./themes/base/assets/images/arrowDown.png": [
		83630,
		1
	],
	"./themes/base/assets/images/arrowKeyboardRight.svg": [
		37558,
		1
	],
	"./themes/base/assets/images/arrowLeft.svg": [
		63155,
		1
	],
	"./themes/base/assets/images/arrowUp.svg": [
		62880,
		1
	],
	"./themes/base/assets/images/attachFilesPlus.svg": [
		16389,
		1
	],
	"./themes/base/assets/images/availableCards/physicalBlack.png": [
		79522,
		1
	],
	"./themes/base/assets/images/availableCards/physicalGoldGTI.png": [
		67579,
		1
	],
	"./themes/base/assets/images/availableCards/physicalHills.png": [
		86018,
		1
	],
	"./themes/base/assets/images/availableCards/physicalPheonixBlack.png": [
		93071,
		1
	],
	"./themes/base/assets/images/availableCards/physicalPhoenixWhite.png": [
		43438,
		1
	],
	"./themes/base/assets/images/availableCards/physicalPlatinumGTI.png": [
		5701,
		1
	],
	"./themes/base/assets/images/availableCards/physicalStandardGTI.png": [
		99937,
		1
	],
	"./themes/base/assets/images/availableCards/virtualBlack.png": [
		54618,
		1
	],
	"./themes/base/assets/images/availableCards/virtualDefault.png": [
		63329,
		1
	],
	"./themes/base/assets/images/availableCards/virtualFoxpay.png": [
		19619,
		1
	],
	"./themes/base/assets/images/availableCards/virtualGTI.png": [
		39383,
		1
	],
	"./themes/base/assets/images/availableCards/virtualHills.png": [
		16712,
		1
	],
	"./themes/base/assets/images/availableCards/virtualPhoenix.png": [
		89128,
		1
	],
	"./themes/base/assets/images/bankAcc.svg": [
		60200,
		1
	],
	"./themes/base/assets/images/bankAccountOvalWhite.svg": [
		41088,
		1
	],
	"./themes/base/assets/images/bankAccountRoundDarkGrey.svg": [
		20472,
		1
	],
	"./themes/base/assets/images/bankAccountRoundGrey.svg": [
		1116,
		1
	],
	"./themes/base/assets/images/basketGrey.svg": [
		51229,
		1
	],
	"./themes/base/assets/images/blueArrowDown.svg": [
		45685,
		1
	],
	"./themes/base/assets/images/blueArrowUp.svg": [
		99637,
		1
	],
	"./themes/base/assets/images/business.svg": [
		52714,
		1
	],
	"./themes/base/assets/images/businessProfile.svg": [
		58800,
		1
	],
	"./themes/base/assets/images/buyAsstesOval.svg": [
		327,
		1
	],
	"./themes/base/assets/images/buyCardOval.svg": [
		61257,
		1
	],
	"./themes/base/assets/images/calendar.svg": [
		64589,
		1
	],
	"./themes/base/assets/images/card.svg": [
		11010,
		1
	],
	"./themes/base/assets/images/cardBackCVC.svg": [
		83266,
		1
	],
	"./themes/base/assets/images/cardDeactivate.svg": [
		36882,
		1
	],
	"./themes/base/assets/images/cardFreeze.svg": [
		58473,
		1
	],
	"./themes/base/assets/images/cardHideDetails.svg": [
		79295,
		1
	],
	"./themes/base/assets/images/cardHidePin.svg": [
		32386,
		1
	],
	"./themes/base/assets/images/cardShowDetails.svg": [
		23757,
		1
	],
	"./themes/base/assets/images/cardShowPin.svg": [
		67990,
		1
	],
	"./themes/base/assets/images/cardUnfreeze.svg": [
		91088,
		1
	],
	"./themes/base/assets/images/check.svg": [
		38698,
		1
	],
	"./themes/base/assets/images/check_circle.svg": [
		8755,
		1
	],
	"./themes/base/assets/images/checked-grey-circle.svg": [
		28271,
		1
	],
	"./themes/base/assets/images/checked-grey-hover.svg": [
		96715,
		1
	],
	"./themes/base/assets/images/checked-grey.svg": [
		64856,
		1
	],
	"./themes/base/assets/images/close.svg": [
		79022,
		1
	],
	"./themes/base/assets/images/closeButton.svg": [
		30146,
		1
	],
	"./themes/base/assets/images/commentCloud.svg": [
		76889,
		1
	],
	"./themes/base/assets/images/confirmAddress.svg": [
		51661,
		1
	],
	"./themes/base/assets/images/contact.png": [
		13038,
		1
	],
	"./themes/base/assets/images/contactImgOne.png": [
		32613,
		1
	],
	"./themes/base/assets/images/copy-icon.svg": [
		49606,
		1
	],
	"./themes/base/assets/images/credit-card-dark-grey.svg": [
		55634,
		1
	],
	"./themes/base/assets/images/dashboardLinkIcon.svg": [
		27950,
		1
	],
	"./themes/base/assets/images/deactive.svg": [
		30683,
		1
	],
	"./themes/base/assets/images/deviceBrowser.svg": [
		8453,
		1
	],
	"./themes/base/assets/images/deviceCardsApp.svg": [
		91733,
		1
	],
	"./themes/base/assets/images/deviceMobileApp.svg": [
		1666,
		1
	],
	"./themes/base/assets/images/document-upload-thumb.svg": [
		24950,
		1
	],
	"./themes/base/assets/images/document.svg": [
		11402,
		1
	],
	"./themes/base/assets/images/documents.svg": [
		71117,
		1
	],
	"./themes/base/assets/images/downloadFileIcon.svg": [
		88118,
		1
	],
	"./themes/base/assets/images/downloadOval.svg": [
		72116,
		1
	],
	"./themes/base/assets/images/dragndropmark.svg": [
		35069,
		1
	],
	"./themes/base/assets/images/dropZoneUpload.svg": [
		45711,
		1
	],
	"./themes/base/assets/images/edit.svg": [
		17285,
		1
	],
	"./themes/base/assets/images/email-confirm.png": [
		30235,
		1
	],
	"./themes/base/assets/images/email2fa.svg": [
		66497,
		1
	],
	"./themes/base/assets/images/error-circle.svg": [
		93151,
		1
	],
	"./themes/base/assets/images/errors/403.png": [
		65055,
		1
	],
	"./themes/base/assets/images/errors/404.png": [
		76348,
		1
	],
	"./themes/base/assets/images/errors/503.png": [
		35640,
		1
	],
	"./themes/base/assets/images/errors/serverError.svg": [
		4391,
		1
	],
	"./themes/base/assets/images/errors/serverOffline.svg": [
		11866,
		1
	],
	"./themes/base/assets/images/exchangeOval.svg": [
		70433,
		1
	],
	"./themes/base/assets/images/failure-circle.svg": [
		30472,
		1
	],
	"./themes/base/assets/images/favourite.svg": [
		55835,
		1
	],
	"./themes/base/assets/images/favouriteBordered.svg": [
		98216,
		1
	],
	"./themes/base/assets/images/file-icon-oval.svg": [
		59558,
		1
	],
	"./themes/base/assets/images/floatingCard.svg": [
		68597,
		1
	],
	"./themes/base/assets/images/foxPayCheck.svg": [
		87467,
		1
	],
	"./themes/base/assets/images/freeze.svg": [
		23142,
		1
	],
	"./themes/base/assets/images/generic.svg": [
		90508,
		1
	],
	"./themes/base/assets/images/google-authenticator.svg": [
		93057,
		1
	],
	"./themes/base/assets/images/hammer.svg": [
		57775,
		1
	],
	"./themes/base/assets/images/hide-pin.svg": [
		58665,
		1
	],
	"./themes/base/assets/images/inactive-programme.svg": [
		41934,
		1
	],
	"./themes/base/assets/images/lang/ar.svg": [
		56936,
		1
	],
	"./themes/base/assets/images/lang/cn.svg": [
		1679,
		1
	],
	"./themes/base/assets/images/lang/de.svg": [
		41710,
		1
	],
	"./themes/base/assets/images/lang/en.svg": [
		88944,
		1
	],
	"./themes/base/assets/images/lang/es.svg": [
		3587,
		1
	],
	"./themes/base/assets/images/lang/fr.svg": [
		39907,
		1
	],
	"./themes/base/assets/images/lang/in.svg": [
		62819,
		1
	],
	"./themes/base/assets/images/lang/it.svg": [
		88753,
		1
	],
	"./themes/base/assets/images/lang/lt.svg": [
		22255,
		1
	],
	"./themes/base/assets/images/lang/ru.svg": [
		48043,
		1
	],
	"./themes/base/assets/images/lang/tr.svg": [
		49331,
		1
	],
	"./themes/base/assets/images/ledgers/adaOval.svg": [
		52961,
		1
	],
	"./themes/base/assets/images/ledgers/aedOval.svg": [
		31065,
		1
	],
	"./themes/base/assets/images/ledgers/air777Oval.svg": [
		7796,
		1
	],
	"./themes/base/assets/images/ledgers/atriOval.svg": [
		84998,
		1
	],
	"./themes/base/assets/images/ledgers/btcIcon.svg": [
		47442,
		1
	],
	"./themes/base/assets/images/ledgers/btcOval.svg": [
		34916,
		1
	],
	"./themes/base/assets/images/ledgers/chfOval.svg": [
		32180,
		1
	],
	"./themes/base/assets/images/ledgers/cruOval.svg": [
		76491,
		1
	],
	"./themes/base/assets/images/ledgers/dogeOval.svg": [
		70064,
		1
	],
	"./themes/base/assets/images/ledgers/dwrldOval.svg": [
		45205,
		1
	],
	"./themes/base/assets/images/ledgers/eosOval.svg": [
		55023,
		1
	],
	"./themes/base/assets/images/ledgers/ethOval.svg": [
		89080,
		1
	],
	"./themes/base/assets/images/ledgers/eurOval.svg": [
		98092,
		1
	],
	"./themes/base/assets/images/ledgers/ftmOval.svg": [
		35252,
		1
	],
	"./themes/base/assets/images/ledgers/gbpOval.svg": [
		98246,
		1
	],
	"./themes/base/assets/images/ledgers/gxagOval.svg": [
		14807,
		1
	],
	"./themes/base/assets/images/ledgers/lif3Oval.svg": [
		65332,
		1
	],
	"./themes/base/assets/images/ledgers/mt760Oval.svg": [
		62412,
		1
	],
	"./themes/base/assets/images/ledgers/mt777Oval.svg": [
		97408,
		1
	],
	"./themes/base/assets/images/ledgers/paugOval.svg": [
		27072,
		1
	],
	"./themes/base/assets/images/ledgers/pauxOval.svg": [
		37839,
		1
	],
	"./themes/base/assets/images/ledgers/rlxOval.svg": [
		4647,
		1
	],
	"./themes/base/assets/images/ledgers/sgdOval.svg": [
		92078,
		1
	],
	"./themes/base/assets/images/ledgers/shibOval.svg": [
		71892,
		1
	],
	"./themes/base/assets/images/ledgers/solOval.svg": [
		84254,
		1
	],
	"./themes/base/assets/images/ledgers/trxOval.svg": [
		56118,
		1
	],
	"./themes/base/assets/images/ledgers/untbOval.svg": [
		67993,
		1
	],
	"./themes/base/assets/images/ledgers/usdOval.svg": [
		55215,
		1
	],
	"./themes/base/assets/images/ledgers/usdcOval.svg": [
		83799,
		1
	],
	"./themes/base/assets/images/ledgers/usdtOval.svg": [
		31759,
		1
	],
	"./themes/base/assets/images/ledgers/usduOval.svg": [
		7106,
		1
	],
	"./themes/base/assets/images/ledgers/vetOval.svg": [
		8346,
		1
	],
	"./themes/base/assets/images/ledgers/wbtcOval.svg": [
		68705,
		1
	],
	"./themes/base/assets/images/ledgers/wcruOval.svg": [
		3510,
		1
	],
	"./themes/base/assets/images/ledgers/xagOval.svg": [
		40594,
		1
	],
	"./themes/base/assets/images/ledgers/xauOval.svg": [
		66805,
		1
	],
	"./themes/base/assets/images/ledgers/xptOval.svg": [
		97959,
		1
	],
	"./themes/base/assets/images/ledgers/xrpOval.svg": [
		19949,
		1
	],
	"./themes/base/assets/images/limitedTokensServices.svg": [
		59283,
		1
	],
	"./themes/base/assets/images/linkingAccount.png": [
		88500,
		1
	],
	"./themes/base/assets/images/logout.svg": [
		83412,
		1
	],
	"./themes/base/assets/images/mastercardLogo.svg": [
		27821,
		1
	],
	"./themes/base/assets/images/metalServices.svg": [
		55569,
		1
	],
	"./themes/base/assets/images/metals.svg": [
		77319,
		1
	],
	"./themes/base/assets/images/navBar.svg": [
		23224,
		1
	],
	"./themes/base/assets/images/note.svg": [
		21185,
		1
	],
	"./themes/base/assets/images/otherServices.svg": [
		42007,
		1
	],
	"./themes/base/assets/images/package.svg": [
		75778,
		1
	],
	"./themes/base/assets/images/pencil.svg": [
		29236,
		1
	],
	"./themes/base/assets/images/personalProfile.svg": [
		46545,
		1
	],
	"./themes/base/assets/images/phone2Fa.svg": [
		82760,
		1
	],
	"./themes/base/assets/images/physicalcardOval.svg": [
		10430,
		1
	],
	"./themes/base/assets/images/pin-code.svg": [
		13760,
		1
	],
	"./themes/base/assets/images/plus-active.svg": [
		23683,
		1
	],
	"./themes/base/assets/images/plus-dark-grey.svg": [
		70508,
		1
	],
	"./themes/base/assets/images/plus-grey.svg": [
		62154,
		1
	],
	"./themes/base/assets/images/plus-white.svg": [
		43530,
		1
	],
	"./themes/base/assets/images/priceTag.svg": [
		23587,
		1
	],
	"./themes/base/assets/images/printOval.svg": [
		33989,
		1
	],
	"./themes/base/assets/images/profile-circle-active.svg": [
		60467,
		1
	],
	"./themes/base/assets/images/profile-oval-dark-grey.svg": [
		81660,
		1
	],
	"./themes/base/assets/images/profile-oval.svg": [
		26417,
		1
	],
	"./themes/base/assets/images/profile.svg": [
		39010,
		1
	],
	"./themes/base/assets/images/referral/1.svg": [
		28159,
		1
	],
	"./themes/base/assets/images/referral/2.svg": [
		67879,
		1
	],
	"./themes/base/assets/images/referral/3.svg": [
		59664,
		1
	],
	"./themes/base/assets/images/referral/facebook.svg": [
		9228,
		1
	],
	"./themes/base/assets/images/referral/finish.svg": [
		5137,
		1
	],
	"./themes/base/assets/images/referral/linkedin.svg": [
		55387,
		1
	],
	"./themes/base/assets/images/referral/success.svg": [
		73767,
		1
	],
	"./themes/base/assets/images/referral/twitter.svg": [
		61858,
		1
	],
	"./themes/base/assets/images/referral/whatsapp.svg": [
		40402,
		1
	],
	"./themes/base/assets/images/referralsIcon.svg": [
		96030,
		1
	],
	"./themes/base/assets/images/refresh.svg": [
		77221,
		1
	],
	"./themes/base/assets/images/refreshGrey.svg": [
		24255,
		1
	],
	"./themes/base/assets/images/refund.svg": [
		14487,
		1
	],
	"./themes/base/assets/images/security-warn-fab.svg": [
		56278,
		1
	],
	"./themes/base/assets/images/selectDropDownArrow.svg": [
		39692,
		1
	],
	"./themes/base/assets/images/sellOval.svg": [
		84913,
		1
	],
	"./themes/base/assets/images/sepaOval.svg": [
		9953,
		1
	],
	"./themes/base/assets/images/servicePlans/cards.svg": [
		91977,
		1
	],
	"./themes/base/assets/images/servicePlans/crypto.svg": [
		8901,
		1
	],
	"./themes/base/assets/images/servicePlans/ibans.svg": [
		65237,
		1
	],
	"./themes/base/assets/images/servicePlans/metals.svg": [
		23202,
		1
	],
	"./themes/base/assets/images/servicePlans/plan_bg.png": [
		54857,
		1
	],
	"./themes/base/assets/images/servicePlans/stocks.svg": [
		3063,
		1
	],
	"./themes/base/assets/images/settingsLinkIcon.svg": [
		61309,
		1
	],
	"./themes/base/assets/images/shipping.svg": [
		74092,
		1
	],
	"./themes/base/assets/images/sourceOfFunds.svg": [
		91690,
		1
	],
	"./themes/base/assets/images/success-circle-gray.svg": [
		2169,
		1
	],
	"./themes/base/assets/images/success-circle.svg": [
		34108,
		1
	],
	"./themes/base/assets/images/successBig.svg": [
		98806,
		1
	],
	"./themes/base/assets/images/support.svg": [
		5098,
		1
	],
	"./themes/base/assets/images/supportIconOvalWhite.svg": [
		89751,
		1
	],
	"./themes/base/assets/images/swiftOval.svg": [
		24260,
		1
	],
	"./themes/base/assets/images/switchAccount.svg": [
		43197,
		1
	],
	"./themes/base/assets/images/tooltip-info.svg": [
		12697,
		1
	],
	"./themes/base/assets/images/trading-desk-logo.svg": [
		96788,
		1
	],
	"./themes/base/assets/images/transactionsLinkIcon.svg": [
		34527,
		1
	],
	"./themes/base/assets/images/transfer.svg": [
		32288,
		1
	],
	"./themes/base/assets/images/transferOval.svg": [
		83948,
		1
	],
	"./themes/base/assets/images/truck-circle.svg": [
		29765,
		1
	],
	"./themes/base/assets/images/truck.svg": [
		93525,
		1
	],
	"./themes/base/assets/images/ukLocalOval.svg": [
		50280,
		1
	],
	"./themes/base/assets/images/unfreeze.svg": [
		37363,
		1
	],
	"./themes/base/assets/images/upload-documents.svg": [
		38746,
		1
	],
	"./themes/base/assets/images/virtualcardOval.svg": [
		59884,
		1
	],
	"./themes/base/assets/images/visaLogo.svg": [
		87772,
		1
	],
	"./themes/base/assets/images/visibility-off.svg": [
		5902,
		1
	],
	"./themes/base/assets/images/visibility-on.svg": [
		32334,
		1
	],
	"./themes/base/assets/images/waiting.svg": [
		76993,
		1
	],
	"./themes/base/assets/images/warning-triangle.svg": [
		35336,
		1
	],
	"./themes/base/assets/images/warningCloud.svg": [
		39913,
		1
	],
	"./themes/base/assets/images/x.svg": [
		33420,
		1
	],
	"./themes/base/assets/images/x_hover.svg": [
		86954,
		1
	],
	"./themes/base/assets/images/x_red.svg": [
		40478,
		1
	],
	"./themes/base/global-styles": [
		81272,
		9
	],
	"./themes/base/global-styles.jsx": [
		81272,
		9
	],
	"./themes/base/locale/ar/forms": [
		87853,
		3
	],
	"./themes/base/locale/ar/forms.json": [
		87853,
		3
	],
	"./themes/base/locale/ar/keys": [
		27062,
		3
	],
	"./themes/base/locale/ar/keys.json": [
		27062,
		3
	],
	"./themes/base/locale/ar/legal": [
		23973,
		3
	],
	"./themes/base/locale/ar/legal.json": [
		23973,
		3
	],
	"./themes/base/locale/ar/translations": [
		5838,
		3
	],
	"./themes/base/locale/ar/translations.json": [
		5838,
		3
	],
	"./themes/base/locale/de/forms": [
		94285,
		3
	],
	"./themes/base/locale/de/forms.json": [
		94285,
		3
	],
	"./themes/base/locale/de/keys": [
		13657,
		3
	],
	"./themes/base/locale/de/keys.json": [
		13657,
		3
	],
	"./themes/base/locale/de/legal": [
		57273,
		3
	],
	"./themes/base/locale/de/legal.json": [
		57273,
		3
	],
	"./themes/base/locale/de/translations": [
		73113,
		3
	],
	"./themes/base/locale/de/translations.json": [
		73113,
		3
	],
	"./themes/base/locale/en/forms": [
		70235,
		3
	],
	"./themes/base/locale/en/forms.json": [
		70235,
		3
	],
	"./themes/base/locale/en/keys": [
		53502,
		3
	],
	"./themes/base/locale/en/keys.json": [
		53502,
		3
	],
	"./themes/base/locale/en/legal": [
		36350,
		3
	],
	"./themes/base/locale/en/legal.json": [
		36350,
		3
	],
	"./themes/base/locale/en/translations": [
		52760,
		3
	],
	"./themes/base/locale/en/translations.json": [
		52760,
		3
	],
	"./themes/base/locale/es/forms": [
		76064,
		3
	],
	"./themes/base/locale/es/forms.json": [
		76064,
		3
	],
	"./themes/base/locale/es/keys": [
		79128,
		3
	],
	"./themes/base/locale/es/keys.json": [
		79128,
		3
	],
	"./themes/base/locale/es/legal": [
		53956,
		3
	],
	"./themes/base/locale/es/legal.json": [
		53956,
		3
	],
	"./themes/base/locale/es/translations": [
		71941,
		3
	],
	"./themes/base/locale/es/translations.json": [
		71941,
		3
	],
	"./themes/base/locale/fr/forms": [
		27110,
		3
	],
	"./themes/base/locale/fr/forms.json": [
		27110,
		3
	],
	"./themes/base/locale/fr/keys": [
		42061,
		3
	],
	"./themes/base/locale/fr/keys.json": [
		42061,
		3
	],
	"./themes/base/locale/fr/legal": [
		74073,
		3
	],
	"./themes/base/locale/fr/legal.json": [
		74073,
		3
	],
	"./themes/base/locale/fr/translations": [
		70000,
		3
	],
	"./themes/base/locale/fr/translations.json": [
		70000,
		3
	],
	"./themes/base/locale/it/forms": [
		33839,
		3
	],
	"./themes/base/locale/it/forms.json": [
		33839,
		3
	],
	"./themes/base/locale/it/keys": [
		81683,
		3
	],
	"./themes/base/locale/it/keys.json": [
		81683,
		3
	],
	"./themes/base/locale/it/legal": [
		30205,
		3
	],
	"./themes/base/locale/it/legal.json": [
		30205,
		3
	],
	"./themes/base/locale/it/translations": [
		69883,
		3
	],
	"./themes/base/locale/it/translations.json": [
		69883,
		3
	],
	"./themes/base/locale/lt/forms": [
		10462,
		3
	],
	"./themes/base/locale/lt/forms.json": [
		10462,
		3
	],
	"./themes/base/locale/lt/keys": [
		13448,
		3
	],
	"./themes/base/locale/lt/keys.json": [
		13448,
		3
	],
	"./themes/base/locale/lt/legal": [
		92630,
		3
	],
	"./themes/base/locale/lt/legal.json": [
		92630,
		3
	],
	"./themes/base/locale/lt/translations": [
		97991,
		3
	],
	"./themes/base/locale/lt/translations.json": [
		97991,
		3
	],
	"./themes/base/locale/ru/forms": [
		7419,
		3
	],
	"./themes/base/locale/ru/forms.json": [
		7419,
		3
	],
	"./themes/base/locale/ru/keys": [
		59241,
		3
	],
	"./themes/base/locale/ru/keys.json": [
		59241,
		3
	],
	"./themes/base/locale/ru/legal": [
		39130,
		3
	],
	"./themes/base/locale/ru/legal.json": [
		39130,
		3
	],
	"./themes/base/locale/ru/translations": [
		52565,
		3
	],
	"./themes/base/locale/ru/translations.json": [
		52565,
		3
	],
	"./themes/base/locale/tr/forms": [
		421,
		3
	],
	"./themes/base/locale/tr/forms.json": [
		421,
		3
	],
	"./themes/base/locale/tr/keys": [
		48111,
		3
	],
	"./themes/base/locale/tr/keys.json": [
		48111,
		3
	],
	"./themes/base/locale/tr/legal": [
		75133,
		3
	],
	"./themes/base/locale/tr/legal.json": [
		75133,
		3
	],
	"./themes/base/locale/tr/translations": [
		59141,
		3
	],
	"./themes/base/locale/tr/translations.json": [
		59141,
		3
	],
	"./themes/base/locale/ur/forms": [
		6779,
		3
	],
	"./themes/base/locale/ur/forms.json": [
		6779,
		3
	],
	"./themes/base/locale/ur/keys.JSON": [
		10720,
		1
	],
	"./themes/base/locale/ur/legal": [
		41571,
		3
	],
	"./themes/base/locale/ur/legal.json": [
		41571,
		3
	],
	"./themes/base/locale/ur/translations": [
		21839,
		3
	],
	"./themes/base/locale/ur/translations.json": [
		21839,
		3
	],
	"./themes/base/locale/zh/forms": [
		25015,
		3
	],
	"./themes/base/locale/zh/forms.json": [
		25015,
		3
	],
	"./themes/base/locale/zh/keys": [
		31630,
		3
	],
	"./themes/base/locale/zh/keys.json": [
		31630,
		3
	],
	"./themes/base/locale/zh/legal": [
		97447,
		3
	],
	"./themes/base/locale/zh/legal.json": [
		97447,
		3
	],
	"./themes/base/locale/zh/translations": [
		50736,
		3
	],
	"./themes/base/locale/zh/translations.json": [
		50736,
		3
	],
	"./themes/base/styles": [
		60213,
		9
	],
	"./themes/base/styles.js": [
		60213,
		9
	],
	"./themes/base/useTheme": [
		13980,
		9
	],
	"./themes/base/useTheme.jsx": [
		13980,
		9
	],
	"./themes/cards": [
		60530,
		9
	],
	"./themes/cards.js": [
		60530,
		9
	],
	"./themes/constants": [
		57912,
		9
	],
	"./themes/constants.ts": [
		57912,
		9
	],
	"./themes/development/assets/images/logo.svg": [
		59448,
		1
	],
	"./themes/development/assets/landing/images/bg.jpg": [
		73628,
		1
	],
	"./themes/development/assets/landing/images/bg_mobile.jpg": [
		13502,
		1
	],
	"./themes/development/assets/landing/images/logo.svg": [
		97929,
		1
	],
	"./themes/development/assets/landing/images/logo_mobile.svg": [
		43264,
		1
	],
	"./themes/development/styles": [
		56077,
		9
	],
	"./themes/development/styles.js": [
		56077,
		9
	],
	"./themes/development/theme": [
		85472,
		9
	],
	"./themes/development/theme.js": [
		85472,
		9
	],
	"./themes/development/uploads/Company_Application_Form.pdf": [
		6389,
		1
	],
	"./themes/development/uploads/Corporate_Packages.pdf": [
		98623,
		1
	],
	"./themes/development/uploads/Individual_Application_Form.pdf": [
		77169,
		1
	],
	"./themes/development/uploads/KYC_Ownership_Structure.pdf": [
		54755,
		1
	],
	"./themes/development/uploads/KYC_UBO_Form.pdf": [
		46256,
		1
	],
	"./themes/development/uploads/Source_Of_Funds_Form.pdf": [
		78863,
		1
	],
	"./themes/development/uploads/UserRolesAndPermissions.pdf": [
		82348,
		1
	],
	"./themes/development/useTheme": [
		97389,
		9
	],
	"./themes/development/useTheme.jsx": [
		97389,
		9
	],
	"./themes/index": [
		96862,
		9
	],
	"./themes/index.js": [
		96862,
		9
	],
	"./themes/swisstech/assets/images/logo.svg": [
		12720,
		1
	],
	"./themes/swisstech/assets/landing/images/bg.jpg": [
		70894,
		1
	],
	"./themes/swisstech/assets/landing/images/bg_mobile.jpg": [
		3114,
		1
	],
	"./themes/swisstech/assets/landing/images/logo.svg": [
		54955,
		1
	],
	"./themes/swisstech/assets/landing/images/logo_mobile.svg": [
		97545,
		1
	],
	"./themes/swisstech/locale/en/override": [
		57094,
		3
	],
	"./themes/swisstech/locale/en/override.json": [
		57094,
		3
	],
	"./themes/swisstech/styles": [
		42127,
		9
	],
	"./themes/swisstech/styles.js": [
		42127,
		9
	],
	"./themes/swisstech/theme": [
		57642,
		9
	],
	"./themes/swisstech/theme.js": [
		57642,
		9
	],
	"./themes/swisstech/uploads/Company_Application_Form.pdf": [
		14071,
		1
	],
	"./themes/swisstech/uploads/Corporate_Packages.pdf": [
		46169,
		1
	],
	"./themes/swisstech/uploads/Individual_Application_Form.pdf": [
		38254,
		1
	],
	"./themes/swisstech/uploads/KYC_Ownership_Structure.pdf": [
		6281,
		1
	],
	"./themes/swisstech/uploads/KYC_UBO_Form.pdf": [
		38918,
		1
	],
	"./themes/swisstech/uploads/Source_Of_Funds_Form.pdf": [
		17512,
		1
	],
	"./themes/swisstech/uploads/UserRolesAndPermissions.pdf": [
		28257,
		1
	],
	"./themes/swisstech/useTheme": [
		58714,
		9
	],
	"./themes/swisstech/useTheme.jsx": [
		58714,
		9
	],
	"./themes/themes.type": [
		86392,
		9
	],
	"./themes/themes.type.ts": [
		86392,
		9
	],
	"./themes/types": [
		53964,
		9
	],
	"./themes/types.ts": [
		53964,
		9
	],
	"./types/Account.d": [
		23886,
		7,
		23886
	],
	"./types/Account.d.ts": [
		23886,
		7,
		23886
	],
	"./types/Acquiring-types.d": [
		55697,
		7,
		55697
	],
	"./types/Acquiring-types.d.ts": [
		55697,
		7,
		55697
	],
	"./types/BatchPayments.d": [
		33633,
		7,
		33633
	],
	"./types/BatchPayments.d.ts": [
		33633,
		7,
		33633
	],
	"./types/Cards.d": [
		44084,
		7,
		44084
	],
	"./types/Cards.d.ts": [
		44084,
		7,
		44084
	],
	"./types/Currencies.d": [
		46260,
		7,
		46260
	],
	"./types/Currencies.d.ts": [
		46260,
		7,
		46260
	],
	"./types/DigitalAssets.d": [
		23531,
		7,
		23531
	],
	"./types/DigitalAssets.d.ts": [
		23531,
		7,
		23531
	],
	"./types/DigitalAssetsUsdc.d": [
		43391,
		7,
		43391
	],
	"./types/DigitalAssetsUsdc.d.ts": [
		43391,
		7,
		43391
	],
	"./types/Fees.d": [
		33087,
		7,
		33087
	],
	"./types/Fees.d.ts": [
		33087,
		7,
		33087
	],
	"./types/Settings.d": [
		66035,
		7,
		66035
	],
	"./types/Settings.d.ts": [
		66035,
		7,
		66035
	],
	"./types/Wallets.d": [
		325,
		7,
		325
	],
	"./types/Wallets.d.ts": [
		325,
		7,
		325
	],
	"./types/common.d": [
		28865,
		7,
		28865
	],
	"./types/common.d.ts": [
		28865,
		7,
		28865
	],
	"./types/createTheme.d": [
		24087,
		9,
		24087
	],
	"./types/createTheme.d.ts": [
		24087,
		9,
		24087
	],
	"./types/styled.d": [
		59525,
		9,
		59525
	],
	"./types/styled.d.ts": [
		59525,
		9,
		59525
	],
	"./utils/accessHelpers": [
		81801,
		9
	],
	"./utils/accessHelpers.ts": [
		81801,
		9
	],
	"./utils/combineStyles": [
		27826,
		9
	],
	"./utils/combineStyles.js": [
		27826,
		9
	],
	"./utils/common": [
		93859,
		9
	],
	"./utils/common.ts": [
		93859,
		9
	],
	"./utils/digitalAssetsHelpers": [
		17934,
		9,
		17934
	],
	"./utils/digitalAssetsHelpers.js": [
		17934,
		9,
		17934
	],
	"./utils/files": [
		7972,
		9
	],
	"./utils/files.ts": [
		7972,
		9
	],
	"./utils/helperConfig": [
		6375,
		7
	],
	"./utils/helperConfig.js": [
		6375,
		7
	],
	"./utils/helperDateFormater": [
		57899,
		9,
		57899
	],
	"./utils/helperDateFormater.js": [
		57899,
		9,
		57899
	],
	"./utils/helperDownloadBlob": [
		94298,
		9,
		94298
	],
	"./utils/helperDownloadBlob.js": [
		94298,
		9,
		94298
	],
	"./utils/helperGuid": [
		54074,
		9,
		54074
	],
	"./utils/helperGuid.js": [
		54074,
		9,
		54074
	],
	"./utils/helperLocalStorage": [
		37077,
		9
	],
	"./utils/helperLocalStorage.js": [
		37077,
		9
	],
	"./utils/helperNumbersFormating": [
		79894,
		9
	],
	"./utils/helperNumbersFormating.js": [
		79894,
		9
	],
	"./utils/helpers": [
		81238,
		9
	],
	"./utils/helpers.ts": [
		81238,
		9
	],
	"./utils/imagesPreload": [
		96249,
		9
	],
	"./utils/imagesPreload.js": [
		96249,
		9
	],
	"./utils/mockAssetGeneratorHelper": [
		45259,
		9
	],
	"./utils/mockAssetGeneratorHelper.ts": [
		45259,
		9
	],
	"./utils/payslipsHelpers": [
		17040,
		9,
		17040
	],
	"./utils/payslipsHelpers.js": [
		17040,
		9,
		17040
	],
	"./utils/phoneVerificationHelpers": [
		42045,
		9,
		42045
	],
	"./utils/phoneVerificationHelpers.js": [
		42045,
		9,
		42045
	],
	"./utils/regex": [
		35961,
		9,
		35961
	],
	"./utils/regex.ts": [
		35961,
		9,
		35961
	],
	"./utils/stringHelpers": [
		53070,
		9
	],
	"./utils/stringHelpers.ts": [
		53070,
		9
	],
	"./utils/transferHelpers": [
		38757,
		9,
		38757
	],
	"./utils/transferHelpers.js": [
		38757,
		9,
		38757
	],
	"./utils/translationsHelpers": [
		51940,
		9,
		51940
	],
	"./utils/translationsHelpers.tsx": [
		51940,
		9,
		51940
	],
	"./utils/validationHelpers": [
		67176,
		9,
		67176
	],
	"./utils/validationHelpers.js": [
		67176,
		9,
		67176
	],
	"./utils/wallet": [
		71109,
		9,
		71109
	],
	"./utils/wallet.ts": [
		71109,
		9,
		71109
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1393;
module.exports = webpackAsyncContext;